const globalVar = {
  install: function (Vue, options) {
    const main = new Vue({
      data: function () {
        return {
          targetJobChangeIds: [
            "rirekisho_job_change",
            "rirekisho_ai_career",
            "rirekisho_job_change2",
            "rirekisho_job_change_old",
            "rirekisho_single",
            "rirekisho_nophoto_double",
            "rirekisho_nophoto",
            "rirekisho_hukugyo"],
          qmailRirekishoHtml: '',
          deviceToken: '',
          dn_flag: 'dn',
          isYagiPrime: false,
          isYagiPrimeCancel: false,
          isYagiPrimeQuickmailcount: 0,
          isShogai: false,
          in_app_payments: true,
          google_ads_tag: [{ 'id': 'jobs919_mail', 'ptype': 5 },
          { 'id': 'jobs919_mail', 'ptype': 1 },
          { 'id': 'jobs919_mail', 'ptype': 2 },
          { 'id': 'krasys_mail', 'ptype': 1 },
          { 'id': 'hrcareer_mail', 'ptype': 5 },
          { 'id': 'hrcareer_mail', 'ptype': 6 },
          { 'id': 'hrcareer_mail', 'ptype': 7 },
          { 'id': 'hrcareer_mail', 'ptype': 8 },
          { 'id': 'hrcareer_mail', 'ptype': 9 },
          { 'id': 'hrcareer_mail', 'ptype': 10 },
          { 'id': 'hrcareer_mail', 'ptype': 11 },
          { 'id': 'hrcareer_mail', 'ptype': 12 },
          { 'id': 'hrcareer_mail', 'ptype': 15 },
          { 'id': 'recree_mail', 'ptype': 2 },
          { 'id': 'recree_mail', 'ptype': 3 },
          { 'id': 'recree_mail', 'ptype': 4 },
          { 'id': 'hitotech_admin', 'ptype': 1 },
          { 'id': 'hitotech_admin', 'ptype': 2 },
          { 'id': 'hitotech_admin', 'ptype': 3 },
          { 'id': 'hitotech_admin', 'ptype': 4 },
          { 'id': 'sms_admin', 'ptype': 1 },
          { 'id': 'sms_admin_eiyoshi', 'ptype': 2 },
          { 'id': 'sms_admin_hoiku', 'ptype': 3 },
          { 'id': 'hitoshia_admin', 'ptype': 3 },
          { 'id': 'hitoshia_admin', 'ptype': 4 },
          { 'id': 'pleiades_mail', 'ptype': 2 },
          { 'id': 'pleiades_mail', 'ptype': 10 },
          { 'id': 'pleiades_mail', 'ptype': 18 },
          { 'id': 'pleiades_mail', 'ptype': 11 },
          { 'id': 'pleiades_mail', 'ptype': 12 },
          { 'id': 'pleiades_mail', 'ptype': 13 },
          { 'id': 'pleiades_mail', 'ptype': 16 },
          { 'id': 'pleiades_mail', 'ptype': 17 },
          { 'id': 'neocareer_admin', 'ptype': 1 },
          { 'id': 'neocareer_admin', 'ptype': 2 },
          { 'id': 'peacekaigo_mail', 'ptype': 2 },
          { 'id': 'peacekaigo_mail', 'ptype': 4 },
          { 'id': 'kikkakeagent_mail', 'ptype': 1 },
          { 'id': 'noajpn_mail', 'ptype': 1 },
          { 'id': 'noajpn_mail', 'ptype': 2 },
          { 'id': 'medley_link', 'ptype': 5 },
          { 'id': 'medley_link', 'ptype': 6 },
          { 'id': 'reaching_mail', 'ptype': 1 },
          { 'id': 'reaching_mail', 'ptype': 2 },
          { 'id': 'persolinnovation_admin', 'ptype': 1 },
          { 'id': 'persolinnovation_admin', 'ptype': 2 },
          { 'id': 'persolinnovation_admin', 'ptype': 4 },
          { 'id': 'cookbiz_mail', 'ptype': 1 },
          { 'id': 'roxx_api', 'ptype': 1 },
          { 'id': 'roxx_api', 'ptype': 2 },
          { 'id': 'roxx_api', 'ptype': 3 }],
          joblistKeyword20240415: ['施工管理', '看護師', '薬剤師', '作業療法士', '理学療法士', '言語聴覚士', '視能訓練士', '保育士', '歯科衛生士', '介護職', 'ヘルパー', '栄養士', '歯科助手', '販促物の製作業務', '福岡私立精華女子高等学校', '畜産農家', 'Webマーケティング', 'ペット業界', '医療法人社団三木会 花まる歯科クリニック 入社', 'CAD製図', 'アコースティックギター演奏', 'ビジネス工科専門学校', 'webライター', '高齢の母親と一緒に暮らしているため、転勤は避けたい', '高速道路', 'スポーツ国際開発', '写植', '岡山商科大学', '宿泊業', '残業', 'ダンスインストラクター', '回送', 'セールスドライバー', 'バスケ', '教育福祉', '熊本市立帯山中学校卒業', '鈑金塗装', '3Dデザイン', 'データ整理', '自動車関連の仕事', 'グランドハンドリング', '接客販売業', '接客サービス業', '電話受付', '在宅の仕事', '中古車販売', 'マーケティングリサーチ', '総務労務', '配送業務', '鍼灸', 'パン職人', '工業高校', 'ITサポート', 'ヤマト運輸', '郵便局', '化学工学', 'キッチンスタッフ', 'ファッションビジネス', '日本語学科', '自然環境専門高校入学', '給与計算', 'パソコン操作', '塾講師', '猫カフェ', '接客経験', '不動産事務', '溶接', 'ライター', '不動産営業', '通関士', 'アパレル販売', '幼児教育', '保険営業', '在宅勤務', '英語教育', '運輸', 'パソコン', '社会福祉士', '法学', '保険', '法律事務所', '電気工事士', '大学', '電気工事', 'UI', '教育', '営業事務', '製造業', '一般事務', '旅行', '医療事務', '営業職', '教員', '経済学部', '接客販売', '医療', 'マネジメント', '自動車', 'IT', '日本語教師', 'マーケティング', '経理', '医薬', 'ホテル', '調理師', '総務', 'フォークリフト', '飲食業', '建設', '軽作業', '農業', 'ゲーム', '工場', '未経験', '企画', 'インテリア', '役所', '化学', 'デザイン', '美容師', '広告', '美容', '営業', '土木', '警備', '管理', '事務', '飲食', '事務職', 'コールセンター', 'エンジニア', 'インターネット', 'SE', 'NPO', '福祉', '映像', '学校法人', '介護', '講師', '医師', '接客', '不動産', '接客業', '看護', '受付', '交通', '公務員', '動物', 'サービス', '製造', '配送', '販売', 'データ入力', 'アパレル', 'スポーツ', '印刷', '制作', '人事', 'クリニック', '開発', '保育', 'サポート', '機械', '運営', '食品', 'プラスチック成形', '土日勤務', '運動経験', 'データ検査', 'アニメ声優', '東大阪市立日新高等学校', '土木施工管理', '情報環境科', '洋服販売', 'エリアマネジャー', 'ビジネススクール', '中古ジュエリー販売', '岡山', 'お寿司の製造', '期間工', '教育関係', '接客応対', '舞台設備工事', '倉庫オペレータ', '会計税務アシスタント', '売り場づくり', '保育士補助', 'ECサイトの運営業務', '障害者移動支援', 'バル', '小学校通訳', '経理総務事務', 'アミューズメントパーク', '材料技術', '陸送業務', 'IT職種', '総合受付業務', '損保事務', 'ITインフラエンジニア', '医療技術短期大学部', '保育園看護師', '軽貨物運送事業', '漫画家', 'エアジャパン', '成田国際空港', 'アトラクションメンテナンス', 'オンライン決済代行業', '総務部', '建設用軽仮設機材', '子育て支援員', '回収車', '尾瀬高等学校', '洗車', 'フィギュア買い取り', '広島県立安西高等学校', '日立エレベーターサービス株式会社', '大型ダンプ運転手', '損害保険調査', 'プロダクトデザイナー', '熊本県立八代高等学校', 'コンタクトセンター', '物流倉庫内のクール便の仕分け作業', '鮮魚部門', '事務調達職', '千葉県立市原高等学校', '日本化粧品検定2級合格', '千葉県立成田北高等学校', '美容外科 受付 サポート 事務', '財務事務', '医療IT業界', '金属プレス', '営業経験', '土地仕入業務', '医療・保育・介護', '事務リーダー', '人材営業', 'MR', '文章構成', '子供英語講師', '筋力トレーニング', '大型自動車免許', '生産技術業務', '化学生命工学', 'スフォリアテッラ専門店', 'トラブル解決', 'ネットショップ', '事務一般', '短大', '大阪大学人間科学部人間科学科', '製造ライン', 'アプリケーション開発', '石油化学プラント オペレーター', 'Web', '医学技術', '福祉心理', '法務事務', '技術専門', '競走馬', '郵便配達', '飲食サービス', '提案営業', '茨城県立ルネサンス高等学校', '製造工場', 'インテリア業界', '弁護士', '成田空港地上職', '広島市立舟入高等学校', '大学事務員', 'リユース業', '文化財学科', '短期アルバイト', 'EC店鋪運営', '医療サービス業', '医師事務作業補助者', '製袋機オペレーター', '物流企画', '給排水処理設備の運転管理', '通信', '物流倉庫スタッフ', '第二種電気工事士', 'カバーディーラー', '国際英語学科', 'アトラクション運営', '横浜駅周辺', '送電線業界の建設土木', 'データマネージャー', '美術科', '介護施設', '総合事務', '東洋大学', '食物調理', '理学療法', '会計・税務知識', '生活支援員', '旅行業界', '生活相談員', 'パソコン作業', '土木建設業', 'ロボット工学', '施工管理アシスタント', '食品栄養学', '教育支援', '情報専門学校', '設備メンテナンス', 'PC業務', '買取営業', '介護事務', '医療従事者', 'インテリア・住宅関連', '工事現場管理', 'ネットワーク', '訪問介護', '不動産管理', '医療機関', '配達ドライバー', 'メンテナンス', '日本の仕事', '航空貨物', 'インサイドセールス', 'サッカー', 'システムエンジニア・プログラマ', '佐賀県立佐賀農業高等学校', '国際関係学', '社長秘書', '英語力', 'カラオケ', '総務職', '副業', '文学', '経営コンサルタント', '喫茶店', '総務経理事務', 'キッチン', '人材紹介', '工業化学', '病棟クラーク', '指導員', 'テクニカルスタッフ', '音楽講師', '倉庫内作業', 'デンソー', '組立', 'セレクトショップ', '障がい者支援', '警備員', '国際営業', '美容室受付', '心理カウンセリング', '鮮魚', '文学部', '倉庫', '営業サポート', '普通自動車第一種運転免許取得', '外国語学部', 'ビジネスマネジメント', '受付兼助手', '医学部', '映像編集', '建築設備点検', '鉄道', '経営学科', '英会話講師', '営業事務職', '人事職', 'デジタルマーケティング', 'SNSマーケティング', '獣医', '自衛隊', '養護教諭', '短期バイト', 'Web開発', 'ホテル業界', '事務・秘書・受付', '看護助手', 'トラック運転手', '国際経済学', 'ルート営業', 'webデザイナー', '調剤薬局事務', '金融業務', '法政大学', '携帯電話販売', 'プログラマー', '設備管理', '仕分け', 'ゲーム業界', '臨床検査技師', 'CADオペレーター', 'WEBデザイン', '陸上自衛隊', '動物看護', '製造業務', '神社', '経理業務', '倉庫作業', '地理学', '医療機器', '事務業務', '物流業', 'システムエンジニア', '建築設計', '英米文学', '製造オペレーター', '歯科技工士', '高校生', '司書', '日本文学', '歯科', '国際経営', 'ITエンジニア', 'カウンセラー', '運転', '人材コーディネーター', '機械工学', '運送業', 'ファッションデザイン', '新卒', 'インフラエンジニア', '製造職', '工場勤務', '製菓', '販売業務', '経営学部', '日本文化', '整備士', '料理', '法人営業', 'パティシエ', 'DTPオペレーター', '法務', '自動車整備士', '早稲田大学', '飲食店', '医療法人', '経理事務', '事務作業', '倉庫管理', '総務事務', 'システム開発', 'ものづくり', '受付業務', '調剤事務', '介護福祉士', 'グラフィックデザイン', '情報処理', '調理', '財務', '自動車販売', 'ドライバー', '接客業務', 'データ分析', '食品製造', '経営学', '管理栄養士', '士業', 'ゲーム開発', '品質管理', '社会福祉', '銀行', '法律', '生産管理', 'IT業界', '受付事務', '販売員', '建設業', '不動産業', '心理学', 'レジャー', '大学卒業後', 'コンサルタント', '翻訳', '物流', '通訳', '販売職', '編集', '工事', '経済学', '会計', 'デザイナー', 'プログラミング', '理容', '音楽', 'ブライダル', '建築', '映画', 'マネージャー', '点検', '設計', '化粧品', 'エステ', 'フード', '清掃', '金融', 'イベント', 'プロジェクトマネージャー', 'クリエイティブ'],
          joblistKeyword: ['工場', 'フォークリフト', '軽作業', '清掃', '製造', '出荷', 'ピッキング', 'ラベル貼り', '箱詰め', '溶接', '研磨', '梱包', '検品', '施工管理', '看護師', '薬剤師', '作業療法士', '理学療法士', '言語聴覚士', '視能訓練士', '保育士', '歯科衛生士', '介護職', 'ヘルパー', '栄養士', '歯科助手', '販促物の製作業務', '福岡私立精華女子高等学校', '畜産農家', 'Webマーケティング', 'ペット業界', 'CAD製図', 'アコースティックギター演奏', 'ビジネス工科専門学校', 'webライター', '高速道路', 'スポーツ国際開発', '写植', '岡山商科大学', '宿泊業', '残業', 'ダンスインストラクター', '回送', 'セールスドライバー', 'バスケ', '教育福祉', '熊本市立帯山中学校卒業', '鈑金塗装', '3Dデザイン', 'データ整理', '自動車関連の仕事', 'グランドハンドリング', '接客販売業', '接客サービス業', '電話受付', '在宅の仕事', '中古車販売', 'マーケティングリサーチ', '総務労務', '配送業務', '鍼灸', 'パン職人', '工業高校', 'ITサポート', 'ヤマト運輸', '郵便局', '化学工学', 'キッチンスタッフ', 'ファッションビジネス', '日本語学科', '自然環境専門高校入学', '給与計算', 'パソコン操作', '塾講師', '猫カフェ', '接客経験', '不動産事務', 'ライター', '不動産営業', '通関士', 'アパレル販売', '幼児教育', '保険営業', '在宅勤務', '英語教育', '運輸', 'パソコン', '社会福祉士', '法学', '保険', '法律事務所', '電気工事士', '大学', '電気工事', 'UI', '教育', '営業事務', '製造業', '一般事務', '旅行', '医療事務', '営業職', '教員', '経済学部', '接客販売', '医療', 'マネジメント', '自動車', 'IT', '日本語教師', 'マーケティング', '経理', '医薬', 'ホテル', '調理師', '総務', 'フォークリフト', '飲食業', '建設', '農業', 'ゲーム', '未経験', '企画', 'インテリア', '役所', '化学', 'デザイン', '美容師', '広告', '美容', '営業', '土木', '警備', '管理', '事務', '飲食', '事務職', 'コールセンター', 'エンジニア', 'インターネット', 'SE', 'NPO', '福祉', '映像', '学校法人', '介護', '講師', '医師', '接客', '不動産', '接客業', '看護', '受付', '交通', '公務員', '動物', 'サービス', '配送', '販売', 'データ入力', 'アパレル', 'スポーツ', '印刷', '制作', '人事', 'クリニック', '開発', '保育', 'サポート', '機械', '運営', '食品', 'プラスチック成形', '土日勤務', '運動経験', 'データ検査', 'アニメ声優', '東大阪市立日新高等学校', '土木施工管理', '情報環境科', '洋服販売', 'エリアマネジャー', 'ビジネススクール', '中古ジュエリー販売', '岡山', 'お寿司の製造', '期間工', '教育関係', '接客応対', '舞台設備工事', '倉庫オペレータ', '会計税務アシスタント', '売り場づくり', '保育士補助', 'ECサイトの運営業務', '障害者移動支援', 'バル', '小学校通訳', '経理総務事務', 'アミューズメントパーク', '材料技術', '陸送業務', 'IT職種', '総合受付業務', '損保事務', 'ITインフラエンジニア', '医療技術短期大学部', '保育園看護師', '軽貨物運送事業', '漫画家', 'エアジャパン', '成田国際空港', 'アトラクションメンテナンス', 'オンライン決済代行業', '総務部', '建設用軽仮設機材', '子育て支援員', '回収車', '尾瀬高等学校', '洗車', 'フィギュア買い取り', '広島県立安西高等学校', '日立エレベーターサービス株式会社', '大型ダンプ運転手', '損害保険調査', 'プロダクトデザイナー', '熊本県立八代高等学校', 'コンタクトセンター', '物流倉庫内のクール便の仕分け作業', '鮮魚部門', '事務調達職', '千葉県立市原高等学校', '日本化粧品検定2級合格', '千葉県立成田北高等学校', '美容外科 受付 サポート 事務', '財務事務', '医療IT業界', '金属プレス', '営業経験', '土地仕入業務', '医療・保育・介護', '事務リーダー', '人材営業', 'MR', '文章構成', '子供英語講師', '筋力トレーニング', '大型自動車免許', '生産技術業務', '化学生命工学', 'スフォリアテッラ専門店', 'トラブル解決', 'ネットショップ', '事務一般', '短大', '大阪大学人間科学部人間科学科', '製造ライン', 'アプリケーション開発', '石油化学プラント オペレーター', 'Web', '医学技術', '福祉心理', '法務事務', '技術専門', '競走馬', '郵便配達', '飲食サービス', '提案営業', '茨城県立ルネサンス高等学校', '製造工場', 'インテリア業界', '弁護士', '成田空港地上職', '広島市立舟入高等学校', '大学事務員', 'リユース業', '文化財学科', '短期アルバイト', 'EC店鋪運営', '医療サービス業', '医師事務作業補助者', '製袋機オペレーター', '物流企画', '給排水処理設備の運転管理', '通信', '物流倉庫スタッフ', '第二種電気工事士', 'カバーディーラー', '国際英語学科', 'アトラクション運営', '横浜駅周辺', '送電線業界の建設土木', 'データマネージャー', '美術科', '介護施設', '総合事務', '東洋大学', '食物調理', '理学療法', '会計・税務知識', '生活支援員', '旅行業界', '生活相談員', 'パソコン作業', '土木建設業', 'ロボット工学', '施工管理アシスタント', '食品栄養学', '教育支援', '情報専門学校', '設備メンテナンス', 'PC業務', '買取営業', '介護事務', '医療従事者', 'インテリア・住宅関連', '工事現場管理', 'ネットワーク', '訪問介護', '不動産管理', '医療機関', '配達ドライバー', 'メンテナンス', '日本の仕事', '航空貨物', 'インサイドセールス', 'サッカー', 'システムエンジニア・プログラマ', '佐賀県立佐賀農業高等学校', '国際関係学', '社長秘書', '英語力', 'カラオケ', '総務職', '副業', '文学', '経営コンサルタント', '喫茶店', '総務経理事務', 'キッチン', '人材紹介', '工業化学', '病棟クラーク', '指導員', 'テクニカルスタッフ', '音楽講師', '倉庫内作業', 'デンソー', '組立', 'セレクトショップ', '障がい者支援', '警備員', '国際営業', '美容室受付', '心理カウンセリング', '鮮魚', '文学部', '倉庫', '営業サポート', '普通自動車第一種運転免許取得', '外国語学部', 'ビジネスマネジメント', '受付兼助手', '医学部', '映像編集', '建築設備点検', '鉄道', '経営学科', '英会話講師', '営業事務職', '人事職', 'デジタルマーケティング', 'SNSマーケティング', '獣医', '自衛隊', '養護教諭', '短期バイト', 'Web開発', 'ホテル業界', '事務・秘書・受付', '看護助手', 'トラック運転手', '国際経済学', 'ルート営業', 'webデザイナー', '調剤薬局事務', '金融業務', '法政大学', '携帯電話販売', 'プログラマー', '設備管理', '仕分け', 'ゲーム業界', '臨床検査技師', 'CADオペレーター', 'WEBデザイン', '陸上自衛隊', '動物看護', '製造業務', '神社', '経理業務', '倉庫作業', '地理学', '医療機器', '事務業務', '物流業', 'システムエンジニア', '建築設計', '英米文学', '製造オペレーター', '歯科技工士', '高校生', '司書', '日本文学', '歯科', '国際経営', 'ITエンジニア', 'カウンセラー', '運転', '人材コーディネーター', '機械工学', '運送業', 'ファッションデザイン', '新卒', 'インフラエンジニア', '製造職', '製菓', '販売業務', '経営学部', '日本文化', '整備士', '料理', '法人営業', 'パティシエ', 'DTPオペレーター', '法務', '自動車整備士', '早稲田大学', '飲食店', '医療法人', '経理事務', '事務作業', '倉庫管理', '総務事務', 'システム開発', 'ものづくり', '受付業務', '調剤事務', '介護福祉士', 'グラフィックデザイン', '情報処理', '調理', '財務', '自動車販売', 'ドライバー', '接客業務', 'データ分析', '食品製造', '経営学', '管理栄養士', '士業', 'ゲーム開発', '品質管理', '社会福祉', '銀行', '法律', '生産管理', 'IT業界', '受付事務', '販売員', '建設業', '不動産業', '心理学', 'レジャー', '大学卒業後', 'コンサルタント', '翻訳', '物流', '通訳', '販売職', '編集', '工事', '経済学', '会計', 'デザイナー', 'プログラミング', '理容', '音楽', 'ブライダル', '建築', '映画', 'マネージャー', '点検', '設計', '化粧品', 'エステ', 'フード', '金融', 'イベント', 'プロジェクトマネージャー', 'クリエイティブ'],
          joblistPrefs: ['北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県', '岐阜県', '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '鳥取県', '島根県', '岡山県', '広島県', '山口県', '徳島県', '香川県', '愛媛県', '高知県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県', '海外'],
          getMessageBoxresult: []
        }
      },
      computed: {
      },
      methods: {
        isJobChangeFormat: function (_id) {
          return this.targetJobChangeIds.includes(_id)
        },
        isJobChangeShokumukeirekiFormat: function (_id) {
          return this.targetJobChangeIds.includes(_id) || _id.includes('shokumukeirekisho')
        },
        eventTag: function () {
          // alert('pdf_' + this.dn_flag + '_rt_completed')
          this.invokeNative('pdf_' + this.dn_flag + '_rt_completed')
        },
        invokeNative: function (_id) {
          console.error(_id)
          if (this.$site.appFlag == 'b' || true) {
            try {
              MessageInvoker.postMessage(_id);
            } catch (error) {
              console.warn(`Error occurred while calling postMessage: ${error.message}`);
            }
          }
        },
        googleAdsTagCheck: function (client_id, permission_type) {
          console.error("googleAdsTagCheck")
          // google_ads_tag のリストを検索して一致する項目を探す
          const matchedTags = this.google_ads_tag.filter(tag => {
            return tag.id === client_id && tag.ptype === permission_type;
          })
          // 結果に応じた処理
          if (matchedTags.length > 0) {
            console.log("一致するタグが見つかりました:", matchedTags)
            return true
          } else {
            console.log("一致するタグが見つかりません")
            return false
          }

        },
        keywordCheck: function (formatId, formatData, keyword) {
          let _check = false
          if (formatId == "shokumukeirekisho") {
            return false
          }
          for (let key in formatData.educationalHistories) {
            // 見出し
            let item = formatData.educationalHistories[key]
            if (item.description && item.description.indexOf(keyword) >= 0) {
              _check = true
            }
          }
          for (let key in formatData.jobHistories) {
            // 見出し
            let item = formatData.jobHistories[key]
            if (item.description && item.description.indexOf(keyword) >= 0) {
              _check = true
            }
          }
          for (let key in formatData.licenseHistories) {
            // 見出し
            let item = formatData.licenseHistories[key]
            if (item.description && item.description.indexOf(keyword) >= 0) {
              _check = true
            }
          }
          return _check
        },
        keywordCheckOnlyLicense: function (formatId, formatData, keyword) {
          let _check = false
          if (formatId == "shokumukeirekisho") {
            return false
          }
          for (let key in formatData.licenseHistories) {
            // 見出し
            let item = formatData.licenseHistories[key]
            if (item.description && item.description.indexOf(keyword) >= 0) {
              _check = true
            }
          }
          return _check
        },
        keywordCheck2: function (formatId, formatData, keyword) {
          let _check = false
          if (formatId == "shokumukeirekisho") {
            return false
          }
          for (let key in formatData.educationalHistories) {
            // 見出し
            let item = formatData.educationalHistories[key]
            if (item.description.indexOf(keyword) >= 0) {
              _check = true
            }
          }
          for (let key in formatData.licenseHistories) {
            // 見出し
            let item = formatData.licenseHistories[key]
            if (item.description.indexOf(keyword) >= 0) {
              _check = true
            }
          }
          return _check
        },
        keywordCheck3: function (formatData, keyword) {
          let _check = false

          if (formatData.prMessage && formatData.prMessage.indexOf(keyword) >= 0) {
            _check = true
          }
          if (formatData.jobSummary && formatData.jobSummary.indexOf(keyword) >= 0) {
            _check = true
          }
          if (formatData.jobHistories) {
            for (let key in formatData.jobHistories) {
              // 見出し
              let item = formatData.jobHistories[key]
              if (item && item.businessArea && item.businessArea.indexOf(keyword) >= 0) {
                _check = true
              }
              for (let subkey in item.projects) {
                let subitem = item.projects[subkey]
                if (subitem && subitem.contentsOfProject && subitem.contentsOfProject.indexOf(keyword) >= 0) {
                  _check = true
                }
                if (subitem && subitem.projectTitle && subitem.projectTitle.indexOf(keyword) >= 0) {
                  _check = true
                }
                if (subitem && subitem.position && subitem.position.indexOf(keyword) >= 0) {
                  _check = true
                }
              }
            }

          }
          return _check
        },
        keywordCheckRirekisho: function (targetData, keywordlist) {
          for (const keyword in keywordlist) {
            for (let key in targetData.educationalHistories) {
              // 見出し
              let item = targetData.educationalHistories[key]
              if (item.description && item.description.indexOf(keywordlist[keyword]) >= 0) {
                return true
              }
            }
            for (let key in targetData.jobHistories) {
              // 見出し
              let item = targetData.jobHistories[key]
              if (item.description && item.description.indexOf(keywordlist[keyword]) >= 0) {
                return true
              }
            }
            for (let key in targetData.licenseHistories) {
              // 見出し
              let item = targetData.licenseHistories[key]
              if (item.description && item.description.indexOf(keywordlist[keyword]) >= 0) {
                return true
              }
            }
          }
          return false
        },
        keywordCheckShokumukeirekishoOnlyLicense: function (targetData, keyword) {

          if (targetData.skillsToUse) {
            for (let key in targetData.skillsToUse) {
              let item = targetData.skillsToUse[key]
              if (item && item.skillname && item.skillname.indexOf(keyword) >= 0) {
                return true
              }
            }
          }
          return false
        },
        keywordCheckShokumukeirekisho: function (targetData, keywordlist) {
          for (const keyword in keywordlist) {
            if (targetData.prMessage && targetData.prMessage.indexOf(keywordlist[keyword]) >= 0) {
              return true
            }
            if (targetData.jobSummary && targetData.jobSummary.indexOf(keywordlist[keyword]) >= 0) {
              return true
            }
            if (targetData.skillsToUse) {
              for (let key in targetData.skillsToUse) {
                let item = targetData.skillsToUse[key]
                if (item && item.skillname && item.skillname.indexOf(keywordlist[keyword]) >= 0) {
                  return true
                }
              }
            }
            if (targetData.jobHistories) {
              for (let key in targetData.jobHistories) {
                // 見出し
                let item = targetData.jobHistories[key]
                if (item && item.businessArea && item.businessArea.indexOf(keywordlist[keyword]) >= 0) {
                  return true
                }
                for (let subkey in item.projects) {
                  let subitem = item.projects[subkey]
                  if (subitem && subitem.contentsOfProject && subitem.contentsOfProject.indexOf(keywordlist[keyword]) >= 0) {
                    return true
                  }
                  if (subitem && subitem.projectTitle && subitem.projectTitle.indexOf(keywordlist[keyword]) >= 0) {
                    return true
                  }
                  if (subitem && subitem.position && subitem.position.indexOf(keywordlist[keyword]) >= 0) {
                    return true
                  }
                }
              }

            }
          }
          return false
        },
        checkJoblistKeyword: function (formatId, formatData) {
          let _keyword = ''
          for (let key in this.joblistKeyword) {
            if (this.keywordCheck(formatId, formatData, this.joblistKeyword[key])) {
              _keyword = this.joblistKeyword[key]
              return _keyword
            }
          }
          return _keyword
        },
        getPrefJoblist: function (basicData) {
          let _pref = ''
          for (let key in this.joblistPrefs) {
            if (basicData.address1.indexOf(this.joblistPrefs[key]) >= 0) {
              _pref = this.joblistPrefs[key]
            }
          }
          return _pref
        },
        addressCheck: function (basicData, addresslist) {
          for (const key in addresslist) {
            if (basicData.address1 && basicData.address1.indexOf(addresslist[key]) >= 0) {
              return true
            }
          }
          return false
        },
        displayFrontEndPopupRenew: function (formatId, formatData, basicData, otherFormatData, request_data, previewFormat) {

          if (formatId == "rirekisho_esf_challenged") {
            return false
          }
          let isYagish_1 = false
          let isMedley1 = false
          let isMedley2 = false
          let isMedley3 = false
          let isMedley4 = false
          let isMedley5 = false
          let isMedley6 = false
          let isMedley7 = false
          let isMedley8 = false
          let isMedley9 = false
          let isMedley10 = false
          let isTryt = false
          let isKirara = false
          let isSimple1 = false
          let isSimple2 = false
          let isSimple3 = false
          let isBaton = false
          let isBaton2 = false
          let isSystemShared = false
          let isSystemShared2 = false
          let isSystemShared3 = false
          let isSystemShared4 = false
          let isSystemShared5 = false
          let isSystemShared6 = false
          let isSystemShared8 = false
          let isSystemShared9 = false
          let isSystemShared10 = false
          let isJaic1 = false
          let isJaic2 = false
          let isJaic3 = false
          let isMynaviMs = false
          let isJigen = false
          let medleyID = 1

          let isHuemaridge_1 = false

          let isMedley_Link_5 = false
          let isMedley_Link_6 = false
          let isMedley_Link_7 = false
          let isMedley_Link_8 = false
          let isMedley_Link_9 = false
          let isMedley_Link_10 = false
          let isMedley_Link_11 = false
          let isMedley_Link_12 = false
          let isMedley_Link_13 = false
          let isMedley_Link_14 = false
          let isMedley_Link_15 = false
          let isMedley_Link_16 = false
          let isMedley_Link_17 = false
          let isMedley_Link_18 = false
          let isMedley_Link_19 = false
          let isMedley_Link_20 = false
          let isMedley_Link_21 = false
          let isMedley_Link_22 = false


          let isJob919_1 = false
          let isJob919_2 = false
          let isJob919_3 = false
          let isJob919_4 = false
          let isJob919_5 = false
          let isJob919_6 = false
          let isJob919_7 = false
          let isJob919_8 = false
          let isJob919_9 = false


          let isPersolinnovation_1 = false
          let isPersolinnovation_2 = false
          let isPersolinnovation_3 = false
          let isPersolinnovation_4 = false

          let isRecrea_1 = false


          let isHrcareer_1 = false
          let isHrcareer_2 = false
          let isHrcareer_3 = false
          let isHrcareer_4 = false
          let isHrcareer_5 = false
          let isHrcareer_6 = false
          let isHrcareer_7 = false
          let isHrcareer_8 = false
          let isHrcareer_9 = false
          let isHrcareer_10 = false
          let isHrcareer_11 = false
          let isHrcareer_12 = false
          let isHrcareer_13 = false
          let isHrcareer_14 = false
          let isHrcareer_15 = false
          let isMiraiyu_1 = false
          let isMiraiyu_2 = false
          let isMiraiyu_3 = false
          let isMiraiyu_4 = false
          let isNeocareer_1 = false
          let isNeocareer_2 = false
          let isNeocareer_3 = false
          let isNeocareer_4 = false
          let isDrtc_1 = false

          let isNeocareerNew_1 = false

          let isCareerdraft_1 = false
          let isYagish = false
          let isReastage_1 = false
          let isMynavi_1 = false
          let isRecruitMc1 = false
          let isRecruitMc2 = false
          let isAsiro_1 = false
          let isAsiro_2 = false
          let isAsiro_3 = false
          let isAsiro_4 = false
          let isAsiro_5 = false
          let isAsiro_6 = false
          let isCapla_1 = false
          let isCapla_2 = false
          let isBridge_1 = false
          let isDely_1 = false
          let isRozas_1 = false
          let isRozas_2 = false
          let isRozas_3 = false
          let isRozas_4 = false
          let isRozas_5 = false
          let isWorkport_1 = false
          let isWorkport_2 = false
          let isWorkport_3 = false
          let isWorkport_4 = false

          let isAgrinavi_1 = false

          let isRecree_1 = false
          let isRecree_2 = false
          let isRecree_3 = false
          let isRecree_4 = false
          let isRecree_5 = false
          let isArowtrail_1 = false
          let isArowtrail_2 = false
          let isArowtrail_3 = false
          let isTunaguba_1 = false

          let isKrasys_2 = false
          let isPharmacareer_1 = false
          let isXmile_1 = false
          let isXmile_2 = false
          let isXmile_3 = false
          let isXmile_4 = false
          let isXmile_5 = false
          let isXmile_6 = false
          let isXmile_7 = false
          let isXmile_8 = false
          let isXmile_9 = false
          let isXmile_10 = false
          let isXmile_11 = false
          let isXmile_12 = false
          let isXmile_13 = false
          let isXmile_14 = false
          let isXmile_15 = false
          let isXmile_16 = false
          let isXmile_17 = false
          let isXmile_18 = false

          let isPleiades_1 = false
          let isPleiades_2 = false
          let isPleiades_3 = false
          let isPleiades_4 = false
          let isPleiades_5 = false
          let isPleiades_6 = false
          let isPleiades_7 = false
          let isPleiades_8 = false
          let isPleiades_9 = false
          let isPleiades_10 = false
          let isPleiades_11 = false
          let isPleiades_12 = false
          let isPleiades_13 = false
          let isPleiades_14 = false
          let isPleiades_15 = false
          let isPleiades_16 = false
          let isPleiades_17 = false
          let isPleiades_18 = false


          let isPeacekaigo_2 = false

          let isPeacekaigo_4 = false
          let isPeacekaigo_5 = false
          let isHitotech_1 = false
          let isHitotech_2 = false
          let isHitotech_3 = false
          let isHitotech_4 = false


          let isHitotechNeocareer_1 = false

          let isTechouse_1 = false
          let isTechouse_2 = false
          let isTechouse_3 = false

          let isUsenworking_1 = false
          let isUsenworking_2 = false
          let isUsenworking_3 = false
          let isUsenworking_4 = false

          let isSms_1 = false
          let isSms_2 = false
          let isSms_3 = false

          let is400F_1 = false
          let isKikkakeagent_1 = false
          let isPrimalwork_1 = false
          let isTalentnavi_1 = false

          let isHuproinc_1 = false
          let isHuproinc_2 = false

          let isNineearth_1 = false
          let isNineearth_2 = false

          let isAxes_1 = false

          let isStarlabo_1 = false
          let isStarlabo_2 = false

          let isSupernurse_1 = false

          let isHeros_1 = false
          let isHeros_2 = false

          let isCloudlink_1 = false
          let isCloudlink_2 = false

          let isOutsourcing_1 = false

          let isAzurite_1 = false
          let isAzurite_2 = false

          let isProlg_1 = false
          let isProlg_2 = false

          let isSmartforce_1 = false

          let isKiminara_1 = false
          let isKiminara_2 = false

          let isStrike_1 = false
          let isCloudlink_3 = false

          let isInternous_1 = false
          let isInternous_2 = false
          let isInternous_3 = false
          let isInternous_4 = false
          let isInternous_5 = false

          let isBearsnavi_1 = false
          let isBearsnavi_2 = false
          let isBearsnavi_3 = false


          let isNoajpn_1 = false
          let isNoajpn_2 = false
          let isAwesome_1 = false
          let isJhr_1 = false
          let isJhr_2 = false
          let isSimple_1 = false

          let isBriedge_1 = false


          let isTryt_2 = false
          let isTryt_3 = false
          let isTryt_4 = false
          let isReaching_1 = false
          let isReaching_2 = false
          let isReaching_3 = false
          let isReaching_4 = false
          let isReaching_5 = false

          let isDagent_1 = false


          let isGrandop_1 = false

          let isCookbiz_1 = false
          let isCookbiz_2 = false
          let isCookbiz_3 = false

          let isFoodison_1 = false
          let isFoodison_2 = false
          let isFoodison_3 = false

          let isOishiru_1 = false

          let isHayfield_1 = false

          let isItk_1 = false

          let isCareerdraft_2 = false
          let isCareerdraft_3 = false

          let isTaikennyusha_1 = false
          let isTaikennyusha_2 = false

          let isRoxx_6 = false
          let isRoxx_7 = false


          let isHitolabo_1 = false
          let isHitolabo_2 = false

          let isLeverages_1 = false


          if (true) {
            if (this.keywordCheck(formatId, formatData, '介護士') || this.keywordCheck(formatId, formatData, 'ヘルパー') || this.keywordCheck(formatId, formatData, '介護福祉士')) {
              isMedley1 = true
              medleyID = 1
            } else if (this.keywordCheck(formatId, formatData, '保育')) {
              isMedley2 = true
              medleyID = 2
            } else if (this.keywordCheck(formatId, formatData, '薬剤')) {
              isMedley3 = true
              medleyID = 3
            } else if (this.keywordCheck(formatId, formatData, '作業療法') || this.keywordCheck(formatId, formatData, '理学療法')
              || this.keywordCheck(formatId, formatData, '言語聴覚') || this.keywordCheck(formatId, formatData, '視能訓練')) {
              isMedley4 = true
              medleyID = 4
            } else if (this.keywordCheck(formatId, formatData, '歯科衛生')) {
              isMedley5 = true
              medleyID = 5
            } else if (this.keywordCheck(formatId, formatData, '歯科助手')) {
              isMedley6 = true
              medleyID = 6
            } else if (this.keywordCheck(formatId, formatData, '看護師') || this.keywordCheck(formatId, formatData, '准看護師')) {
              isMedley7 = true
              medleyID = 7
            }

          }


          let yagish1KeywordArray = ['G2BAi4bWlzPRQ2vEF9ajZZx4ylX2']
          if (this.keywordCheckRirekisho(formatData, yagish1KeywordArray)
            || this.keywordCheckShokumukeirekisho(formatData, yagish1KeywordArray)) {
            isYagish_1 = true
          }

          let sms1AddressArray = ['練馬区光が丘']
          let sms1KeywordArray = ['介護士', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員', 'ケアマネジャー']
          if (true) {
            if (basicData.age >= 20 && basicData.age <= 59) {
              if (this.keywordCheckRirekisho(formatData, sms1KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, sms1KeywordArray)) {
                isSms_1 = true
              }
            }
          }
          let sms2KeywordArray = ['栄養士']
          if (true) {
            if (basicData.age >= 23 && basicData.age <= 55) {
              if (this.keywordCheckRirekisho(formatData, sms2KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, sms2KeywordArray)) {
                isSms_2 = true
              }
            }
          }
          let sms3KeywordArray = ['保育士']
          if (true) {
            if (basicData.age >= 20 && basicData.age <= 69) {
              if (this.keywordCheckRirekisho(formatData, sms3KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, sms3KeywordArray)) {
                isSms_3 = true
              }
            }
          }



          let mynavi1addressArray = ['東京都']
          if (this.addressCheck(basicData, mynavi1addressArray)) {
            if (basicData.age <= 30 && basicData.age >= 18) {
              isMynavi_1 = true
            }
          }

          let trytaddressArray = ['岩手県', '茨城県', '京都府', '兵庫県', '滋賀県', '奈良県', '広島県', '山口県', '鹿児島県', '北海道', '愛知県', '岐阜県', '香川県', '富山県', '青森県', '鳥取県', '静岡県', '三重県', '千葉県', '新潟県', '石川県', '山梨県', '和歌山県', '福井県', '大阪府']
          if (this.addressCheck(basicData, trytaddressArray)) {
            if (this.keywordCheck2(formatId, formatData, '正看護師') || this.keywordCheck2(formatId, formatData, '准看護師') || this.keywordCheck2(formatId, formatData, '保健師') || this.keywordCheck2(formatId, formatData, '助産師')) {
              isTryt = true
            }
          }

          let kiraraaddressArray = ['東京都']
          if (this.addressCheck(basicData, kiraraaddressArray)) {
            if (this.keywordCheck2(formatId, formatData, '保育士')) {
              if (basicData.age < 50 && basicData.age >= 22) {
                isKirara = true
              }
            }
          }
          // isKirara = false
          let simple1addressArray = ['東京都']
          if (this.addressCheck(basicData, simple1addressArray)) {
            if (this.keywordCheck(formatId, formatData, '保育士')) {
              if (basicData.age < 60 && basicData.age >= 22) {
                isSimple1 = false
              }
            }
          }
          let simple2addressArray = ['神奈川県', '千葉県', '埼玉県']
          if (this.addressCheck(basicData, simple2addressArray)) {
            if (this.keywordCheck(formatId, formatData, '保育士')) {
              if (basicData.age < 60 && basicData.age >= 22) {
                isSimple2 = false
              }
            }
          }
          let simple3addressArray = ['東京都', '神奈川県', '千葉県', '埼玉県']
          if (this.addressCheck(basicData, simple3addressArray)) {
            if (this.keywordCheck(formatId, formatData, '栄養士')) {
              if (basicData.age < 60 && basicData.age >= 22) {
                isSimple3 = false
              }
            }
          }

          let batonAddressArray = ['東京都']
          if (this.addressCheck(basicData, batonAddressArray)) {
            if (this.keywordCheck(formatId, formatData, '看護')) {
              isBaton = true
            }
          }
          let baton2addressArray = ['東京都', '神奈川県', '千葉県', '埼玉県']
          if (this.addressCheck(basicData, baton2addressArray)) {
            if (this.keywordCheck(formatId, formatData, '営業')) {
              if (basicData.age < 36 && basicData.age >= 30) {
                isBaton2 = true
              }
            }
          }
          isBaton = false
          isBaton2 = false
          let jaic1addressArray = ['宮城県', '広島県', '福岡県']
          if (this.addressCheck(basicData, jaic1addressArray)) {
            if (basicData.age < 30 && basicData.age >= 20 && formatId == "rerekisho_part_time") {
              isJaic1 = true
            }
          }
          let jaic2addressArray = ['宮城県', '広島県', '福岡県']
          if (this.addressCheck(basicData, jaic2addressArray)) {
            if (basicData.age <= 25 && this.keywordCheck(formatId, formatData, '中退') && (formatId == "rirekisho_job_change" || formatId == "rirekisho_ai_career" ||
              formatId == "rirekisho_job_change2" ||
              formatId == "rirekisho_job_change_old" ||
              formatId == "rirekisho_single" ||
              formatId == "rirekisho_nophoto_double" ||
              formatId == "rirekisho_nophoto")) {
              isJaic2 = true
            }
          }
          let jaic3addressArray = ['宮城県']
          if (this.addressCheck(basicData, jaic3addressArray)) {
            if (basicData.age < 30 && basicData.age >= 20 && (formatId == "rirekisho_job_change" || formatId == "rirekisho_ai_career" ||
              formatId == "rirekisho_job_change2" ||
              formatId == "rirekisho_job_change_old" ||
              formatId == "rirekisho_single" ||
              formatId == "rirekisho_nophoto_double" ||
              formatId == "rirekisho_nophoto")) {
              isJaic3 = true
            }
          }
          isJaic1 = false
          isJaic2 = false
          isJaic3 = false
          if (this.keywordCheck(formatId, formatData, '人事') || this.keywordCheck(formatId, formatData, '法務') || this.keywordCheck(formatId, formatData, '総務') || this.keywordCheck(formatId, formatData, '経理')
            || this.keywordCheck(formatId, formatData, '財務') || this.keywordCheck(formatId, formatData, '労務') || this.keywordCheck(formatId, formatData, '情報システム')) {
            if (basicData.age >= 35) {
              isMynaviMs = true
            }
          }
          isMynaviMs = false

          if (basicData.age >= 35) {
            isJigen = true
          }
          isJigen = false

          isSystemShared = false


          let reastageAddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '愛知県名古屋市', '大阪府', '福岡県']
          let reastageKeywordArray = ['営業', '事務', '販売', '接客']
          let reastageNotKeywordArray = ['学生', '卒業見込み', '日本語検定', 'N1', 'N2', '永住権', '定住者', '配偶者']
          if (this.addressCheck(basicData, reastageAddressArray)) {
            if (basicData.age < 26 && basicData.age >= 18) {
              if (this.keywordCheckRirekisho(formatData, reastageKeywordArray)) {
                if (this.keywordCheckRirekisho(formatData, reastageNotKeywordArray)) {
                  isReastage_1 = false
                } else {
                  isReastage_1 = true
                }
              }
            }
          }



          let systemShared2addressArray = ['北海道', '青森県', '秋田県', '宮城県', '山形県', '福島県', '岩手県', '茨城県', '栃木県', '群馬県', '新潟県', '富山県', '石川県', '長野県', '山梨県', '岐阜県', '福井県', '静岡県', '広島県', '岡山県', '鳥取県', '島根県', '山口県', '愛媛県', '徳島県', '香川県', '高知県', '福岡県', '佐賀県', '大分県', '長崎県', '熊本県', '宮崎県', '鹿児島県', '沖縄県']
          if (this.addressCheck(basicData, systemShared2addressArray)) {
            if (basicData.age < 30 && basicData.age >= 20) {
              isSystemShared2 = true
            }
          }
          isSystemShared2 = false
          let systemShared3addressArray = ['東京都', '神奈川県', '千葉県', '茨城県', '群馬県', '埼玉県', '栃木県']
          if (this.addressCheck(basicData, systemShared3addressArray)) {
            if (formatData.gradeYear == 23) {
              isSystemShared3 = true
            } else {
              if (basicData.age >= 22) {
                isSystemShared3 = true
              }
            }
          }
          isSystemShared3 = false
          let systemShared4addressArray = ['東京都', '神奈川県', '千葉県', '茨城県', '群馬県', '埼玉県', '栃木県', '静岡県', '山梨県']
          let systemShared4KeywordArray = ['エンジニア', 'プログラミング', 'JAVA', 'C#', 'AWS', 'クラウド', 'salesforce', 'セールスフォース', 'コンサル', 'PG', 'SE', 'PM', 'PL', '講師', '教員免許', '教論免許', 'ソフトウェア開発', '基本情報', '応用情報', 'ORACLE', 'Python', 'C言語', 'C++', 'SQL', '日商簿記2級']
          // if (this.keywordCheck(formatId, formatData, 'エンジニア') || this.keywordCheck(formatId, formatData, 'プログラミング') || this.keywordCheck(formatId, formatData, 'JAVA') || this.keywordCheck(formatId, formatData, 'C#') || this.keywordCheck(formatId, formatData, 'AWS') || 
          // this.keywordCheck(formatId, formatData, 'クラウド') || this.keywordCheck(formatId, formatData, 'salesforce') || this.keywordCheck(formatId, formatData, 'セールスフォース') || 
          // this.keywordCheck(formatId, formatData, 'コンサル') || this.keywordCheck(formatId, formatData, 'PG') || this.keywordCheck(formatId, formatData, 'SE') || this.keywordCheck(formatId, formatData, 'PM') || this.keywordCheck(formatId, formatData, 'PL') || 
          // this.keywordCheck(formatId, formatData, '講師') || this.keywordCheck(formatId, formatData, '教員免許') || this.keywordCheck(formatId, formatData, '教論免許') || this.keywordCheck(formatId, formatData, 'ソフトウェア開発') || 
          // this.keywordCheck(formatId, formatData, '基本情報') || this.keywordCheck(formatId, formatData, '応用情報') || this.keywordCheck(formatId, formatData, 'ORACLE') || this.keywordCheck(formatId, formatData, 'Python') || this.keywordCheck(formatId, formatData, 'C言語') || 
          // this.keywordCheck(formatId, formatData, 'C++') || this.keywordCheck(formatId, formatData, 'SQL') || this.keywordCheck(formatId, formatData, '日商簿記2級')) {
          //   if (this.addressCheck(basicData, systemShared4addressArray)) {
          //     if (basicData.age >= 18 && basicData.age <= 35) {
          //       isSystemShared4 = true
          //     }
          //   }
          // }

          if (this.addressCheck(basicData, systemShared4addressArray)) {
            if (basicData.age >= 18 && basicData.age <= 35) {
              if (formatId.indexOf('shokumukeirekisho') >= 0) {
                // 職務経歴書
                if (this.keywordCheckShokumukeirekisho(formatData, systemShared4KeywordArray)) {
                  isSystemShared4 = true
                }
                if (!isSystemShared4) {
                  if (this.keywordCheckRirekisho(otherFormatData, systemShared4KeywordArray)) {
                    isSystemShared4 = true
                  }
                }
              } else {
                // 履歴書
                if (this.keywordCheckRirekisho(formatData, systemShared4KeywordArray)) {
                  isSystemShared4 = true
                }
                if (!isSystemShared4) {
                  if (this.keywordCheckShokumukeirekisho(otherFormatData, systemShared4KeywordArray)) {
                    isSystemShared4 = true
                  }
                }

              }
            }
          }



          // isSystemShared4 = false 
          let systemShared5addressArray = ['東京都', '神奈川県', '千葉県', '茨城県', '群馬県', '栃木県', '静岡県', '山梨県']
          let systemShared5KeywordArray = ['JavaSpring', 'Vue.js', 'React', 'Ruby on Rails', 'Laravel', 'Django', 'JavaScript', 'PHP', 'C+', 'Ruby', '提案', '要件定義', '設計', '開発', '構築', '運用保守', 'Azure', 'GCP', 'Oracle', 'データ分析', 'ITパスポート', 'IPA', 'CCNA', 'CCNP', 'CompTIA', 'PMP', '簿記', '会計士']

          if (this.addressCheck(basicData, systemShared5addressArray)) {
            if (basicData.age >= 18 && basicData.age <= 35) {
              if (formatId.indexOf('shokumukeirekisho') >= 0) {
                // 職務経歴書
                if (this.keywordCheckShokumukeirekisho(formatData, systemShared5KeywordArray)) {
                  isSystemShared5 = true
                }
                if (!isSystemShared5) {
                  if (this.keywordCheckRirekisho(otherFormatData, systemShared5KeywordArray)) {
                    isSystemShared5 = true
                  }
                }
              } else {
                // 履歴書
                if (this.keywordCheckRirekisho(formatData, systemShared5KeywordArray)) {
                  isSystemShared5 = true
                }
                if (!isSystemShared5) {
                  if (this.keywordCheckShokumukeirekisho(otherFormatData, systemShared5KeywordArray)) {
                    isSystemShared5 = true
                  }
                }
              }
            }
          }
          isSystemShared5 = false
          let systemShared8addressArray = ['茨城県', '群馬県', '栃木県', '静岡県', '山梨県']
          let systemShared8KeywordArray = ['日本大学理工学部', '日本工学院 ITカレッジ', '船橋情報ビジネス専門学校', '日本電子専門学校', '東京電子専門学校', 'HAL東京', 'ITエンジニア科', '情報処理専門学校']
          if (this.addressCheck(basicData, systemShared8addressArray)) {
            if (basicData.age >= 18 && basicData.age <= 35) {
              if (formatId.indexOf('shokumukeirekisho') >= 0) {
                // 職務経歴書
                if (this.keywordCheckShokumukeirekisho(formatData, systemShared8KeywordArray)) {
                  isSystemShared8 = true
                }
                if (!isSystemShared8) {
                  if (this.keywordCheckRirekisho(otherFormatData, systemShared8KeywordArray)) {
                    isSystemShared8 = true
                  }
                }
              } else {
                // 履歴書
                if (this.keywordCheckRirekisho(formatData, systemShared8KeywordArray)) {
                  isSystemShared8 = true
                }
                if (!isSystemShared8) {
                  if (this.keywordCheckShokumukeirekisho(otherFormatData, systemShared8KeywordArray)) {
                    isSystemShared8 = true
                  }
                }
              }
            }
          }

          let systemShared6addressArray = ['東京都', '神奈川県', '千葉県', '埼玉県']
          let systemShared6KeywordArray = ['IT講師', 'IT研修講師', 'プログラミング講師', '学芸大学', 'インターネットアカデミー', 'トレノケート', 'KENスクール', 'リナックスアカデミー', 'インソース', 'ラーニングエージェンシー', '富士通ラーニングメディア', '株式会社フルネス', '株式会社エンベックスエデュケーション', '株式会社リカレント', '神田ITスクール', '株式会社FusionOne', 'ITカレッジ', 'リゾーム', '株式会社シンクスバンク', '株式会社クロノス', 'SEカレッジ', '株式会社 SEプラス', 'TECHSEED', '株式会社アルバイトタイムス']
          if (this.addressCheck(basicData, systemShared6addressArray)) {
            if (basicData.age >= 18 && basicData.age <= 35) {
              if (formatId.indexOf('shokumukeirekisho') >= 0) {
                // 職務経歴書
                if (this.keywordCheckShokumukeirekisho(formatData, systemShared6KeywordArray)) {
                  isSystemShared6 = true
                }
                if (!isSystemShared6) {
                  if (this.keywordCheckRirekisho(otherFormatData, systemShared6KeywordArray)) {
                    isSystemShared6 = true
                  }
                }
              } else {
                // 履歴書
                if (this.keywordCheckRirekisho(formatData, systemShared6KeywordArray)) {
                  isSystemShared6 = true
                }
                if (!isSystemShared6) {
                  if (this.keywordCheckShokumukeirekisho(otherFormatData, systemShared6KeywordArray)) {
                    isSystemShared6 = true
                  }
                }
              }
            }
          }


          let systemShared9addressArray = ['茨城県', '群馬県', '栃木県', '静岡県', '山梨県']
          let systemShared9KeywordArray = ['SES営業', 'マーケティング', 'デジタルマーケ', 'WEBデザイン', '新聞配達', '牛乳配達', 'ブライダルコーディネーター']
          if (this.addressCheck(basicData, systemShared9addressArray)) {
            if (basicData.age >= 18 && basicData.age <= 35) {
              if (formatId.indexOf('shokumukeirekisho') >= 0) {
                // 職務経歴書
                if (this.keywordCheckShokumukeirekisho(formatData, systemShared9KeywordArray)) {
                  isSystemShared9 = true
                }
                if (!isSystemShared9) {
                  if (this.keywordCheckRirekisho(otherFormatData, systemShared9KeywordArray)) {
                    isSystemShared9 = true
                  }
                }
              } else {
                // 履歴書
                if (this.keywordCheckRirekisho(formatData, systemShared9KeywordArray)) {
                  isSystemShared9 = true
                }
                if (!isSystemShared9) {
                  if (this.keywordCheckShokumukeirekisho(otherFormatData, systemShared9KeywordArray)) {
                    isSystemShared9 = true
                  }
                }
              }
            }
          }




          let systemShared10addressArray = ['茨城県', '群馬県', '栃木県', '静岡県', '山梨県']
          let systemShared10KeywordArray = ['IT講師', 'IT研修講師', 'プログラミング講師', '学芸大学', 'インターネットアカデミー', 'トレノケート', 'KENスクール', 'リナックスアカデミー', 'インソース', 'ラーニングエージェンシー', '富士通ラーニングメディア', '株式会社フルネス', '株式会社エンベックスエデュケーション', '株式会社リカレント', '神田ITスクール', '株式会社FusionOne', 'ITカレッジ', 'リゾーム', '株式会社シンクスバンク', '株式会社クロノス', 'SEカレッジ', '株式会社 SEプラス', 'TECHSEED', '株式会社アルバイトタイムス']
          if (this.addressCheck(basicData, systemShared10addressArray)) {
            if (basicData.age >= 18 && basicData.age <= 35) {
              if (formatId.indexOf('shokumukeirekisho') >= 0) {
                // 職務経歴書
                if (this.keywordCheckShokumukeirekisho(formatData, systemShared10KeywordArray)) {
                  isSystemShared10 = true
                }
                if (!isSystemShared10) {
                  if (this.keywordCheckRirekisho(otherFormatData, systemShared10KeywordArray)) {
                    isSystemShared10 = true
                  }
                }
              } else {
                // 履歴書
                if (this.keywordCheckRirekisho(formatData, systemShared10KeywordArray)) {
                  isSystemShared10 = true
                }
                if (!isSystemShared10) {
                  if (this.keywordCheckShokumukeirekisho(otherFormatData, systemShared10KeywordArray)) {
                    isSystemShared10 = true
                  }
                }
              }
            }
          }



          if (this.keywordCheck(formatId, formatData, '施工管理')) {
            if (basicData.age <= 65 && basicData.age >= 20) {
              isJob919_1 = true
            }
          }

          if (this.keywordCheck(formatId, formatData, '監理技術者')) {
            if (basicData.age <= 65 && basicData.age >= 20) {
              isJob919_7 = true
            }
          }
          let job919addressArray = ["和歌山県", "北海道", "兵庫県", "福島県", "福岡県", "福井県", "富山県", "奈良県", "栃木県", "東京都", "長野県", "大分県", "大阪府", "千葉県", "石川県", "静岡県", "青森県", "神奈川県", "新潟県", "秋田県", "鹿児島県", "滋賀県", "山梨県", "山形県", "三重県", "埼玉県", "香川県", "広島県", "群馬県", "熊本県", "京都府", "宮城県", "岐阜県", "岩手県", "沖縄県", "岡山県", "茨城県", "愛媛県", "愛知県"]
          if (this.keywordCheck(formatId, formatData, '自動車整備士')) {
            if (this.addressCheck(basicData, job919addressArray)) {
              if (basicData.age <= 54 && basicData.age >= 20) {
                isJob919_2 = true
              }
            }
          }
          if (this.keywordCheck(formatId, formatData, '自動車検査員')) {
            if (this.addressCheck(basicData, job919addressArray)) {
              if (basicData.age <= 54 && basicData.age >= 20) {
                isJob919_8 = true
              }
            }
          }
          if (this.keywordCheck(formatId, formatData, '板金塗装')
            || this.keywordCheck(formatId, formatData, 'ジーゼル整備士')
            || this.keywordCheck(formatId, formatData, 'ガソリン整備士')
            || this.keywordCheck(formatId, formatData, '自動車整備工')) {
            if (this.addressCheck(basicData, job919addressArray)) {
              if (basicData.age <= 54 && basicData.age >= 20) {
                isJob919_9 = true
              }
            }
          }
          if (this.keywordCheck(formatId, formatData, '建築士')) {
            if (basicData.age <= 65 && basicData.age >= 20) {
              isJob919_3 = true
            }
          }
          if (this.keywordCheck(formatId, formatData, '電気主任技術者')) {
            if (basicData.age <= 65 && basicData.age >= 20) {
              isJob919_4 = true
            }
          }
          let job919_5_addressArray = ['香川県', '北海道', '青森県', '宮城県', '福島県', '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '岐阜県', '静岡県', '愛知県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '岡山県', '広島県', '山口県', '愛媛県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県']
          let job919_5KeywordArray = ['看護師']
          let job919_5NotKeywordArray = ['動物看護']
          if (this.keywordCheck(formatId, formatData, '看護師')
            || this.keywordCheckShokumukeirekisho(formatData, job919_5KeywordArray)) {
            if (this.addressCheck(basicData, job919_5_addressArray)) {
              if (basicData.age <= 39 && basicData.age >= 23) {
                isJob919_5 = true
              }
            }
            if (this.keywordCheckRirekisho(formatData, job919_5NotKeywordArray)
              || this.keywordCheckShokumukeirekisho(formatData, job919_5NotKeywordArray)) {
              isJob919_5 = false
            }
          }

          let job919_6_keywordArray = ['CRA', '臨床開発', 'CRC', '治験', '国際共同治験', '品質管理', '品質保証', '監査対応', '統計解析', 'データマネジメント', 'PMS', 'PV', '薬事', '生産技術', '保全', '設備導入', '臨床検査技師', 'GCP', '医薬', '医療用', '新薬', 'ジェネリック', 'CRO', 'CMO', 'MR', 'バイオ', '細胞治療', '再生医療', '抗体', '遺伝子']
          if (basicData.age >= 20 && basicData.age <= 40) {
            if (formatId.indexOf('shokumukeirekisho') >= 0) {
              // 職務経歴書
              if (this.keywordCheckShokumukeirekisho(formatData, job919_6_keywordArray)) {
                isJob919_6 = true
              }
              if (!isJob919_6) {
                if (this.keywordCheckRirekisho(otherFormatData, job919_6_keywordArray)) {
                  isJob919_6 = true
                }
              }
            } else {
              // 履歴書
              if (this.keywordCheckRirekisho(formatData, job919_6_keywordArray)) {
                isJob919_6 = true
              }
              if (!isJob919_6) {
                if (this.keywordCheckShokumukeirekisho(otherFormatData, job919_6_keywordArray)) {
                  isJob919_6 = true
                }
              }
            }
          }

          if (this.keywordCheck(formatId, formatData, 'ドライバー')) {
            if (basicData.age <= 59 && basicData.age >= 31) {
              isMiraiyu_1 = false
            }
          }
          let miraiyu2addressArray = ['東京都', '神奈川県']
          if (this.addressCheck(basicData, miraiyu2addressArray)) {
            if (basicData.age == 18) {
              isMiraiyu_2 = false
            }
            if (this.keywordCheck(formatId, formatData, '軽貨物') || this.keywordCheck(formatId, formatData, 'トラック') || this.keywordCheck(formatId, formatData, '配送') || this.keywordCheck(formatId, formatData, '長距離') || this.keywordCheck(formatId, formatData, '運送') || this.keywordCheck(formatId, formatData, '物流') || this.keywordCheck(formatId, formatData, '宅配') || this.keywordCheck(formatId, formatData, '運輸') || this.keywordCheck(formatId, formatData, '大型免許') || this.keywordCheck(formatId, formatData, '送迎') || this.keywordCheck(formatId, formatData, '急便') || this.keywordCheck(formatId, formatData, '運行管理') || this.keywordCheck(formatId, formatData, '運転手') || this.keywordCheck(formatId, formatData, 'ロジスティクス')) {
              // if (this.keywordCheck(formatId, formatData, '普通免許') || this.keywordCheck(formatId, formatData, '準中型免許') || this.keywordCheck(formatId, formatData, '中型免許') || this.keywordCheck(formatId, formatData, '大型免許') || this.keywordCheck(formatId, formatData, '大型特殊免許') || this.keywordCheck(formatId, formatData, '牽引（けん引・けんいん）免許') || this.keywordCheck(formatId, formatData, '普通第二種免許') || this.keywordCheck(formatId, formatData, '大型第二種免許') || this.keywordCheck(formatId, formatData, '中型第二種免許') || this.keywordCheck(formatId, formatData, '大型特殊第二種免許') || this.keywordCheck(formatId, formatData, '牽引第二種免許')) {
              if (basicData.age >= 20 && basicData.age <= 59) {
                isMiraiyu_3 = true
              }
              // }
            }
            if (this.keywordCheck(formatId, formatData, 'タクシー') || this.keywordCheck(formatId, formatData, '交通') || this.keywordCheck(formatId, formatData, 'ハイヤー')) {
              // if (this.keywordCheck(formatId, formatData, '普通免許') || this.keywordCheck(formatId, formatData, '準中型免許') || this.keywordCheck(formatId, formatData, '中型免許') || this.keywordCheck(formatId, formatData, '大型免許') || this.keywordCheck(formatId, formatData, '大型特殊免許') || this.keywordCheck(formatId, formatData, '牽引（けん引・けんいん）免許') || this.keywordCheck(formatId, formatData, '普通第二種免許') || this.keywordCheck(formatId, formatData, '大型第二種免許') || this.keywordCheck(formatId, formatData, '中型第二種免許') || this.keywordCheck(formatId, formatData, '大型特殊第二種免許') || this.keywordCheck(formatId, formatData, '牽引第二種免許')) {
              if (basicData.age >= 20 && basicData.age <= 59) {
                isMiraiyu_4 = true
              }
              // }
            }

          }




          let asiro1AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '大阪府', '奈良県', '京都府']
          let asiro1KeywordArray = ['弁護士登録', '司法試験合格']
          if (this.addressCheck(basicData, asiro1AddressArray)) {
            if (basicData.age >= 30 && basicData.age <= 45) {
              if (formatId.indexOf('shokumukeirekisho') >= 0) {
                // 職務経歴書
                if (this.keywordCheckShokumukeirekisho(formatData, asiro1KeywordArray)) {
                  isAsiro_1 = true
                }
                if (!isAsiro_1) {
                  if (this.keywordCheckRirekisho(otherFormatData, asiro1KeywordArray)) {
                    isAsiro_1 = true
                  }
                }
              } else {
                // 履歴書
                if (this.keywordCheckRirekisho(formatData, asiro1KeywordArray)) {
                  isAsiro_1 = true
                }
                if (!isAsiro_1) {
                  if (this.keywordCheckShokumukeirekisho(otherFormatData, asiro1KeywordArray)) {
                    isAsiro_1 = true
                  }
                }
              }
            }
          }

          let problemsolving1AddressArray = ['大阪府', '兵庫県', '京都府', '滋賀県', '奈良県', '和歌山県']
          let problemsolving1KeywordArray = ['看護師']

          let problemsolving2AddressArray = ['香川県', '愛媛県', '徳島県']
          let problemsolving2KeywordArray = ['介護士', 'ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員']

          let isPersolinnovation_1AddressArray = ['東京', '神奈川', '埼玉', '千葉']
          let isPersolinnovation_1KeywordArray = ['介護士', 'ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員']
          if (this.addressCheck(basicData, isPersolinnovation_1AddressArray)) {
            if (this.keywordCheckRirekisho(formatData, isPersolinnovation_1KeywordArray)) {
              if (basicData.age >= 20 && basicData.age <= 34) {
                isPersolinnovation_1 = true

              } else if (basicData.age >= 35 && basicData.age <= 59) {
                isPersolinnovation_2 = true

              }
            }
          }

          let isRecrea_1KeywordArray = ['']
          let isRecrea_1AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '大阪府', '愛知県', '福岡県']
          if (this.addressCheck(basicData, isRecrea_1AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 29) {
              isRecrea_1 = true
            }
          }

          let isPersolinnovation_3AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '大阪府', '愛知県', '福岡県']
          let isPersolinnovation_3NotKeywordArray = ['看護師', '保育士', '栄養士', '施工管理', '自動車整備士', '電気主任技術者', '介護士', 'ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員']
          if (this.addressCheck(basicData, isPersolinnovation_3AddressArray)) {
            if (this.keywordCheckRirekisho(formatData, isPersolinnovation_3NotKeywordArray)) {
              isPersolinnovation_3 = false
            } else {
              if (basicData.age >= 19 && basicData.age <= 29) {
                isPersolinnovation_3 = true

              }
            }
          }

          let isPersolinnovation_4AddressArray = ['北海道', '群馬県', '茨城県', '愛知県', '福島県', '福岡県']
          let isPersolinnovation_4KeywordArray = ['介護士', 'ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員']
          if (this.addressCheck(basicData, isPersolinnovation_4AddressArray)) {
            if (this.keywordCheckRirekisho(formatData, isPersolinnovation_4KeywordArray)) {
              if (basicData.age >= 20 && basicData.age <= 59) {
                isPersolinnovation_4 = true

              }
            }
          }

          if (!(basicData.tel1) ||
            !(basicData.tel2) ||
            !(basicData.tel3)) {
          } else {

            let hrcareer1AddressArray = ['東京都', '千葉県', '神奈川県', '埼玉県', '大阪府', '京都府', '兵庫県']
            let hrcareer1KeywordArray = ['保育士']
            if (this.addressCheck(basicData, hrcareer1AddressArray) || true) {
              if (basicData.age >= 20 && basicData.age <= 50) {
                if (this.keywordCheckRirekisho(formatData, hrcareer1KeywordArray)) {
                  isHrcareer_1 = true
                }
              }
              if (basicData.age <= 34) {
                if (this.keywordCheckRirekisho(formatData, hrcareer1KeywordArray)) {
                  isHrcareer_5 = true
                }
              } else if (basicData.age >= 35) {
                if (this.keywordCheckRirekisho(formatData, hrcareer1KeywordArray)) {
                  isHrcareer_6 = true
                }
              }
            }
            let hrcareer2AddressArray = ['東京都', '千葉県', '神奈川県', '埼玉県', '大阪府', '京都府', '兵庫県', '北海道']
            let hrcareer2KeywordArray = ['看護']

            let hrcareer2NotInKeywordArray = ['動物', '中退']
            if (this.addressCheck(basicData, hrcareer2AddressArray) || true) {
              if (this.keywordCheckRirekisho(formatData, hrcareer2KeywordArray)) {
                isHrcareer_2 = true
              }
              if (basicData.age <= 34) {
                if (this.keywordCheckRirekisho(formatData, hrcareer2NotInKeywordArray)) {
                  isHrcareer_7 = false
                } else if (this.keywordCheckRirekisho(formatData, hrcareer2KeywordArray)) {
                  isHrcareer_7 = true
                }
              } else if (basicData.age >= 35) {
                if (this.keywordCheckRirekisho(formatData, hrcareer2NotInKeywordArray)) {
                  isHrcareer_8 = false
                } else if (this.keywordCheckRirekisho(formatData, hrcareer2KeywordArray)) {
                  isHrcareer_8 = true
                }
              }
            }


            // let hrcareer3AddressArray = ['東京都', '千葉県', '神奈川県', '埼玉県', '大阪府', '京都府', '兵庫県', '静岡県', '北海道']
            let hrcareer3AddressArray = ['東京都', '神奈川県']
            let temphrcareerAddressArray = ['大阪府', '兵庫県', '東京都', '神奈川県', '千葉県', '埼玉県']
            let hrcareer3KeywordArray = ['介護士', 'ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員', 'ヘルパー２級', 'ヘルパー１級', 'ヘルパー二級', 'ヘルパー一級']
            if (true) {
              if (this.keywordCheckRirekisho(formatData, hrcareer3KeywordArray)) {
                isHrcareer_3 = true
              }
              if (basicData.age <= 34) {
                if (this.keywordCheckRirekisho(formatData, hrcareer3KeywordArray)) {
                  isHrcareer_9 = true
                }
              } else if (basicData.age >= 35) {
                if (this.keywordCheckRirekisho(formatData, hrcareer3KeywordArray)) {
                  isHrcareer_10 = true
                }
              }
            }

            // 北海道、東京、神奈川、大阪、兵庫
            hrcareer3AddressArray = ['東京都', '北海道', '神奈川県', '大阪府', '兵庫県']

            if (this.addressCheck(basicData, hrcareer3AddressArray)) {
              if (basicData.age <= 34) {
                if (this.keywordCheckRirekisho(formatData, hrcareer3KeywordArray)) {
                  isHrcareer_13 = true
                }
              } else if (basicData.age >= 35) {
                if (this.keywordCheckRirekisho(formatData, hrcareer3KeywordArray)) {
                  isHrcareer_14 = true
                }
              }
            }
            let hrcareer4AddressArray = ['東京都', '千葉県', '神奈川県', '埼玉県', '大阪府', '兵庫県']
            let hrcareer4KeywordArray = ['栄養士']
            if (true) {
              if (basicData.age >= 20 && basicData.age <= 55) {
                if (this.keywordCheckRirekisho(formatData, hrcareer4KeywordArray)) {
                  isHrcareer_4 = true
                }
              }
              if (basicData.age <= 34) {
                if (this.keywordCheckRirekisho(formatData, hrcareer4KeywordArray)) {
                  isHrcareer_11 = true
                }
              } else if (basicData.age >= 35) {
                if (this.keywordCheckRirekisho(formatData, hrcareer4KeywordArray)) {
                  isHrcareer_12 = true
                }
              }
            }

            let hrcareer15KeywordArray = ['建築士', '宅地建物取引士', '宅建']
            if (true) {
              if (this.keywordCheckRirekisho(formatData, hrcareer15KeywordArray)) {
                isHrcareer_15 = true
              }
            }

          }


          let isLeverages_1KeywordArray = ['保育士']
          let isLeverages_1AddressArray = ['東京都', '神奈川県', '大阪府', '兵庫県', '愛知県']
          if (this.addressCheck(basicData, isLeverages_1AddressArray)) {
            if (basicData.age >= 29 && basicData.age <= 39) {
              if (this.keywordCheckRirekisho(formatData, isLeverages_1KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isLeverages_1KeywordArray)) {
                isLeverages_1 = true
              }
            }
          }

          let asiro2AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '大阪府', '奈良県', '京都府']
          let asiro2KeywordArray = ['公認会計士', '監査法人']
          if (this.addressCheck(basicData, asiro2AddressArray)) {
            if (basicData.age >= 30 && basicData.age <= 45) {
              if (formatId.indexOf('shokumukeirekisho') >= 0) {
                // 職務経歴書
                if (this.keywordCheckShokumukeirekisho(formatData, asiro2KeywordArray)) {
                  isAsiro_2 = true
                }
                if (!isAsiro_2) {
                  if (this.keywordCheckRirekisho(otherFormatData, asiro2KeywordArray)) {
                    isAsiro_2 = true
                  }
                }
              } else {
                // 履歴書
                if (this.keywordCheckRirekisho(formatData, asiro2KeywordArray)) {
                  isAsiro_2 = true
                }
                if (!isAsiro_2) {
                  if (this.keywordCheckShokumukeirekisho(otherFormatData, asiro2KeywordArray)) {
                    isAsiro_2 = true
                  }
                }
              }
            }
          }

          let asiro3AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '大阪府', '奈良県', '京都府']
          let asiro3KeywordArray = ['税理士', '税理士法人', '税理士科目合格']
          if (this.addressCheck(basicData, asiro3AddressArray)) {
            if (basicData.age >= 30 && basicData.age <= 45) {
              if (formatId.indexOf('shokumukeirekisho') >= 0) {
                // 職務経歴書
                if (this.keywordCheckShokumukeirekisho(formatData, asiro3KeywordArray)) {
                  isAsiro_3 = true
                }
                if (!isAsiro_3) {
                  if (this.keywordCheckRirekisho(otherFormatData, asiro3KeywordArray)) {
                    isAsiro_3 = true
                  }
                }
              } else {
                // 履歴書
                if (this.keywordCheckRirekisho(formatData, asiro3KeywordArray)) {
                  isAsiro_3 = true
                }
                if (!isAsiro_3) {
                  if (this.keywordCheckShokumukeirekisho(otherFormatData, asiro3KeywordArray)) {
                    isAsiro_3 = true
                  }
                }
              }
            }
          }

          let asiro4AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '大阪府', '奈良県', '京都府']
          let asiro4KeywordArray = ['労務', '制度設計', '採用支援']
          if (this.addressCheck(basicData, asiro4AddressArray)) {
            if (basicData.age >= 30 && basicData.age <= 45) {
              if (formatId.indexOf('shokumukeirekisho') >= 0) {
                // 職務経歴書
                if (this.keywordCheckShokumukeirekisho(formatData, asiro4KeywordArray)) {
                  isAsiro_4 = true
                }
                if (!isAsiro_4) {
                  if (this.keywordCheckRirekisho(otherFormatData, asiro4KeywordArray)) {
                    isAsiro_4 = true
                  }
                }
              } else {
                // 履歴書
                if (this.keywordCheckRirekisho(formatData, asiro4KeywordArray)) {
                  isAsiro_4 = true
                }
                if (!isAsiro_4) {
                  if (this.keywordCheckShokumukeirekisho(otherFormatData, asiro4KeywordArray)) {
                    isAsiro_4 = true
                  }
                }
              }
            }
          }


          let asiro5AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '大阪府', '奈良県', '京都府']
          let asiro5KeywordArray = ['財務', '会計基準', 'FRS', '簿記１級', '月次決算', '年次決算']
          if (this.addressCheck(basicData, asiro5AddressArray)) {
            if (basicData.age >= 30 && basicData.age <= 45) {
              if (formatId.indexOf('shokumukeirekisho') >= 0) {
                // 職務経歴書
                if (this.keywordCheckShokumukeirekisho(formatData, asiro5KeywordArray)) {
                  isAsiro_5 = true
                }
                if (!isAsiro_5) {
                  if (this.keywordCheckRirekisho(otherFormatData, asiro5KeywordArray)) {
                    isAsiro_5 = true
                  }
                }
              } else {
                // 履歴書
                if (this.keywordCheckRirekisho(formatData, asiro5KeywordArray)) {
                  isAsiro_5 = true
                }
                if (!isAsiro_5) {
                  if (this.keywordCheckShokumukeirekisho(otherFormatData, asiro5KeywordArray)) {
                    isAsiro_5 = true
                  }
                }
              }
            }
          }


          let asiro6AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '大阪府', '奈良県', '京都府']
          let asiro6KeywordArray = ['法務部', '法務担当', 'ビジネス法務検定']
          if (this.addressCheck(basicData, asiro6AddressArray)) {
            if (basicData.age >= 30 && basicData.age <= 45) {
              if (formatId.indexOf('shokumukeirekisho') >= 0) {
                // 職務経歴書
                if (this.keywordCheckShokumukeirekisho(formatData, asiro6KeywordArray)) {
                  isAsiro_6 = true
                }
                if (!isAsiro_6) {
                  if (this.keywordCheckRirekisho(otherFormatData, asiro6KeywordArray)) {
                    isAsiro_6 = true
                  }
                }
              } else {
                // 履歴書
                if (this.keywordCheckRirekisho(formatData, asiro6KeywordArray)) {
                  isAsiro_6 = true
                }
                if (!isAsiro_6) {
                  if (this.keywordCheckShokumukeirekisho(otherFormatData, asiro6KeywordArray)) {
                    isAsiro_6 = true
                  }
                }
              }
            }
          }



          let capla1AddressArray = ['岡山県']
          let capla1KeywordArray = ['看護師']
          if (this.addressCheck(basicData, capla1AddressArray)) {
            if (basicData.age >= 40 && basicData.age <= 49) {
              if (formatId.indexOf('shokumukeirekisho') >= 0) {
                // 職務経歴書
                if (this.keywordCheckShokumukeirekisho(formatData, capla1KeywordArray)) {
                  isCapla_1 = true
                }
                if (!isCapla_1) {
                  if (this.keywordCheckRirekisho(otherFormatData, capla1KeywordArray)) {
                    isCapla_1 = true
                  }
                }
              } else {
                // 履歴書
                if (this.keywordCheckRirekisho(formatData, capla1KeywordArray)) {
                  isCapla_1 = true
                }
                if (!isCapla_1) {
                  if (this.keywordCheckShokumukeirekisho(otherFormatData, capla1KeywordArray)) {
                    isCapla_1 = true
                  }
                }
              }
            }
          }

          let capla2AddressArray = ['岡山県', '広島県']
          let capla2KeywordArray = ['介護福祉士', '初任者研修', '実務者研修', 'ヘルパー']
          if (this.addressCheck(basicData, capla2AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 49) {
              if (formatId.indexOf('shokumukeirekisho') >= 0) {
                // 職務経歴書
                if (this.keywordCheckShokumukeirekisho(formatData, capla2KeywordArray)) {
                  isCapla_2 = true
                }
                if (!isCapla_2) {
                  if (this.keywordCheckRirekisho(otherFormatData, capla2KeywordArray)) {
                    isCapla_2 = true
                  }
                }
              } else {
                // 履歴書
                if (this.keywordCheckRirekisho(formatData, capla2KeywordArray)) {
                  isCapla_2 = true
                }
                if (!isCapla_2) {
                  if (this.keywordCheckShokumukeirekisho(otherFormatData, capla2KeywordArray)) {
                    isCapla_2 = true
                  }
                }
              }
            }
          }


          let isAdtop = false
          if (basicData.age < 35) {
            isAdtop = true
          }
          isAdtop = false

          let isRoxx = false
          let roxxaddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '大阪府', '兵庫県', '京都府', '奈良県', '滋賀県', '三重県', '愛知県', '福岡県', '静岡県', '岐阜県', '札幌市', '仙台市', '新潟市', '広島市', '岡山市', '熊本市']
          if (this.addressCheck(basicData, roxxaddressArray)) {
            if (basicData.age >= 19 && basicData.age <= 30) {
              isRoxx = true
            }
          }

          let isRoxx2 = false
          let roxxaddressArray2 = ['東京都', '神奈川県', '千葉県', '埼玉県', '大阪府', '兵庫県', '京都府', '奈良県', '滋賀県', '三重県', '愛知県', '福岡県', '静岡県', '岐阜県', '札幌市', '仙台市', '新潟市', '広島市', '岡山市', '熊本市']
          if (this.addressCheck(basicData, roxxaddressArray2)) {
            if (basicData.age >= 31 && basicData.age <= 34) {
              isRoxx2 = true
            }
          }

          let isRoxx3 = false
          let roxxaddressArray3 = ['東京都', '神奈川県', '千葉県', '埼玉県', '大阪府', '兵庫県', '京都府', '奈良県', '滋賀県', '三重県', '愛知県', '福岡県', '静岡県', '岐阜県', '札幌市', '仙台市', '新潟市', '広島市', '岡山市', '熊本市']


          let isRoxx_4 = false
          let roxxaddressArray4 = ['東京都', '神奈川県', '千葉県', '埼玉県', '大阪府', '兵庫県', '京都府', '奈良県', '滋賀県', '三重県', '愛知県', '福岡県', '静岡県', '岐阜県', '札幌市', '仙台市', '新潟市', '広島市', '岡山市', '熊本市']


          let isRoxx_5 = false
          let roxxaddressArray5 = ['茨城県', '群馬県', '栃木県']



          if (this.addressCheck(basicData, roxxaddressArray3)) {
            if (basicData.age >= 19 && basicData.age <= 29 && (formatData.gradeYear == 24 || formatData.gradeYear == 25)) {
              isRoxx3 = true
            }
          }

          if (this.addressCheck(basicData, roxxaddressArray4)) {
            if (basicData.age >= 19 && basicData.age <= 29) {
              if (formatData.gradeYear == '' || !(formatData.gradeYear !== undefined)) {
                isRoxx_4 = true
              }
            }
          }

          if (this.addressCheck(basicData, roxxaddressArray5)) {
            if (basicData.age >= 19 && basicData.age <= 29) {
              isRoxx_5 = true
            }
          }

          let roxx_ng_keyword_array = ['看護師', '保育士', '栄養士', '施工管理', '自動車整備士', '電気主任技術者', '介護士', 'ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員']


          if (this.keywordCheckRirekisho(formatData, roxx_ng_keyword_array)) {
            // isRoxx = false
            // isRoxx2 = false
            // isRoxx3 = false
            // isRoxx_4 = false
            isRoxx_5 = false
          }

          if (!(basicData.tel1) ||
            !(basicData.tel2) ||
            !(basicData.tel3)) {
            isRoxx = false
            isRoxx2 = false
            isRoxx3 = false
            isRoxx_4 = false
            isRoxx_5 = false
          }

          if (!(formatData.gradeYear)) {
            if (!formatData.foreignStudent) {
              if (this.keywordCheck(formatId, formatData, '大学')) {
                if (basicData.age >= 20 && basicData.age <= 28) {
                  isCareerdraft_1 = true
                }
              }
            }
          }

          if (formatData.gradeYear == 26) {
            if (!formatData.foreignStudent) {
              if (this.keywordCheck(formatId, formatData, '大学')) {
                if (basicData.age >= 20 && basicData.age <= 28) {
                  isCareerdraft_2 = true
                }
              }
            }
          }
          if (formatData.gradeYear == 27) {
            if (!formatData.foreignStudent) {
              if (this.keywordCheck(formatId, formatData, '大学')) {
                if (basicData.age >= 20 && basicData.age <= 28) {
                  isCareerdraft_3 = true
                }
              }
            }
          }

          if (formatData.gradeYear == 26) {
            if (this.keywordCheck(formatId, formatData, '大学')) {
              if (basicData.age >= 19 && basicData.age <= 25) {
                isRoxx_6 = true
              }
            }
          }
          if (basicData.age >= 19 && basicData.age <= 29) {
            isRoxx_7 = true
          }
          let isTaikennyusha_1KeywordArray = ['コミュニケーション']
          let isTaikennyusha_1AddressArray = ['宮城県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '新潟県', '長野県', '千葉県', '埼玉県', '東京都', '神奈川県', '静岡県', '愛知県', '富山県', '岐阜県', '三重県', '滋賀県', '大阪府', '奈良県', '京都府', '兵庫県', '鳥取県', '島根県', '岡山県', '広島県', '山口県', '福岡県', '沖縄県']
          if (this.addressCheck(basicData, isTaikennyusha_1AddressArray)) {
            if (basicData.age >= 21 && basicData.age <= 34) {
              if (this.keywordCheckRirekisho(formatData, isTaikennyusha_1KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isTaikennyusha_1KeywordArray)) {
                isTaikennyusha_1 = true
              }
              isTaikennyusha_1 = true
            }
          }
          let isTaikennyusha_2KeywordArray = ['コミュニケーション']
          let isTaikennyusha_2AddressArray = ['宮城県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '新潟県', '長野県', '千葉県', '埼玉県', '東京都', '神奈川県', '静岡県', '愛知県', '富山県', '岐阜県', '三重県', '滋賀県', '大阪府', '奈良県', '京都府', '兵庫県', '鳥取県', '島根県', '岡山県', '広島県', '山口県', '福岡県', '沖縄県']
          if (this.addressCheck(basicData, isTaikennyusha_2AddressArray)) {
            if (basicData.age >= 21 && basicData.age <= 34) {
              if (this.keywordCheckRirekisho(formatData, isTaikennyusha_2KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isTaikennyusha_2KeywordArray)) {
                isTaikennyusha_2 = true
              }
              isTaikennyusha_2 = true
            }
          }

          if (formatData.gradeYear == 26) {
            isHitotech_1 = true
          }
          let isHitotech_2addressArray = ['愛知県', '石川県', '新潟県', '福井県', '山口県', '岡山県', '広島県', '香川県', '愛媛県', '高知県', '富山県', '長野県', '鳥取県', '島根県', '徳島県']
          if (formatData.gradeYear == 25) {
            if (this.addressCheck(basicData, isHitotech_2addressArray)) {
              isHitotech_2 = true
            }
          }

          let isHitotech_3addressArray = ['北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '山梨県', '岐阜県', '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県']
          if (formatData.gradeYear == 25) {
            if (this.addressCheck(basicData, isHitotech_3addressArray)) {
              isHitotech_3 = true
            }
          }
          if (!formatData.gradeYear) {
            isHitotech_4 = true
          }


          let bridge1addressArray = ['東京都', '埼玉県', '神奈川県', '千葉県']
          let bridge1KeywordArray = ['USCPA', 'IPO準備', '株式公開', '上場準備', 'ファイナンス', '決算', '開示', '管理会計', '税務', '資金調達', '原価計算', '人事評価', '人事制度', '社会保険労務士', 'リスクマネジメント', '内部統制', '監査役', '経営企画', '情報セキュリティ', 'コンサルタント', 'ファンド', '投資銀行']
          if (this.addressCheck(basicData, bridge1addressArray)) {
            if (basicData.age >= 25 && basicData.age <= 45) {
              console.error(formatData)
              if (this.keywordCheckRirekisho(formatData, bridge1KeywordArray)) {
                isBridge_1 = true
              }
            }
          }
          console.error(isBridge_1)


          let rozas1addressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '茨城県', '群馬県', '栃木県']
          let rozas1KeywordArray = ['看護師']
          let rozas1NotKeywordArray = ['動物看護', '助手']
          if (this.addressCheck(basicData, rozas1addressArray)) {
            if (basicData.age >= 22 && basicData.age <= 55) {
              console.error(formatData)
              if (this.keywordCheckRirekisho(formatData, rozas1KeywordArray)) {
                isRozas_1 = true
              }
              if (this.keywordCheckRirekisho(formatData, rozas1NotKeywordArray)) {
                isRozas_1 = false
              }
            }
          }
          let isRozas_2KeywordArray = ['医療事務', '調剤事務', '外来クラーク', '病棟クラーク', 'レセプト業務', 'メディカルクラーク', '診療報酬請求事務能力認定試験', '医事オペレータ技能認定試験']
          let isRozas_2AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '群馬県', '栃木県', '茨城県', '大阪府', '兵庫県', '静岡県', '岐阜県', '宮崎県', '福岡県']
          let rozas2NotKeywordArray = ['ホテル']
          if (this.addressCheck(basicData, isRozas_2AddressArray)) {
            if (basicData.age >= 22 && basicData.age <= 55) {
              if (this.keywordCheckRirekisho(formatData, isRozas_2KeywordArray)) {
                isRozas_2 = true
              }
              if (this.keywordCheckRirekisho(formatData, rozas2NotKeywordArray)) {
                isRozas_2 = false
              }
            }
          }
          let isRozas_3KeywordArray = ['臨床検査技師', '診療放射線技師']
          let isRozas_3AddressArray = ['']
          if (true) {
            if (basicData.age >= 22 && basicData.age <= 50) {
              if (this.keywordCheckRirekisho(formatData, isRozas_3KeywordArray)) {
                isRozas_3 = true
              }
            }
          }
          let isRozas_4KeywordArray = ['1級自動車整備士', '2級自動車整備士', '3級自動車整備士', '一級自動車整備士', '二級自動車整備士', '三級自動車整備士']
          let isRozas_4AddressArray = ['']
          if (true) {
            if (basicData.age >= 22 && basicData.age <= 50) {
              if (this.keywordCheckRirekisho(formatData, isRozas_4KeywordArray)) {
                isRozas_4 = true
              }
            }
          }
          let isRozas_5KeywordArray = ['看護助手', '社会福祉士', '精神保健福祉士', '社会福祉主事任用資格', '介護福祉士', '介護支援専門員', 'ケアマネジャー', 'ケアマネージャー', '介護職員初任者研修', '介護福祉士実務者研修']
          let isRozas_5AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '群馬県', '栃木県', '茨城県', '愛知県', '静岡県', '大阪府', '兵庫県']
          let rozas5NotKeywordArray = ['スクール']
          if (this.addressCheck(basicData, isRozas_5AddressArray)) {
            if (basicData.age >= 22 && basicData.age <= 55) {
              if (this.keywordCheckRirekisho(formatData, isRozas_5KeywordArray)) {
                isRozas_5 = true
              }
              if (this.keywordCheckRirekisho(formatData, rozas5NotKeywordArray)) {
                isRozas_5 = false
              }
            }
          }

          let tunaguba1addressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '愛知県', '大阪府', '福岡県']
          let tunaguba1KeywordArray = ['未経験', 'スキルアップ', '大学', '免許']
          if (this.addressCheck(basicData, tunaguba1addressArray)) {
            if (basicData.age >= 18 && basicData.age <= 32) {
              if (this.keywordCheckRirekisho(formatData, tunaguba1KeywordArray)) {
                isTunaguba_1 = true
              }
            }
          }

          let dely1addressArray = ['東京都']
          let dely1KeywordArray = ['免許']
          let dely1NotInKeywordArray = ['週1', '週2', '週3', '週4']
          if (this.addressCheck(basicData, dely1addressArray)) {
            if (basicData.age >= 22 && basicData.age <= 29) {
              if (this.keywordCheckRirekisho(formatData, dely1NotInKeywordArray)) {
                isDely_1 = false
              } else if (this.keywordCheckRirekisho(formatData, dely1KeywordArray)) {
                isDely_1 = true
              }
            }
          }

          let workport1addressArray = ['佐賀県', '長崎県', '大分県', '熊本県', '宮崎県', '鹿児島県', '沖縄県', '広島県', '岡山県', '島根県', '鳥取県', '山口県', '香川県', '愛媛県', '高知県', '徳島県', '青森県', '秋田県', '岩手県', '山形県', '宮城県', '福県島', '石川県', '富山県', '福井県', '新潟県', '長野県']
          let workport1NotAddressArray = ['仙台市', '新潟市', '広島市', '岡山市', '熊本市']
          let workport1KeywordArray = ['エンジニア']
          if (this.addressCheck(basicData, workport1addressArray)) {
            if (this.addressCheck(basicData, workport1NotAddressArray)) {
              //なし
            } else {
              if (basicData.age >= 20 && basicData.age <= 45) {
                if (this.keywordCheckRirekisho(formatData, workport1KeywordArray)
                  || this.keywordCheckShokumukeirekisho(formatData, workport1KeywordArray)) {
                  isWorkport_1 = true
                }
              }
            }
          }
          let workport4addressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '大阪府', '兵庫県', '京都府', '奈良県', '滋賀県', '和歌山県', '愛知県', '福岡県', '静岡県', '岐阜県', '北海道', '宮城県', '新潟県', '岡山県', '広島県', '熊本県']
          let workport4KeywordArray = ['エンジニア']
          if (this.addressCheck(basicData, workport4addressArray)) {
            if (basicData.age >= 35 && basicData.age <= 42) {
              if (this.keywordCheckRirekisho(formatData, workport4KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, workport4KeywordArray)) {
                isWorkport_4 = true
              }
            }
          }
          let workport2KeywordArray = ['経理']
          if (this.addressCheck(basicData, workport1addressArray)) {
            if (this.addressCheck(basicData, workport1NotAddressArray)) {
              //なし
            } else {
              if (basicData.age >= 20 && basicData.age <= 45) {
                if (this.keywordCheckRirekisho(formatData, workport2KeywordArray)
                  || this.keywordCheckShokumukeirekisho(formatData, workport2KeywordArray)) {
                  isWorkport_2 = true
                }
              }
            }
          }
          let workport3KeywordArray = ['営業']
          if (this.addressCheck(basicData, workport1addressArray)) {
            if (this.addressCheck(basicData, workport1NotAddressArray)) {
              //なし
            } else {
              if (basicData.age >= 20 && basicData.age <= 45) {
                if (this.keywordCheckRirekisho(formatData, workport3KeywordArray)
                  || this.keywordCheckShokumukeirekisho(formatData, workport3KeywordArray)) {
                  isWorkport_3 = true
                }
              }
            }
          }


          let loginess1addressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '静岡県']
          let loginess1KeywordArray = ['トラックドライバー', '長距離トラック', '長距離輸送', '大型免許', '準中型免許', '中型免許', 'フォークリフト']



          let agrinavi1addressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '大阪府', '京都府', '兵庫県', '和歌山県', '奈良県', '京都県', '滋賀県', '愛知県', '福岡県', '岐阜県', '静岡県']
          let agrinavi1KeywordArray = ['農業']
          if (this.addressCheck(basicData, agrinavi1addressArray)) {
            if (basicData.age >= 20 && basicData.age <= 34) {
              if (this.keywordCheckRirekisho(formatData, agrinavi1KeywordArray)) {
                isAgrinavi_1 = true
              }
            }
          }


          let techouse1addressArray = ['愛知県', '栃木県']
          let techouse1KeywordArray = ['工場', '製造', '期間工', '溶接', 'フォークリフト']
          if (this.addressCheck(basicData, techouse1addressArray)) {
            if (basicData.age >= 20 && basicData.age <= 45) {
              if (this.keywordCheckRirekisho(formatData, techouse1KeywordArray)) {
                isTechouse_1 = true
              }
            }
          } else {
            if (basicData.age >= 20 && basicData.age <= 45) {
              if (this.keywordCheckRirekisho(formatData, techouse1KeywordArray)) {
                isTechouse_2 = true
              }
            }
          }

          let techouse3addressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '愛知県', '大阪府']
          let techouse3KeywordArray = ['運輸', '運送', '物流', '配送', 'ドライバー', 'トラックドライバー', '長距離トラック', '長距離輸送', '大型免許', '準中型免許', '中型免許', '軽貨物']
          if (this.addressCheck(basicData, techouse3addressArray)) {
            if (basicData.age >= 20 && basicData.age <= 59) {
              if (this.keywordCheckRirekisho(formatData, techouse3KeywordArray)) {
                isTechouse_3 = true
              }
            }
          }

          let isOutsourcing_1addressArray = ['兵庫県', '滋賀県', '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '神奈川県', '福岡県', '大分県', '静岡県', '北海道', '愛知県', '三重県']
          let isOutsourcing_1Array = ['日総工産株式会社', '日研トータルソーシング株式会社', '', 'UTエイム株式会社', 'Man to Man株式会社', '日総工産', '日研トータルソーシング', 'UTエイム', 'Man to Man']
          let isOutsourcing_1NotKeyArray = ['製菓']
          // if (this.addressCheck(basicData, isOutsourcing_1addressArray)) {
          if (true) {
            if (basicData.age >= 18 && basicData.age <= 44) {
              if (this.keywordCheckRirekisho(formatData, isOutsourcing_1Array)
                || this.keywordCheckShokumukeirekisho(formatData, isOutsourcing_1Array)) {
                isOutsourcing_1 = true
              }
              // if (this.keywordCheckRirekisho(formatData, isOutsourcing_1NotKeyArray)
              //   || this.keywordCheckShokumukeirekisho(formatData, isOutsourcing_1NotKeyArray)) {
              //   isOutsourcing_1 = false
              // }
            }
          }


          // let isHitolabo_1AddressArray = ['東京都', '神奈川県', '埼玉県', '大阪府', '京都府', '兵庫県']
          let isHitolabo_1AddressArray = ['東京都', '神奈川県']
          let isHitolabo_1KeywordArray = ['調理師']
          if (this.addressCheck(basicData, isHitolabo_1AddressArray)) {
            if (basicData.age >= 21 && basicData.age <= 53) {
              if (this.keywordCheckRirekisho(formatData, isHitolabo_1KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isHitolabo_1KeywordArray)) {
                isHitolabo_1 = true
              }
            }
          }
          // let isHitolabo_2AddressArray = ['東京都', '神奈川県', '埼玉県', '大阪府', '京都府', '兵庫県']
          let isHitolabo_2AddressArray = ['東京都', '神奈川県']
          let isHitolabo_2KeywordArray = ['栄養士']
          if (this.addressCheck(basicData, isHitolabo_2AddressArray)) {
            if (basicData.age >= 21 && basicData.age <= 53) {
              if (this.keywordCheckRirekisho(formatData, isHitolabo_2KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isHitolabo_2KeywordArray)) {
                isHitolabo_2 = true
              }
            }
          }

          let isCookbiz_1NotaddressArray = ['東京都', '愛知県', '大阪府']
          let isCookbiz_1KeywordArray = ['調理師', '料理人', '板前', 'シェフ', '食品衛生責任者', 'レストランサービス技能士', '料理長', '支配人', 'ソムリエ', 'バーテンダー']
          if (false) {
            // 除外
          } else {
            if (basicData.age >= 20 && basicData.age <= 45) {
              if (this.keywordCheckRirekisho(formatData, isCookbiz_1KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isCookbiz_1KeywordArray)) {
                isCookbiz_1 = true
              }
            }
          }
          let isCookbiz_2NotaddressArray = ['東京都', '愛知県', '大阪府']
          let isCookbiz_2KeywordArray = ['飲食', '接客']
          if (this.addressCheck(basicData, isCookbiz_2NotaddressArray)) {
            // 除外
          } else {
            if (basicData.age >= 20 && basicData.age <= 35) {
              if (this.keywordCheckRirekisho(formatData, isCookbiz_2KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isCookbiz_2KeywordArray)) {
                isCookbiz_2 = true
              }
            }
          }
          let isCookbiz_3NotaddressArray = ['東京都', '愛知県', '大阪府']
          let isCookbiz_3KeywordArray = ['飲食', '接客']
          if (false) {
            // 除外
          } else {
            isCookbiz_3 = true
          }


          let isFoodison_1AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '京都府', '大阪府', '兵庫県', '愛知県']
          let isFoodison_1KeywordArray = ['和食', 'イタリアン', 'フレンチ', 'ビストロ', '中華', 'チェーン店', '料理長', 'キッチンチーフ', 'シェフ', 'メニュー開発']
          let isFoodison_1NotKeywordArray = ['接客', '集団調理', 'カフェ', '調理師']
          if (this.addressCheck(basicData, isFoodison_1AddressArray)) {
            if (basicData.age >= 23 && basicData.age <= 50) {
              if (this.keywordCheckRirekisho(formatData, isFoodison_1KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isFoodison_1KeywordArray)) {
                isFoodison_1 = true
              }
              if (this.keywordCheckRirekisho(formatData, isFoodison_1NotKeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isFoodison_1NotKeywordArray)) {
                isFoodison_1 = false
              }
            }
          }

          let isFoodison_2AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '京都府', '大阪府', '兵庫県']
          let isFoodison_2KeywordArray = ['スーパー']
          let isFoodison_2NotKeywordArray = ['接客', '集団調理']
          if (this.addressCheck(basicData, isFoodison_2AddressArray)) {
            if (basicData.age >= 28 && basicData.age <= 50) {
              if (this.keywordCheckRirekisho(formatData, isFoodison_2KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isFoodison_2KeywordArray)) {
                isFoodison_2 = true
              }
              // if (this.keywordCheckRirekisho(formatData, isFoodison_2NotKeywordArray)
              //   || this.keywordCheckShokumukeirekisho(formatData, isFoodison_2NotKeywordArray)) {
              //   isFoodison_2 = false
              // }
            }
          }

          let isFoodison_3NotAddressArray = ['北海道']
          let isFoodison_3KeywordArray = ['鮮魚部門', '精肉部門', '鮮魚加工', '精肉加工', '魚売場', '魚屋']
          let isFoodison_3NotKeywordArray = ['接客', '集団調理']
          if (this.addressCheck(basicData, isFoodison_3NotAddressArray)) {
            // なし
          } else {
            if (basicData.age >= 28 && basicData.age <= 50) {
              if (this.keywordCheckRirekisho(formatData, isFoodison_3KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isFoodison_3KeywordArray)) {
                isFoodison_3 = true
              }
              // if (this.keywordCheckRirekisho(formatData, isFoodison_2NotKeywordArray)
              //   || this.keywordCheckShokumukeirekisho(formatData, isFoodison_2NotKeywordArray)) {
              //   isFoodison_2 = false
              // }
            }
          }

          let isOishiru_1KeywordArray = ['スーパーマーケット', '鮮魚部', '水産部', '精肉部', '畜産部', '青果部', '農産部', '惣菜部', '総菜部', '鮮魚加工', '精肉加工', '魚売場', '魚売り場', '水産売場', '水産売り場', '魚屋', '精肉売場', '精肉売り場', '鮮魚店', '鮮魚専門店', '精肉店', '精肉専門店', 'バックヤード', '株式会社魚力', '株式会社魚喜', '角上魚類', '株式会社山助', '北辰水産', '北海道北辰', '東海北辰', '仙冷平庄', '鈴木水産', '株式会社NFT', 'タカマル鮮魚店', '旬フーズシステム', '魚太郎', '魚錠', '鮮魚丸忠', '髭定', '大起水産', '鮮魚たかぎ', '株式会社西浅', '最上鮮魚', 'ミートテラバヤシ', 'タカギフーズ', '株式会社天池', '伊藤ハムフードソリューション', '大三ミート産業', 'オーエムツーミート', 'オーエムツーネットワーク', '株式会社九州屋', '旬八青果', 'スーパーバリュー', '株式会社ロピア', '株式会社イオン', 'イトーヨーカ堂', '業務スーパー', '食品スーパー', '食品館', 'イオンリテール']
          let isOishiru_1NotKeywordArray = ['イトーヨーカ堂へ', 'イトーヨーカ堂に', 'イトーヨーカ堂と', 'イトーヨーカ堂を', 'バックヤードの']
          let isOishiru_1AddressArray = ['北海道', '宮城県', '東京都', '神奈川県', '千葉県', '埼玉県', '愛知県', '大阪府', '兵庫県', '福岡県', '沖縄県']
          if (this.addressCheck(basicData, isOishiru_1AddressArray)) {
            if (basicData.age >= 23 && basicData.age <= 55) {
              if (this.keywordCheckRirekisho(formatData, isOishiru_1KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isOishiru_1KeywordArray)) {
                isOishiru_1 = true
              }
            }
            if (this.keywordCheckRirekisho(formatData, isOishiru_1NotKeywordArray)
              || this.keywordCheckShokumukeirekisho(formatData, isOishiru_1NotKeywordArray)) {
              isOishiru_1 = false
            }
          }


          let isHayfield_1KeywordArray = ['営業', 'コミュニケーション能力']
          let isHayfield_1AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '北海道', '愛知県', '大阪府', '兵庫県', '福岡県', '静岡県']

          if (this.addressCheck(basicData, isHayfield_1AddressArray)) {
            if (basicData.age >= 22 && basicData.age <= 43) {
              if (this.keywordCheckRirekisho(formatData, isHayfield_1KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isHayfield_1KeywordArray)) {
                isHayfield_1 = true
              }
            }
          }

          let isItk_1KeywordArray = ['キッチン', '調理', '飲食', '店長', 'ホールスタッフ']
          let isItk_1AddressArray = ['東京都', '神奈川県']
          if (this.addressCheck(basicData, isItk_1AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 35) {
              if (this.keywordCheckRirekisho(formatData, isItk_1KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isItk_1KeywordArray)) {
                isItk_1 = true
              }
            }
          }

          let isPrimalwork_1addressArray = ['東京都']
          // let isPrimalwork_1_1KeywordArray = ['保守', 'メンテナンス', '修理', '点検', '警備', '配送', '配達', '夜勤', '配達', '指導', 'レクチャー', 'バイトリーダー', 'ホール', 'シフトリーダー', '調理', 'リーダー', '正社員', '成長', '挑戦', 'セールス', 'テレアポ', '受注', '発注', 'アシスタント']
          // let isPrimalwork_1_2KeywordArray = ['鑑定', '査定', '契約', '運行管理', '夜勤', '品質管理', '製品', '歩留まり', '運行管理', '施術', 'ゲスト', 'カウンセリング', '受付', 'コンシェルジュ', '効率', '安定']
          // let isPrimalwork_1_3KeywordArray = ['設計', 'モノづくり', '伝票', '集計', 'サポート', 'ニーズ', '伴走']
          let isPrimalwork_1Array = ['販売', '携帯販売', '携帯ショップ', 'スマホ販売', 'モバイル販売', 'カウンターセールス', '機種変更', 'MNP', 'プラン変更']
          if (this.addressCheck(basicData, isPrimalwork_1addressArray)) {
            if (basicData.age >= 20 && basicData.age <= 29) {
              if (this.keywordCheckRirekisho(formatData, isPrimalwork_1Array)
                || this.keywordCheckShokumukeirekisho(formatData, isPrimalwork_1Array)) {
                isPrimalwork_1 = true
              }
            }
          }

          let isTalentnavi_1addressArray = ['東京都']
          // let isTalentnavi_1addressArray = ['東京都', '神奈川県', '千葉県', '埼玉県']
          let isTalentnavi_1Array = ['販売', 'コミュニケーション能力']
          if (this.addressCheck(basicData, isTalentnavi_1addressArray)) {
            if (basicData.age >= 20 && basicData.age <= 29) {
              if (this.keywordCheckRirekisho(formatData, isTalentnavi_1Array)
                || this.keywordCheckShokumukeirekisho(formatData, isTalentnavi_1Array)) {
                isTalentnavi_1 = true
              }
            }
          }



          let azurite_mail_1addressArray = ['東京都', '神奈川県', '千葉県', '埼玉県']
          let azurite_mail_1KeywordArray = ['宅地建物取引士']
          if (this.addressCheck(basicData, azurite_mail_1addressArray)) {
            if (basicData.age >= 20 && basicData.age <= 55) {
              if (this.keywordCheckRirekisho(formatData, azurite_mail_1KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, azurite_mail_1KeywordArray)) {
                isAzurite_1 = true
              }
            }
          }
          let azurite_mail_2addressArray = ['東京都', '神奈川県', '千葉県', '埼玉県']
          let azurite_mail_2KeywordArray = ['東宝ハウス', '住友不動産ステップ', '東急リバブル', 'オープンハウス', '積水ハウス不動産ホールディングス', 'ケイアイスター不動産', 'アイダ設計', '三井不動産リアルティ', '三井のリハウス', '住友不動産販売', '東急リバブル', '野村不動産ソリューションズ', '大京穴吹不動産', '三菱地所ハウスネット', '小田急不動産', '京王不動産', '近鉄不動産', '三井ホーム不動産', 'センチュリー21・ジャパン', 'センチュリー21', 'ハウスドゥ', 'And Doホールディングス', 'イエステーション', 'ERA', 'LIXIL不動産ショップ', 'みずほ不動産販売', '三井住友トラスト不動産', '大成有楽不動産販売', '大和ハウスリアルエステート', '積水ハウス不動産東京', '積水化学工業', 'セキスイハイム不動産', 'オークラヤ住宅', '明和地所', 'リビングライフ', '城南建設', '住宅情報館', '日商エステム', '株式会社東宝ハウスグループ', '株式会社アドキャスト', '株式会社リアル', '株式会社プレシャスライフ', '株式会社アーバンホーム', '株式会社ベストセレクト', '株式会社藤和ハウス', '株式会社クラシア', '株式会社ハウジングスカイ', '株式会社ケーコーポレーション', '株式会社マイタウン', '株式会社マックホーム', '株式会社エステート白馬', '株式会社ホームプラザ', '株式会社サンシティホーム', '株式会社アイデアル', '株式会社S-FIT', '株式会社アシスト', '株式会社アンビション・エージェンシー', '株式会社クレアスレント', '株式会社シマダハウス', '株式会社ユーミーネット', '株式会社リブマックス', '株式会社誠興業', '株式会社エムズ', '株式会社アーバン21', '株式会社エステートトーワ', '株式会社タウン住宅販売', '株式会社ベストホーム', '株式会社ゼロメンテナンス', '株式会社エイムプレイス', '株式会社ハウスメイトショップ', '株式会社フォーラス＆カンパニー', '株式会社フォーラス&カンパニー', '株式会社アクシス・ジャパン', '株式会社リズム']
          if (this.addressCheck(basicData, azurite_mail_2addressArray)) {
            if (basicData.age >= 20 && basicData.age <= 28) {
              if (this.keywordCheckRirekisho(formatData, azurite_mail_2KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, azurite_mail_2KeywordArray)) {
                isAzurite_2 = true
              }
            }
          }

          let isProlg_1KeywordArray = ['ブライダル', '中古車']
          let isProlg_1AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県']
          if (this.addressCheck(basicData, isProlg_1AddressArray)) {
            if (basicData.age >= 24 && basicData.age <= 29) {
              if (this.keywordCheckRirekisho(formatData, isProlg_1KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isProlg_1KeywordArray)) {
                isProlg_1 = true
              }
            }
          }

          let isProlg_2KeywordArray = ['不動産', '塾']
          let isProlg_2AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県']
          if (this.addressCheck(basicData, isProlg_2AddressArray)) {
            if (basicData.age >= 24 && basicData.age <= 27) {
              if (this.keywordCheckRirekisho(formatData, isProlg_2KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isProlg_2KeywordArray)) {
                isProlg_2 = true
              }
            }
          }

          let isSmartforce_1KeywordArray = ['正社員', 'バイトリーダー', 'テレアポ', 'セールス', '明るい', '元気', 'コミュニケーション能力', '成長', '挑戦', '未経験']
          let isSmartforce_1AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県']
          if (this.addressCheck(basicData, isSmartforce_1AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 29) {
              if (this.keywordCheckRirekisho(formatData, isSmartforce_1KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isSmartforce_1KeywordArray)) {
                isSmartforce_1 = true
              }
            }
          }

          // let kiminara_mail_1addressArray = ['東京都', '埼玉県', '千葉県', '神奈川県', '大阪府']
          let kiminara_mail_1addressArray = ['東京都', '埼玉県', '千葉県', '神奈川県', '大阪府']
          let kiminara_mail_1NotKeywordArray = ['看護師', '保育士', '栄養士', '施工管理', '自動車整備士', '電気主任技術者', '介護士', 'ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員']
          if (this.addressCheck(basicData, kiminara_mail_1addressArray)) {
            if (basicData.age >= 24 && basicData.age <= 29) {
              if (this.keywordCheckRirekisho(formatData, kiminara_mail_1NotKeywordArray)) {
                isKiminara_1 = false
                isKiminara_2 = false
              } else {
                isKiminara_1 = true
                isKiminara_2 = true
              }
            }
          }

          let isCloudlink_3keywordArray = ['営業', '販売', 'コミュニケーション能力', '接客']
          let isCloudlink_3NotkeywordArray = ['アルバイト']
          if (this.keywordCheckRirekisho(formatData, isCloudlink_3keywordArray)
            || this.keywordCheckShokumukeirekisho(formatData, isCloudlink_3keywordArray)) {
            if (basicData.age >= 20 && basicData.age <= 29) {
              isCloudlink_3 = true
            }

          }
          if (this.keywordCheckRirekisho(formatData, isCloudlink_3NotkeywordArray)
            || this.keywordCheckShokumukeirekisho(formatData, isCloudlink_3NotkeywordArray)) {
            isCloudlink_3 = false
          }


          let isBearsnavi_1KeywordArray = ['接客']
          let isBearsnavi_1NotKeywordArray = ['日本語能力検定', '在留資格', '技術・人文知識・国際業務', '人文知識', '国際業務', 'JLPT', '通訳', '在日', '日本語能力', '日本語スキル']
          let isBearsnavi_1AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '大阪府']
          if (this.addressCheck(basicData, isBearsnavi_1AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 29) {
              if (this.keywordCheckRirekisho(formatData, isBearsnavi_1KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isBearsnavi_1KeywordArray)) {
                isBearsnavi_1 = true
              }
            }
            if (this.keywordCheckRirekisho(formatData, isBearsnavi_1NotKeywordArray)
              || this.keywordCheckShokumukeirekisho(formatData, isBearsnavi_1NotKeywordArray)) {
              isBearsnavi_1 = false
            }
          }

          let isBearsnavi_2KeywordArray = ['製造', '販売']
          let isBearsnavi_2NotKeywordArray = ['日本語能力検定', '在留資格', '技術・人文知識・国際業務', '人文知識', '国際業務', 'JLPT', '通訳', '在日', '日本語能力', '日本語スキル']
          let isBearsnavi_2AddressArray = ['東京都', '大阪府']
          if (this.addressCheck(basicData, isBearsnavi_2AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 29) {
              if (this.keywordCheckRirekisho(formatData, isBearsnavi_2KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isBearsnavi_2KeywordArray)) {
                isBearsnavi_2 = true
              }
            }
            if (this.keywordCheckRirekisho(formatData, isBearsnavi_2NotKeywordArray)
              || this.keywordCheckShokumukeirekisho(formatData, isBearsnavi_2NotKeywordArray)) {
              isBearsnavi_2 = false
            }
          }
          let isBearsnavi_3KeywordArray = ['営業']
          let isBearsnavi_3NotKeywordArray = ['日本語能力検定', '在留資格', '技術・人文知識・国際業務', '人文知識', '国際業務', 'JLPT', '通訳', '在日', '日本語能力', '日本語スキル']
          let isBearsnavi_3AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '大阪府']
          if (this.addressCheck(basicData, isBearsnavi_3AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 29) {
              if (this.keywordCheckRirekisho(formatData, isBearsnavi_3KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isBearsnavi_3KeywordArray)) {
                isBearsnavi_3 = true
              }
            }
            if (this.keywordCheckRirekisho(formatData, isBearsnavi_3NotKeywordArray)
              || this.keywordCheckShokumukeirekisho(formatData, isBearsnavi_3NotKeywordArray)) {
              isBearsnavi_3 = false
            }
          }



          let isStrike_1addressArray = ['東京都', '埼玉県', '千葉県', '神奈川県', '愛知県', '大阪府', '兵庫県', '京都府']
          if (this.addressCheck(basicData, isStrike_1addressArray)) {
            if (basicData.age >= 23 && basicData.age <= 35) {
              isStrike_1 = true
            }

          }


          let isInternous_1KeywordArray = ['接客', '販売']
          let isInternous_1AddressArray = ['茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県']
          if (this.addressCheck(basicData, isInternous_1AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 30) {
              if (this.keywordCheckRirekisho(formatData, isInternous_1KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isInternous_1KeywordArray)) {
                isInternous_1 = true
              }
            }
          }

          let isInternous_2KeywordArray = ['事務']
          let isInternous_2AddressArray = ['茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県']
          if (this.addressCheck(basicData, isInternous_2AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 30) {
              if (this.keywordCheckRirekisho(formatData, isInternous_2KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isInternous_2KeywordArray)) {
                isInternous_2 = true
              }
            }
          }

          let isInternous_3KeywordArray = ['製造']
          let isInternous_3AddressArray = ['茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県']
          if (this.addressCheck(basicData, isInternous_3AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 30) {
              if (this.keywordCheckRirekisho(formatData, isInternous_3KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isInternous_3KeywordArray)) {
                isInternous_3 = true
              }
            }
          }

          let isInternous_4KeywordArray = ['IT', 'WEB', 'web', 'Web']
          let isInternous_4AddressArray = ['茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県']
          if (this.addressCheck(basicData, isInternous_4AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 30) {
              if (this.keywordCheckRirekisho(formatData, isInternous_4KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isInternous_4KeywordArray)) {
                isInternous_4 = true
              }
            }
          }

          let isInternous_5KeywordArray = ['']
          let isInternous_5AddressArray = ['茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県']
          if (this.addressCheck(basicData, isInternous_5AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 30) {
              if (true) {
                isInternous_5 = true
              }
            }
          }



          let isBriedge_1addressArray = ['東京都', '神奈川県', '埼玉県', '千葉県']
          let isBriedge_1KeywordArray = ['営業']
          if (this.addressCheck(basicData, isBriedge_1addressArray)) {
            if (basicData.age >= 20 && basicData.age <= 29) {
              if (this.keywordCheckRirekisho(formatData, isBriedge_1KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isBriedge_1KeywordArray)) {
                isBriedge_1 = true
              }
            }
          }

          let isAwesome_1addressArray = ['東京都', '神奈川県', '大阪府']
          let isAwesome_1KeywordArray = ['営業']
          if (this.addressCheck(basicData, isAwesome_1addressArray)) {
            if (basicData.age >= 20 && basicData.age <= 29) {
              if (this.keywordCheckRirekisho(formatData, isAwesome_1KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isAwesome_1KeywordArray)) {
                isAwesome_1 = true
              }
            }
          }


          let is400f1addressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '愛知県', '大阪府', '福岡県']
          let is400f1KeywordArray = ['事務', '営業']
          if (this.addressCheck(basicData, is400f1addressArray)) {
            if (basicData.age >= 23 && basicData.age <= 34) {
              if (this.keywordCheckRirekisho(formatData, is400f1KeywordArray)) {
                is400F_1 = true
              }
            }
          }



          let usenworking1addressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '大阪府']
          let usenworking1KeywordArray = ['飲食', '調理', '厨房', 'キッチン', 'ホール', '店舗', '料理長', '接客', 'SV', '店舗開発']
          // let usenworking1NotKeywordArray = ['週１', '週２', '週３', '週４', '週1', '週2', '週3', '週4', 'パート希望', 'アルバイト希望', '時短']
          let usenworking1NotKeywordArray = ['週１', '週２', '週３', '週４', '週1', '週2', '週3', '週4', 'パート希望', 'アルバイト希望', '時短', '事務', '業務委託']
          if (this.addressCheck(basicData, usenworking1addressArray)) {
            if (this.keywordCheckRirekisho(formatData, usenworking1NotKeywordArray)) {

            } else {
              if (this.keywordCheckRirekisho(formatData, usenworking1KeywordArray)) {
                if (basicData.age >= 27 && basicData.age <= 34) {
                  isUsenworking_1 = true
                } else if (basicData.age >= 35 && basicData.age <= 36) {
                  isUsenworking_2 = true
                }
              }

            }
          }
          let usenworking2addressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '大阪府']
          let usenworking2KeywordArray = ['営業', 'セールス', 'カスタマーサクセス']
          if (this.addressCheck(basicData, usenworking2addressArray)) {
            if (this.keywordCheckRirekisho(formatData, usenworking2KeywordArray)) {
              if (basicData.age >= 27 && basicData.age <= 34) {
                isUsenworking_3 = true
              } else if (basicData.age >= 35 && basicData.age <= 36) {
                isUsenworking_4 = true
              }
            }
          }




          let agrinavi2addressArray = ['北海道', '青森県', '秋田県', '宮城県', '福島県', '岩手県', '山形県', '群馬県', '茨城県', '栃木県', '新潟県', '富山県', '石川県', '福井県', '長野県', '山梨県', '鳥取県', '島根県', '山口県', '愛媛県', '香川県', '高知県', '徳島県', '大分県', '宮崎県', '鹿児島県', '長崎県', '沖縄県']
          let agrinavi2KeywordArray = ['日本農業技術検定', '農学部', '農業大学', '酪農', '畜産', 'ポートリー', '牧場', 'ファーム', '農業協同組合']


          let xmile1addressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '愛知県', '大阪府', '京都府', '奈良県', '兵庫県', '滋賀県', '和歌山県']
          let xmile1KeywordArray = ['タクシー', '普通自動車第二種', '普通自動車第2種', 'ハイヤー']

          if (basicData.age >= 18 && basicData.age <= 64) {
            if (this.keywordCheckRirekisho(formatData, xmile1KeywordArray)) {
              if (this.addressCheck(basicData, xmile1addressArray)) {
                isXmile_1 = true
              } else {
                isXmile_2 = true
              }
            }
          }


          let xmile3addressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '愛知県', '大阪府', '京都府', '奈良県', '兵庫県', '滋賀県', '和歌山県']
          let xmile3KeywordArray = ['大型自動車', '中型自動車', 'ドライバー', '運送']

          if (basicData.age >= 18 && basicData.age <= 59) {
            if (this.keywordCheckRirekisho(formatData, xmile3KeywordArray)) {
              if (this.addressCheck(basicData, xmile3addressArray)) {
                isXmile_3 = true
              } else {
                isXmile_4 = true
              }
            }
          }

          let growtrail1KeywordArray = ['看護師']
          if (basicData.age >= 40 && basicData.age <= 60) {
            if (this.keywordCheckRirekisho(formatData, growtrail1KeywordArray)) {
              isArowtrail_1 = true
            }
          }

          let growtrail2KeywordArray = ['作業療法士', '理学療法士']
          if (this.keywordCheckRirekisho(formatData, growtrail2KeywordArray)) {
            isArowtrail_2 = true
          }

          let growtrail3KeywordArray = ['介護福祉士', '介護支援専門員']
          if (basicData.age >= 40 && basicData.age <= 60) {
            if (this.keywordCheckRirekisho(formatData, growtrail3KeywordArray)) {
              isArowtrail_3 = true
            }
          }


          // let recree1KeywordArray = ['現場監督', 'ゼネコン', '現場管理', '土木', '現場代理', '測量士', 'ウィルオブ・コンストラクション', 'ワールドコーポレーション', 'アーキ・ジャパン', 'アイアール', 'テクノプロ・コンストラクション', 'イーフラッグ', 'SUGUNI', 'コプロ・エンジニアード', '夢真', 'アクトエンジニアリング', 'スタッフ・アクティオ', 'UTコンストラクション', 'サイマリーディング', 'ハウスメーカー', 'RCCM', '意匠設計', '内装設計', '構造設計', '設備設計', '設計士', '工事', '改修工事', '修繕工事', '改築工事', '主任技術者', '管理技術者', '工事監理', '専任技術者', 'コンストラクションマネジメント', '技術士', '概略設計', 'リフォーム工事', 'W造', '木造住宅', '戸建て住宅', 'マンション工事', 'ビル工事', '杭工事', '鋼構造物', '法面工事', '港湾工事', '電験', '電気主任', '大規模修繕', '積算', 'サブコン', '電気工事士', '日建学院', 'RC造', 'SRC造', 'PC造', 'S造', '軽量鉄骨造', '木質フレーム構造', '地盤改良工事', 'プレキャストコンクリート工法', 'システム建築工法', 'トンネル工法', '地中構造物工法', '逆打ち工法', 'スリップフォーム工法', 'クライミングフォーム工法', 'トンネル工事', '河川工事', '上下水道工事', '海岸工事', '地滑り防止工事', '災害復旧工事', '地下構造物の建設']
          // if (basicData.age >= 20 && basicData.age <= 55) {
          //   if (this.keywordCheckRirekisho(formatData, recree1KeywordArray)) {
          //     isRecree_1 = true
          //   }
          // }

          let recree2KeywordArray = ['施工監理', '施工管理']
          if (basicData.age >= 20 && basicData.age <= 65) {
            if (this.keywordCheckRirekisho(formatData, recree2KeywordArray)
              || this.keywordCheckShokumukeirekisho(formatData, recree2KeywordArray)) {
              isRecree_2 = true
            }
          }

          let recree345NotKeywordArray = ['IT', 'SE']
          let recree3AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '静岡県', '愛知県', '岐阜県', '大阪府', '京都府', '兵庫県', '奈良県', '和歌山県', '北海道', '広県島', '岡山県']
          // let recree3KeywordArray = ['現場監督', 'ゼネコン', '現場管理', '土木', '現場代理', 'ウィルオブ・コンストラクション', 'ワールドコーポレーション', 'アーキ・ジャパン', 'テクノプロ・コンストラクション', 'イーフラッグ', 'SUGUNI', 'コプロ・エンジニアード', '夢真', 'アクトエンジニアリング', 'スタッフ・アクティオ', 'UTコンストラクション', 'サイマリーディング', 'ハウスメーカー', 'RCCM', '意匠設計', '内装設計', '構造設計', '設備設計', '設計士', '工事', '改修工事', '修繕工事', '改築工事', '主任技術者', '管理技術者', '電験', '電気主任', '大規模修繕', '積算', 'サブコン', '電気工事士', '日建学院', 'RC造', 'SRC造', 'PC造', 'S造', '軽量鉄骨造', '木質フレーム構造', '地盤改良工事', 'プレキャストコンクリート工法', 'システム建築工法', 'トンネル工法', '地中構造物工法', '逆打ち工法', 'スリップフォーム工法', 'クライミングフォーム工法', 'トンネル工事', '河川工事', '上下水道工事', '海岸工事', '地滑り防止工事', '災害復旧工事', '地下構造物の建設', '工事監理', '専任技術者', 'コンストラクションマネジメント', '技術士', '概略設計', 'リフォーム工事', 'W造', '木造住宅', '戸建て住宅', 'マンション工事', 'ビル工事', '杭工事', '鋼構造物', '法面工事', '港湾工事', 'CADオペレーター', '建築CAD検定', '2次元CAD利用技術者', '3次元CAD利用技術者', 'CADデザインマスター', 'CADトレース技士', '共同エンジニアリング', 'JAGフィールド', 'イーフラッグ']
          let recree3KeywordArray = ['共同エンジニアリング', 'JAGフィールド', '工事監理', '専任技術者', 'コンストラクションマネジメント', '管理技術者', '概略設計', 'リフォーム工事', 'W造', 'マンション工事', 'ビル工事', '杭工事', '鋼構造物', '法面工事', '港湾工事', '現場監督', '現場代理', 'ウィルオブ・コンストラクション', 'ワールドコーポレーション', 'テクノプロ・コンストラクション', 'イーフラッグ', 'SUGUNI', 'コプロ・エンジニアード', '夢真', 'アクトエンジニアリング', 'スタッフ・アクティオ', 'ＵＴコンストラクション', 'サイマリーディング', '意匠設計', '主任技術者', '監理技術者', 'RCCM', '内装設計', '構造設計', '設備設計', '設計士', '設計監理', '管工事', '改修工事', '修繕工事', '改築工事', '電験', '大規模修繕', '高松建設', 'ヤマギシリフォーム工業', 'カシワバラコーポレーション', 'メルディア', 'フクダアンドパートナーズ', '塩浜工業', 'ホークワン', '北野建設', '生和コーポレーション', '電気工事士', 'RC造', 'PC造', 'S造', '軽量鉄骨造', '木質フレーム構造', '地盤改良工事', 'プレキャストコンクリート工法', 'システム建築工法', 'ツーバイフォー工法', 'トンネル工法', '地中構造物工法', '逆打ち工法', 'スリップフォーム工法', 'クライミングフォーム工法', 'トンネル工事', '河川工事', '上下水道工事', '海岸工事', '地滑り防止工事', '災害復旧工事', '地下構造物の建設', '施工技士', '現場監理', '工事管理', '建築士', '現場所長', '現場主任', '工事主任', '建設コンサルタント', '建築コンサルタント', '建設マネジメント', 'トライトエンジニアリング', 'ウィルオブコンストラクション', 'コプロエンジニアード', 'テクノプロコンストラクション', 'UTコンストラクション', '設計管理', '土木設計', '建築設計', '工事監督', '建築設備士', '建築積算士', '発注者支援', '技士補']
          if (basicData.age >= 20 && basicData.age <= 30) {
            if (this.addressCheck(basicData, recree3AddressArray)) {
              if (this.keywordCheckRirekisho(formatData, recree345NotKeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, recree345NotKeywordArray)) {
                isRecree_3 = false
              } else if (this.keywordCheckRirekisho(formatData, recree3KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, recree3KeywordArray)) {
                isRecree_3 = true
              }
            }
          }

          let recree4AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '静岡県', '愛知県', '岐阜県', '大阪府', '京都府', '兵庫県', '奈良県', '和歌山県', '北海道', '広県島', '岡山県']
          let recree4KeywordArray = ['共同エンジニアリング', 'JAGフィールド', '工事監理', '専任技術者', 'コンストラクションマネジメント', '管理技術者', '概略設計', 'リフォーム工事', 'W造', '木造住宅', '戸建て住宅', 'マンション工事', 'ビル工事', '杭工事', '鋼構造物', '法面工事', '港湾工事', '現場監督', 'ゼネコン', '現場管理', '土木', '現場代理', 'ウィルオブ・コンストラクション', 'ワールドコーポレーション', 'アーキ・ジャパン', 'テクノプロ・コンストラクション', 'イーフラッグ', 'SUGUNI', 'コプロ・エンジニアード', '夢真', 'アクトエンジニアリング', 'スタッフ・アクティオ', 'ＵＴコンストラクション', 'サイマリーディング', '意匠設計', '主任技術者', '監理技術者', 'ハウスメーカー', 'RCCM', '内装設計', '構造設計', '設備設計', '設計士', '設計監理', '管工事', '改修工事', '修繕工事', '改築工事', '電験', '大規模修繕', '高松建設', 'ヤマギシリフォーム工業', 'カシワバラコーポレーション', 'メルディア', 'フクダアンドパートナーズ', 'ケイアイスター不動産', '一建設', '塩浜工業', 'ホークワン', '北野建設', '生和コーポレーション', 'サブコン', '電気工事士', '日建学院', 'RC造', 'PC造', 'S造', '軽量鉄骨造', '木質フレーム構造', '地盤改良工事', 'プレキャストコンクリート工法', 'システム建築工法', 'ツーバイフォー工法', 'トンネル工法', '地中構造物工法', '逆打ち工法', 'スリップフォーム工法', 'クライミングフォーム工法', 'トンネル工事', '河川工事', '上下水道工事', '海岸工事', '地滑り防止工事', '災害復旧工事', '地下構造物の建設', '施工技士', '現場監理', '工事管理', '建築士', '現場所長', '現場主任', '工事主任', '建設コンサルタント', '建築コンサルタント', '住宅リフォーム', '建設マネジメント']
          if (basicData.age >= 31 && basicData.age <= 55) {
            if (this.addressCheck(basicData, recree4AddressArray)) {
              if (this.keywordCheckRirekisho(formatData, recree345NotKeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, recree345NotKeywordArray)) {
                isRecree_4 = false
              } else if (this.keywordCheckRirekisho(formatData, recree3KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, recree3KeywordArray)) {
                isRecree_4 = true
              }
            }
          }

          let recree5AddressArray = ['青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県', '三重県', '滋賀県', '鳥取県', '島根県', '山口県', '徳島県', '香川県', '愛媛県', '高知県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県']
          let recree5KeywordArray = ['共同エンジニアリング', 'JAGフィールド', '工事監理', '専任技術者', 'コンストラクションマネジメント', '管理技術者', '概略設計', 'リフォーム工事', 'W造', '木造住宅', '戸建て住宅', 'マンション工事', 'ビル工事', '杭工事', '鋼構造物', '法面工事', '港湾工事', '現場監督', 'ゼネコン', '現場管理', '土木', '現場代理', 'ウィルオブ・コンストラクション', 'ワールドコーポレーション', 'アーキ・ジャパン', 'テクノプロ・コンストラクション', 'イーフラッグ', 'SUGUNI', 'コプロ・エンジニアード', '夢真', 'アクトエンジニアリング', 'スタッフ・アクティオ', 'ＵＴコンストラクション', 'サイマリーディング', '意匠設計', '主任技術者', '監理技術者', 'ハウスメーカー', 'RCCM', '内装設計', '構造設計', '設備設計', '設計士', '設計監理', '管工事', '改修工事', '修繕工事', '改築工事', '電験', '大規模修繕', '高松建設', 'ヤマギシリフォーム工業', 'カシワバラコーポレーション', 'メルディア', 'フクダアンドパートナーズ', 'ケイアイスター不動産', '一建設', '塩浜工業', 'ホークワン', '北野建設', '生和コーポレーション', 'サブコン', '電気工事士', '日建学院', 'RC造', 'PC造', 'S造', '軽量鉄骨造', '木質フレーム構造', '地盤改良工事', 'プレキャストコンクリート工法', 'システム建築工法', 'ツーバイフォー工法', 'トンネル工法', '地中構造物工法', '逆打ち工法', 'スリップフォーム工法', 'クライミングフォーム工法', 'トンネル工事', '河川工事', '上下水道工事', '海岸工事', '地滑り防止工事', '災害復旧工事', '地下構造物の建設', '施工技士', '現場監理', '工事管理', '建築士', '現場所長', '現場主任', '工事主任', '建設コンサルタント', '建築コンサルタント', '住宅リフォーム', '建設マネジメント']
          if (basicData.age >= 20 && basicData.age <= 35) {
            if (this.addressCheck(basicData, recree5AddressArray)) {
              if (this.keywordCheckRirekisho(formatData, recree345NotKeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, recree345NotKeywordArray)) {
                isRecree_5 = false
              } else if (this.keywordCheckRirekisho(formatData, recree3KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, recree3KeywordArray)) {
                isRecree_5 = true
              }
            }
          }


          let isXmile_5AddressArray = ['']
          let isXmile_5KeywordArray = ['施工管理']
          if (basicData.age >= 20 && basicData.age <= 49) {
            if (this.addressCheck(basicData, isXmile_5AddressArray) || true) {
              if (this.keywordCheckRirekisho(formatData, isXmile_5KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isXmile_5KeywordArray)) {
                isXmile_5 = true
              }
            }
          }
          let isXmile_6AddressArray = ['三重県', '京都府', '佐賀県', '兵庫県', '千葉県', '埼玉県', '大分県', '大阪府', '奈良県', '宮崎県', '岐阜県', '岡山県', '島根県', '広島県', '徳島県', '愛媛県', '愛知県', '東京都', '栃木県', '滋賀県', '熊本県', '神奈川県', '福岡県', '茨城県', '香川県', '高知県', '鳥取県', '鹿児島県']
          let isXmile_6KeywordArray = ['中型自動車第二種運転免許', '中型自動車運転免許', '準中型自動車運転免許', '大型自動車第二種運転免許', '大型特殊自動車免許', '牽引自動車第一種運転免許', '大型特殊免許', '大型二種免許', '第二種運転免許', 'けん引免許', '玉掛け免許', 'フォークリフト運転技能者', '大型自動車免許', '第二種自動車運転免許', '大型自動車二種免許', 'トラックドライバー', '配送ドライバー', '長距離ドライバー', 'バスドライバー', '長距離輸送', '特殊車両', '軽貨物', 'タンクローリー', '長距離運転', '倉庫管理主任者', 'ルート配送', '準中型自動車免許', '運行管理者', '大型自動車第一種運転免許', '中型自動車第一種運転免許']
          if (basicData.age >= 20 && basicData.age <= 54) {
            if (this.addressCheck(basicData, isXmile_6AddressArray)) {
              if (this.keywordCheckRirekisho(formatData, isXmile_6KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isXmile_6KeywordArray)) {
                isXmile_6 = true
              }
            }
          }
          let isXmile_7AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '茨城県', '大阪府', '福岡県', '広島県', '京都府', '兵庫県']
          let isXmile_7KeywordArray = ['タクシードライバー', '普通自動車第二種運転免許', '普通二種免許', '一般乗用旅客', '普通自動車二種免許', '普通自動車第二種免許', '旅客運送']
          if (basicData.age >= 20 && basicData.age <= 54) {
            if (this.addressCheck(basicData, isXmile_7AddressArray)) {
              if (this.keywordCheckRirekisho(formatData, isXmile_7KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isXmile_7KeywordArray)) {
                isXmile_7 = true
              }
            }
          }
          let isXmile_8AddressArray = ['']
          let isXmile_8KeywordArray = ['自動車検査員', '整備士']
          if (basicData.age >= 20 && basicData.age <= 49) {
            if (this.addressCheck(basicData, isXmile_8AddressArray) || true) {
              if (this.keywordCheckRirekisho(formatData, isXmile_8KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isXmile_8KeywordArray)) {
                isXmile_8 = true
              }
            }
          }
          let isXmile_9AddressArray = ['三重県', '京都府', '兵庫県', '千葉県', '埼玉県', '大阪府', '奈良県', '宮城県', '岐阜県', '岡山県', '愛知県', '新潟県', '東京都', '栃木県', '神奈川県', '福島県', '群馬県', '茨城県', '長野県']
          let isXmile_9KeywordArray = ['機械設計', '機械加工技能士', '機械加工', 'CADオペレーター', '製造オペレーター', '生産技術', '品質保証', '設計開発', 'サービスエンジニア']
          if (basicData.age >= 20 && basicData.age <= 44) {
            if (this.addressCheck(basicData, isXmile_9AddressArray)) {
              if (this.keywordCheckRirekisho(formatData, isXmile_9KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isXmile_9KeywordArray)) {
                isXmile_9 = true
              }
            }
          }
          let isXmile_10AddressArray = ['千葉県', '埼玉県', '愛知県', '東京都', '神奈川県', '群馬県', '茨城県']
          let isXmile_10KeywordArray = ['警備員指導教育責任者', '施設警備業務', '交通誘導警備業務', '貴重品運搬警備業務', '空港保安警備業務', '機械警備業務']
          if (basicData.age >= 20 && basicData.age <= 54) {
            if (this.addressCheck(basicData, isXmile_10AddressArray)) {
              if (this.keywordCheckRirekisho(formatData, isXmile_10KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isXmile_10KeywordArray)) {
                isXmile_10 = true
              }
            }
          }

          let isXmile_11AddressArray = true
          let isXmile_11KeywordArray = ['建築士', '建築設計', '測量士補', 'RC造']
          if (basicData.age >= 20 && basicData.age <= 35) {
            if (isXmile_11AddressArray) {
              if (this.keywordCheckRirekisho(formatData, isXmile_11KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isXmile_11KeywordArray)) {
                isXmile_11 = true
              }
            }
          }
          let isXmile_12AddressArray = true
          let isXmile_12KeywordArray = ['プラントエンジニアリング']
          if (basicData.age >= 20 && basicData.age <= 35) {
            if (isXmile_12AddressArray) {
              if (this.keywordCheckRirekisho(formatData, isXmile_12KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isXmile_12KeywordArray)) {
                isXmile_12 = true
              }
            }
          }
          let isXmile_13AddressArray = true
          let isXmile_13KeywordArray = ['工業高等学校建築科', '工業高等学校土木科', '学部建築学科', '工業高等学校　建築科', '工業高等学校 建築科', '工業高等学校　土木科', '工業高等学校 土木科', '学部　建築学科', '学部 建築学科']
          if (basicData.age >= 20 && basicData.age <= 35) {
            if (isXmile_13AddressArray) {
              if (this.keywordCheckRirekisho(formatData, isXmile_13KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isXmile_13KeywordArray)) {
                isXmile_13 = true
              }
            }
          }
          let isXmile_14AddressArray = true
          let isXmile_14KeywordArray = ['工業高等学校電気科', '工業高等学校機械科', '工業高等学校　電気科', '工業高等学校　機械科', '工業高等学校 電気科', '工業高等学校 機械科']
          if (basicData.age >= 20 && basicData.age <= 35) {
            if (isXmile_14AddressArray) {
              if (this.keywordCheckRirekisho(formatData, isXmile_14KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isXmile_14KeywordArray)) {
                isXmile_14 = true
              }
            }
          }
          let isXmile_15AddressArray = true
          let isXmile_15KeywordArray = ['自動車大学校', '自動車整備士専門学校', 'ホンダテクニカルカレッジ', '株式会社IDOM']
          if (basicData.age >= 20 && basicData.age <= 35) {
            if (isXmile_15AddressArray) {
              if (this.keywordCheckRirekisho(formatData, isXmile_15KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isXmile_15KeywordArray)) {
                isXmile_15 = true
              }
            }
          }
          let isXmile_16AddressArray = ['東京都']
          let isXmile_16KeywordArray = ['法人営業', 'ルート営業', '訪問販売']
          if (basicData.age >= 20 && basicData.age <= 35) {
            if (this.addressCheck(basicData, isXmile_16AddressArray)) {
              if (this.keywordCheckRirekisho(formatData, isXmile_16KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isXmile_16KeywordArray)) {
                isXmile_16 = true
              }
            }
          }
          let isXmile_17AddressArray = ['東京都']
          let isXmile_17KeywordArray = ['不動産営業', '宅地建物取引士', '賃貸不動産経営管理士', '管理業務主任者']
          if (basicData.age >= 20 && basicData.age <= 35) {
            if (this.addressCheck(basicData, isXmile_17AddressArray)) {
              if (this.keywordCheckRirekisho(formatData, isXmile_17KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isXmile_17KeywordArray)) {
                isXmile_17 = true
              }
            }
          }
          let isXmile_18AddressArray = ['東京都']
          let isXmile_18KeywordArray = ['キャリアアドバイザー', 'キャリアコンサルタント', '人材コーディネーター']
          if (basicData.age >= 20 && basicData.age <= 35) {
            if (this.addressCheck(basicData, isXmile_18AddressArray)) {
              if (this.keywordCheckRirekisho(formatData, isXmile_18KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isXmile_18KeywordArray)) {
                isXmile_18 = true
              }
            }
          }


          let isDrtc_1AddressArray = true
          let isDrtc_1KeywordArray = ['ドライバー', '運輸', '運送', 'トランスポート', 'タクシー', 'ハイヤー', 'バス', '送迎', '交通', 'トラック', '大型免許', '大型二種', '配送', '輸送', '軽貨物', '地場', '運転手']
          if (basicData.age >= 35) {
            if (isDrtc_1AddressArray) {
              if (this.keywordCheckRirekisho(formatData, isDrtc_1KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isDrtc_1KeywordArray)) {
                isDrtc_1 = true
              }
            }
          }

          let isNeocareerNew_1AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '大阪府', '京都府', '兵庫県', '愛知県', '三重県', '岐阜県', '福岡県']
          let isNeocareerNew_1NotKeywordArray = ['休職', '鬱', '障害', '日本語能力検定', 'N1', 'N2', 'N3']
          if (this.addressCheck(basicData, isNeocareerNew_1AddressArray)) {
            if (this.keywordCheckRirekisho(formatData, isNeocareerNew_1NotKeywordArray)) {
              isNeocareerNew_1 = false
            } else {
              if (basicData.age >= 20 && basicData.age <= 29) {
                isNeocareerNew_1 = true

              }
            }
          }

          let isHuemaridge_1AddressArray = ['東京都', '埼玉県', '千葉県', '神奈川県', '新潟県', '青森県', '宮城県', '福島県', '岩手県', '栃木県', '群馬県', '茨城県', '静岡県', '大阪県', '京都県', '愛知県', '石川県', '山形県', '富山県', '大分県', '岐阜県', '鳥取県', '広島県', '福岡県', '佐賀県', '沖縄県']
          let isHuemaridge_1KeywordArray = ['エステティシャン']
          if (basicData.age >= 18 && basicData.age <= 35) {
            if (this.addressCheck(basicData, isHuemaridge_1AddressArray)) {
              if (this.keywordCheckRirekisho(formatData, isHuemaridge_1KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isHuemaridge_1KeywordArray)) {
                isHuemaridge_1 = true
              }
            }
          }

          if (formatData.gradeYear == 26) {
            if (basicData.email &&
              basicData.tel1 &&
              basicData.tel2 &&
              basicData.tel3 &&
              basicData.lastName &&
              basicData.firstName) {
              let isNeocareerAddressArray2 = ['北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '山梨県', '岐阜県', '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県']
              if (true) {
                if (basicData.age <= 25 && !formatData.foreignStudent) {
                  isNeocareer_1 = true
                  isHitotechNeocareer_1 = false
                }
              }
            }
          }
          if (basicData.email &&
            basicData.tel1 &&
            basicData.tel2 &&
            basicData.tel3 &&
            basicData.lastName &&
            basicData.firstName) {
            let isNeocareerAddressArray2 = ['北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '山梨県', '岐阜県', '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県']
            if (this.addressCheck(basicData, isNeocareerAddressArray2)) {
              if (basicData.age <= 25) {
                if (this.keywordCheck(formatId, formatData, '2026年　卒業見込') || this.keywordCheck(formatId, formatData, '2026年 卒業見込')) {
                  isNeocareer_2 = true
                }
              }
            }
          }
          let isNeocareer3AddressArray = ['東京都', '千葉県', '埼玉県', '神奈川県']
          if (this.addressCheck(basicData, isNeocareer3AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 50) {
              if (this.keywordCheck(formatId, formatData, '保育士')) {
                isNeocareer_3 = true
              }
            }
          }
          let isNeocareer4AddressArray = ['北海道', '青森県', '岩手県', '宮城県', '福島県', '秋田県', '山形県', '茨城県', '栃木県', '群県馬', '長野県', '山梨県', '静岡県', '愛知県', '岐阜県', '新潟県', '富山県', '石川県', '福井県', '滋賀県', '京都府', '大阪府', '奈良県', '三重県', '和歌山県', '兵庫県', '岡山県', '広島県', '山口県', '島根県', '鳥取県', '香川県', '愛媛県', '高知県', '徳島県', '福岡県', '大分県', '宮崎県', '鹿児島県', '熊本県', '佐賀県', '長崎県', '沖縄県']
          if (this.addressCheck(basicData, isNeocareer4AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 50) {
              if (this.keywordCheck(formatId, formatData, '保育士')) {
                isNeocareer_4 = true
              }
            }
          }

          let isMedley_Link_5KeywordArray = ['看護師']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_5KeywordArray)) {
            isMedley_Link_5 = true
          }
          let isMedley_Link_6KeywordArray = ['介護士', 'ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_6KeywordArray)) {
            isMedley_Link_6 = true
          }
          let isMedley_Link_7KeywordArray = ['保育士']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_7KeywordArray)) {
            isMedley_Link_7 = true
          }
          let isMedley_Link_8KeywordArray = ['栄養士']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_8KeywordArray)) {
            isMedley_Link_8 = true
          }
          let isMedley_Link_9KeywordArray = ['作業療法士']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_9KeywordArray)) {
            isMedley_Link_9 = true
          }
          let isMedley_Link_10KeywordArray = ['理学療法士']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_10KeywordArray)) {
            isMedley_Link_10 = true
          }
          let isMedley_Link_11KeywordArray = ['臨床工学技士']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_11KeywordArray)) {
            isMedley_Link_11 = true
          }
          let isMedley_Link_12KeywordArray = ['臨床検査技師']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_12KeywordArray)) {
            isMedley_Link_12 = true
          }
          let isMedley_Link_13KeywordArray = ['診療放射線技師']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_13KeywordArray)) {
            isMedley_Link_13 = true
          }
          let isMedley_Link_14KeywordArray = ['言語聴覚士']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_14KeywordArray)) {
            isMedley_Link_14 = true
          }
          let isMedley_Link_15KeywordArray = ['視能訓練士']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_15KeywordArray)) {
            isMedley_Link_15 = true
          }
          let isMedley_Link_16KeywordArray = ['歯科衛生士']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_16KeywordArray)) {
            isMedley_Link_16 = true
          }
          let isMedley_Link_17KeywordArray = ['歯科助手']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_17KeywordArray)) {
            isMedley_Link_17 = true
          }
          let isMedley_Link_18KeywordArray = ['看護助手']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_18KeywordArray)) {
            isMedley_Link_18 = true
          }
          let isMedley_Link_19KeywordArray = ['美容師']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_19KeywordArray)) {
            isMedley_Link_19 = true
          }
          let isMedley_Link_20KeywordArray = ['柔道整復師']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_20KeywordArray)) {
            isMedley_Link_20 = true
          }
          let isMedley_Link_21KeywordArray = ['児童指導員']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_21KeywordArray)) {
            isMedley_Link_21 = true
          }
          let isMedley_Link_22KeywordArray = ['医療事務']
          if (this.keywordCheckRirekisho(formatData, isMedley_Link_22KeywordArray)) {
            isMedley_Link_22 = true
          }





          let isPleiades_9KeywordArray = ['保育士']
          if (this.keywordCheckRirekisho(formatData, isPleiades_9KeywordArray)) {
            if (basicData.age >= 51 && basicData.age <= 60) {
              isPleiades_9 = true
            }
          }

          let isPleiades_1KeywordArray = ['児童発達支援管理責任者', '児童支援員', '学童指導員', '放課後等デイサービス']
          if (this.keywordCheckRirekisho(formatData, isPleiades_1KeywordArray)) {
            if (basicData.age >= 30 && basicData.age <= 59) {
              isPleiades_1 = true
            }
          }
          let isPleiades_2KeywordArray = ['栄養士']
          let isPleiades_2NotKeywordArray = ['事務', '助手', '営業']
          let isPleiades_2AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '大阪府']
          // if (this.addressCheck(basicData, isPleiades_2AddressArray) || true) {
          if (true) {
            if (this.keywordCheckRirekisho(formatData, isPleiades_2KeywordArray) ||
              this.keywordCheckShokumukeirekisho(formatData, isPleiades_2KeywordArray)) {
              if (basicData.age >= 23 && basicData.age <= 54) {
                isPleiades_2 = true
              }
            }
            if (this.keywordCheckRirekisho(formatData, isPleiades_2NotKeywordArray) ||
              this.keywordCheckShokumukeirekisho(formatData, isPleiades_2NotKeywordArray)) {
              isPleiades_2 = false
            }
          }
          let isPleiades_3KeywordArray = ['パティシエ', 'パン職人', 'ブーランジェ', '鮮魚加工', '精肉加工']
          let isPleiades_3AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '大阪府', '兵庫県', '京都府']
          if (this.addressCheck(basicData, isPleiades_3AddressArray)) {
            if (this.keywordCheckRirekisho(formatData, isPleiades_3KeywordArray)) {
              if (basicData.age >= 23 && basicData.age <= 45) {
                isPleiades_3 = true
              }
            }
          }
          let isPleiades_4KeywordArray = ['建設機械整備技能士']
          if (true) {
            if (this.keywordCheckRirekisho(formatData, isPleiades_4KeywordArray)) {
              if (basicData.age >= 23 && basicData.age <= 45) {
                isPleiades_4 = true
              }
            }
          }
          let isPleiades_5KeywordArray = ['設備管理', '電気保安', 'ビルメンテナンス']
          let isPleiades_5AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '大阪府', '兵庫県', '京都府', '奈良県', '福岡県', '愛知県']
          if (this.addressCheck(basicData, isPleiades_5AddressArray)) {
            if (this.keywordCheckRirekisho(formatData, isPleiades_5KeywordArray)) {
              if (basicData.age >= 23 && basicData.age <= 45) {
                isPleiades_5 = true
              }
            }
          }
          let isPleiades_6KeywordArray = ['ゼネコン', 'サブコン', '現場代理人', '現場監督']
          let isPleiades_6AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '大阪府', '兵庫県', '京都府', '奈良県', '福岡県', '愛知県']
          if (this.addressCheck(basicData, isPleiades_6AddressArray)) {
            if (this.keywordCheckRirekisho(formatData, isPleiades_6KeywordArray)) {
              if (basicData.age >= 23 && basicData.age <= 45) {
                isPleiades_6 = true
              }
            }
          }
          let isPleiades_7KeywordArray = ['設備保全', 'ビル管理', '建築物環境衛生管理技術者']
          let isPleiades_7AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '大阪府', '兵庫県', '京都府', '奈良県', '福岡県', '愛知県']
          if (this.addressCheck(basicData, isPleiades_7AddressArray)) {
            if (this.keywordCheckRirekisho(formatData, isPleiades_7KeywordArray)) {
              if (basicData.age >= 23 && basicData.age <= 45) {
                isPleiades_7 = true
              }
            }
          }
          let isPleiades_8KeywordArray = ['大型自動車', '中型自動車']
          let isPleiades_8AddressArray = ['大阪府']
          if (this.addressCheck(basicData, isPleiades_8AddressArray)) {
            if (this.keywordCheckRirekisho(formatData, isPleiades_8KeywordArray)) {
              if (basicData.age >= 20 && basicData.age <= 49) {
                isPleiades_8 = true
              }
            }
          }


          let isJhr_1KeywordArray = ['営業', '製造', 'エンジニア', '接客', '販売']
          if (basicData.age >= 18 && basicData.age <= 34) {
            if (this.keywordCheckRirekisho(formatData, isJhr_1KeywordArray)
              || this.keywordCheckShokumukeirekisho(formatData, isJhr_1KeywordArray)) {
              isJhr_1 = true
            }
          }
          let isJhr_2KeywordArray = ['製造', 'エンジニア']
          let isJhr_2AddressArray = ['東京都', '埼玉県', '神奈川県', '千葉県', '大阪府', '愛知県', '福岡県']
          if (this.addressCheck(basicData, isJhr_2AddressArray)) {
            if (basicData.age >= 18 && basicData.age <= 34) {
              if (this.keywordCheckRirekisho(formatData, isJhr_2KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isJhr_2KeywordArray)) {
                isJhr_2 = true
              }
            }
          }



          let isPeacekaigo_1KeywordArray = ['ヘルパー2級', 'ヘルパー1級', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '精神保険福祉士', '介護支援専門員', '主任介護支援専門員']
          let isPeacekaigo_1AddressArray = ['北海道', '大阪府', '奈良県', '兵庫県', '宮城県', '京都府']


          let isPeacekaigo_2KeywordArray = ['介護福祉士', '実務者研修', '初任者研修']
          let isPeacekaigo_2AddressArray = ['北海道', '青森県', '岩手県', '宮城県', '新潟県', '大阪府', '京都府', '兵庫県', '奈良県']
          // if (this.addressCheck(basicData, isPeacekaigo_2AddressArray)) {
          //   if (this.keywordCheckRirekisho(formatData, isPeacekaigo_2KeywordArray)) {
          //     isPeacekaigo_2 = true
          //   }
          // }
          if (this.addressCheck(basicData, isPeacekaigo_2AddressArray)) {
            if (this.keywordCheckRirekisho(formatData, isPeacekaigo_2KeywordArray)) {
              isPeacekaigo_2 = true
            }
          }

          let isPeacekaigo_3KeywordArray = ['ヘルパー2級', 'ヘルパー1級', '初任者研修', '実務者研修', '介護福祉士', '介護支援専門員', '主任介護支援専門員']
          let isPeacekaigo_3AddressArray = ['大阪府']

          let isPeacekaigo_4KeywordArray = ['准看護師', '正看護師']
          let isPeacekaigo_5KeywordArray = ['正看護師']
          // let isPeacekaigo_4AddressArray = ['大阪府']
          if (true) {
            if (this.keywordCheckRirekisho(formatData, isPeacekaigo_4KeywordArray)) {
              isPeacekaigo_4 = true
            }
          }
          if (true) {
            if (this.keywordCheckRirekisho(formatData, isPeacekaigo_5KeywordArray)) {
              isPeacekaigo_5 = true
            }
          }

          let isPleiades_10KeywordArray = ['保育士']
          let isPleiades_10_NotKeywordArray = ['事務', '接客', '在宅']
          let isPleiades_10AddressArray = ['北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '新潟県', '富山県', '石川県', '福井県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県']
          if (this.addressCheck(basicData, isPleiades_10AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 49) {
              if (this.keywordCheckRirekisho(formatData, isPleiades_10KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isPleiades_10KeywordArray)) {
                isPleiades_10 = true
              }
              if (this.keywordCheckRirekisho(formatData, isPleiades_10_NotKeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isPleiades_10_NotKeywordArray)) {
                isPleiades_10 = false
              }
            }
          }
          let isPleiades_18KeywordArray = ['保育士']
          let isPleiades_18_NotKeywordArray = ['事務', '接客', '在宅']
          let isPleiades_18AddressArray = ['茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '山梨県', '長野県', '岐阜県', '静岡県', '愛知県', '三重県', '鳥取県', '島根県', '岡山県', '広島県', '山口県', '徳島県', '香川県', '愛媛県', '高知県']
          if (this.addressCheck(basicData, isPleiades_18AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 49) {
              if (this.keywordCheckRirekisho(formatData, isPleiades_18KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isPleiades_18KeywordArray)) {
                isPleiades_18 = true
              }
              if (this.keywordCheckRirekisho(formatData, isPleiades_18_NotKeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isPleiades_18_NotKeywordArray)) {
                isPleiades_18 = false
              }
            }
          }
          let isPleiades_11KeywordArray = ['施工管理']
          if (basicData.age >= 20 && basicData.age <= 65) {
            if (this.keywordCheckShokumukeirekisho(formatData, isPleiades_11KeywordArray)) {
              isPleiades_11 = true
            }
          }
          let isPleiades_12KeywordArray = ['自動車整備士']
          let isPleiades_12NotKeywordArray = ['事務職', 'IT', 'アルバイト']
          if (basicData.age >= 20 && basicData.age <= 65) {
            if (this.keywordCheckShokumukeirekisho(formatData, isPleiades_12KeywordArray)) {
              isPleiades_12 = true
            }
            if (this.keywordCheckShokumukeirekisho(formatData, isPleiades_12NotKeywordArray)) {
              isPleiades_12 = false
            }
          }
          let isPleiades_13KeywordArray = ['自動車整備工']
          if (basicData.age >= 20 && basicData.age <= 65) {
            if (this.keywordCheckShokumukeirekisho(formatData, isPleiades_13KeywordArray)) {
              isPleiades_13 = true
            }
          }
          let isPleiades_14KeywordArray = ['電気主任技術者']
          if (basicData.age >= 20 && basicData.age <= 65) {
            if (this.keywordCheckShokumukeirekisho(formatData, isPleiades_14KeywordArray)) {
              isPleiades_14 = true
            }
          }
          let isPleiades_15KeywordArray = ['管理技術者']
          if (basicData.age >= 20 && basicData.age <= 65) {
            if (this.keywordCheckShokumukeirekisho(formatData, isPleiades_15KeywordArray)) {
              isPleiades_15 = true
            }
          }
          let isPleiades_16KeywordArray = ['電気工事']
          if (basicData.age >= 20 && basicData.age <= 65) {
            if (this.keywordCheckShokumukeirekisho(formatData, isPleiades_16KeywordArray)) {
              isPleiades_16 = true
            }
          }
          let isPleiades_17KeywordArray = ['現場監督']
          if (basicData.age >= 20 && basicData.age <= 65) {
            if (this.keywordCheckShokumukeirekisho(formatData, isPleiades_17KeywordArray)) {
              isPleiades_17 = true
            }
          }


          let krasys1AddressArray = ['東京都', '千葉県', '神奈川県', '埼玉県']

          // let krasys2AddressArray = ['東京都', '千葉県', '神奈川県', '埼玉県']
          if (true) {
            if (basicData.age >= 23 && basicData.age <= 55) {
              if (this.keywordCheck(formatId, formatData, '薬剤師')) {
                isKrasys_2 = true
              }
            }
          }
          if (true) {
            if (basicData.age >= 23 && basicData.age <= 59) {
              if (this.keywordCheckOnlyLicense(formatId, formatData, '薬剤師')
                || this.keywordCheckShokumukeirekishoOnlyLicense(formatData, '薬剤師')) {
                isPharmacareer_1 = true
              }
            }
          }


          let isYagishSaiyo1 = false
          let isYagishSaiyo2 = false
          let isYagish_8 = false

          if (this.keywordCheck3(formatData, '営業') || this.keywordCheck3(formatData, '販売')) {
            isYagishSaiyo1 = false
          }
          if (this.keywordCheck3(formatData, '分析') || this.keywordCheck3(formatData, 'ディレクター') || this.keywordCheck3(formatData, 'GA') || this.keywordCheck3(formatData, 'グーグルアナリティクス') || this.keywordCheck3(formatData, 'Googleアナリティクス') || this.keywordCheck3(formatData, 'UI・UX設計') || this.keywordCheck3(formatData, 'ユーザーテスト') || this.keywordCheck3(formatData, 'SEO')) {
            isYagishSaiyo2 = false
          }

          if (formatData.gradeYear == 24) {
            if (formatData.foreignStudent) {
              isYagish = false
            }
          }
          if (formatData.foreignStudent) {
            isYagish_8 = true
          }


          // let isKikkakeagent_1KeywordArray = ['Java', 'PHP', 'C#', 'プロジェクトマネージャー', 'PM', 'プロジェクトリーダー', 'システムアーキテクト', 'システムエンジニア', 'バックエンドエンジニア', 'インフラエンジニア', 'フロントエンドエンジニア', 'AWS', 'Azure', 'GCP', 'Linux']
          let isKikkakeagent_1KeywordArray = ['Java', 'PHP', 'C#', 'システムアーキテクト', 'システムエンジニア', 'バックエンドエンジニア', 'インフラエンジニア', 'フロントエンドエンジニア', 'GCP', 'Linux', 'TypeScript', 'Python', 'Go言語', 'COBOL', 'Angular', 'Laravel', 'React', 'Vue.js', 'Apache', 'Nginx', 'MariaDB', 'MongoDB', 'MySQL', 'Postgre', 'SES']
          let isKikkakeagent_1NotKeywordArray = ['営業']
          let isKikkakeagent_1AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '大阪府', '愛知県', '福岡県']
          if (this.addressCheck(basicData, isKikkakeagent_1AddressArray)) {
            if (basicData.age >= 24 && basicData.age <= 40) {
              if (this.keywordCheckRirekisho(formatData, isKikkakeagent_1KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isKikkakeagent_1KeywordArray)) {
                isKikkakeagent_1 = true
              }
              if (this.keywordCheckRirekisho(formatData, isKikkakeagent_1NotKeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isKikkakeagent_1NotKeywordArray)) {
                isKikkakeagent_1 = false
              }
            }
          }
          if (formatId == "engineer_shokumukeirekisho") {
            isKikkakeagent_1 = true
          }



          let isCloudlink_1KeywordArray = ['機械設計', '生産技術', '生産管理', '品質管理', '品質保証', '研究開発', '制御設計', '設計開発', '電気設計', '回路設計']
          let isCloudlink_1AddressArray = ['']
          if (true) {
            if (basicData.age >= 45 && basicData.age <= 60) {
              if (this.keywordCheckRirekisho(formatData, isCloudlink_1KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isCloudlink_1KeywordArray)) {
                isCloudlink_1 = true
              }
            }
          }
          let isCloudlink_2KeywordArray = ['Java', 'PHP', 'C#', 'システムアーキテクト', 'システムエンジニア', 'バックエンドエンジニア', 'インフラエンジニア', 'フロントエンドエンジニア', 'GCP', 'Linux', 'TypeScript', 'Python', 'Go言語', 'COBOL', 'Angular', 'Laravel', 'React', 'Vue.js', 'Apache', 'Nginx', 'MariaDB', 'MongoDB', 'MySQL', 'Postgre', 'SES']
          let isCloudlink_2AddressArray = ['']
          if (true) {
            if (basicData.age >= 25 && basicData.age <= 35) {
              if (this.keywordCheckRirekisho(formatData, isCloudlink_2KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isCloudlink_2KeywordArray)) {
                isCloudlink_2 = true
              }
            }
            if (basicData.age >= 45 && basicData.age <= 54) {
              if (this.keywordCheckRirekisho(formatData, isCloudlink_2KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isCloudlink_2KeywordArray)) {
                isCloudlink_2 = true
              }
            }
          }


          let isHeros_1KeywordArray = ['販売']
          let isHeros_1AddressArray = ['大阪府']
          if (this.addressCheck(basicData, isHeros_1AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 29) {
              if (this.keywordCheckRirekisho(formatData, isHeros_1KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isHeros_1KeywordArray)) {
                isHeros_1 = true
              }
            }
          }
          let isHeros_2KeywordArray = ['販売', '接客']
          let isHeros_2AddressArray = ['北海道', '青森県', '山形県', '石川県', '茨城県', '岡山県', '徳島県', '愛媛県']
          // let isHeros_2AddressArray = ['山形県', '石川県', '岡山県', '徳島県', '愛媛県']
          if (this.addressCheck(basicData, isHeros_2AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 29) {
              if (this.keywordCheckRirekisho(formatData, isHeros_2KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isHeros_2KeywordArray)) {
                isHeros_2 = true
              }
            }
          }

          let isHuproinc_1KeywordArray = ['経理', '税理士', '税務', '財務', 'CFO']
          let isHuproinc_1NotKeywordArray = ['経理事務', '経理総務']
          let isHuproinc_1AddressArray = ['東京都', '大阪府']
          if (this.addressCheck(basicData, isHuproinc_1AddressArray)) {
            if (basicData.age >= 25 && basicData.age <= 45) {
              if (this.keywordCheckRirekisho(formatData, isHuproinc_1KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isHuproinc_1KeywordArray)) {
                isHuproinc_1 = true
              }
              if (this.keywordCheckRirekisho(formatData, isHuproinc_1NotKeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isHuproinc_1NotKeywordArray)) {
                isHuproinc_1 = false
              }
            }
          }




          let isHuproinc_2KeywordArray = ['税理士法人', '社労士法人', '会計事務所', '社労士事務所', '税理士事務所', '簿記論', '財務諸表論', '相続税法', '消費税法', '酒税法', '国税徴収法', '所得税', '法人税', '住民税', '固定資産税', '事業税', '公認会計士', '月次決算', '年次決算', '四半期決算', '単体決算', '連結決算', '開示', '有価証券報告書の作成', 'Ⅰの部作成', '連結パッケージ', '法人税申告書作成', 'ショートレビュー', '税務申告', '巡回監査']
          let isHuproinc_2AddressArray = ['東京都', '大阪府']
          if (this.addressCheck(basicData, isHuproinc_2AddressArray)) {
            if (basicData.age >= 25 && basicData.age <= 45) {
              if (this.keywordCheckRirekisho(formatData, isHuproinc_2KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isHuproinc_2KeywordArray)) {
                isHuproinc_2 = true
              }
            }
          }



          let isTryt_3KeywordArray = ['初任者研修', '実務者研修', '介護福祉士', 'ケアマネジャー']
          let isTryt_3NotAddressArray = ['山梨県', '大分県', '鳥取県', '山口県', '青森県', '神奈川県', '富山県', '秋田県', '千葉県', '兵庫県', '島根県', '北海道', '愛知県', '栃木県', '岐阜県', '宮城県', '宮崎県']

          if (this.addressCheck(basicData, isTryt_3NotAddressArray)) {
            // NOT
          } else {
            if (basicData.age >= 23 && basicData.age <= 49) {
              if (this.keywordCheckRirekisho(formatData, isTryt_3KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isTryt_3KeywordArray)) {
                isTryt_3 = true
              }
            }
          }

          let isTryt_4KeywordArray = ['看護師', '助産師', '保健師']
          let isTryt_4NotAddressArray = ['東京都', '埼玉県', '福岡県']
          let isTryt_4NotKeywordArray = ['動物看護士', '介護士', '営業', '事務']
          if (this.addressCheck(basicData, isTryt_4NotAddressArray)) {
            // NOT
          } else {
            if (basicData.age >= 23 && basicData.age <= 54) {
              if (this.keywordCheckRirekisho(formatData, isTryt_4KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isTryt_4KeywordArray)) {
                isTryt_4 = true
              }
              if (this.keywordCheckRirekisho(formatData, isTryt_4NotKeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isTryt_4NotKeywordArray)) {
                isTryt_4 = false
              }
            }
          }

          let isGrandop_1KeywordArray = ['情報処理科', '情報システム科', '電子情報技術科', '情報学部', '工学部', '情報科学科', '情報工学科', 'コンピュータ科学科', '情報システム学科', '情報通信工学科', 'データサイエンス学部', 'データサイエンス学科', '人工知能学科']
          let isGrandop_1AddressArray = ['']
          if (true) {
            if (basicData.age >= 18 && basicData.age <= 35) {
              if (this.keywordCheckRirekisho(formatData, isGrandop_1KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isGrandop_1KeywordArray)) {
                isGrandop_1 = true
              }
            }
          }


          let isReaching_1KeywordArray = ['ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員']
          let isReaching_1AddressArray = ['東京都', '神奈川県', '埼玉県', '愛知県', '静岡県', '京都府', '大阪府', '兵庫県', '福岡県']
          if (this.addressCheck(basicData, isReaching_1AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 39) {
              if (this.keywordCheckRirekisho(formatData, isReaching_1KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isReaching_1KeywordArray)) {
                isReaching_1 = true
              }
            }
          }
          let isReaching_2KeywordArray = ['看護師']
          let isReaching_2AddressArray = ['神奈川県', '千葉県', '東京都', '埼玉県', '静岡県', '愛知県', '京都府', '大阪府', '兵庫県', '奈良県', '福岡県', '熊本県', '鹿児島県', '沖縄県']
          if (this.addressCheck(basicData, isReaching_2AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 59) {
              if (this.keywordCheckRirekisho(formatData, isReaching_2KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isReaching_2KeywordArray)) {
                isReaching_2 = true
              }
            }
          }
          let isReaching_3KeywordArray = ['保育士', '幼稚園教諭']
          let isReaching_3AddressArray = ['東京都', '埼玉県', '神奈川県', '愛知県', '大阪府', '兵庫県']
          if (this.addressCheck(basicData, isReaching_3AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 49) {
              if (this.keywordCheckRirekisho(formatData, isReaching_3KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isReaching_3KeywordArray)) {
                isReaching_3 = true
              }
            }
          }
          let isReaching_4KeywordArray = ['接客', '販売']
          let isReaching_4AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '愛知県', '大阪府']
          if (this.addressCheck(basicData, isReaching_4AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 29) {
              if (this.keywordCheckRirekisho(formatData, isReaching_4KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isReaching_4KeywordArray)) {
                isReaching_4 = true
              }
            }
          }
          let isReaching_5KeywordArray = ['機械', '生産技術', '生産管理', '品質管理', '品質保証', '研究開発', '制御設計', '設計開発', '電気設計', '回路設計']
          let isReaching_5AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県', '愛知県', '大阪府']
          if (this.addressCheck(basicData, isReaching_5AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 29) {
              if (this.keywordCheckRirekisho(formatData, isReaching_5KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isReaching_5KeywordArray)) {
                isReaching_5 = true
              }
            }
          }


          let isDagent_1KeywordArray = ['看護師', '正看護師 ', '准看護師']
          let isDagent_1AddressArray = ['大阪府', '兵庫県', '京都府', '奈良県', '北海道']
          if (this.addressCheck(basicData, isDagent_1AddressArray)) {
            if (basicData.age >= 30 && basicData.age <= 50) {
              if (this.keywordCheckRirekisho(formatData, isDagent_1KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isDagent_1KeywordArray)) {
                isDagent_1 = true
              }
            }
          }

          let isSimple_1KeywordArray = ['保育士', '幼稚園教諭']
          let isSimple_1AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県']
          let isSimple_1NotAddressArray = ['Simple株式会社']
          if (this.addressCheck(basicData, isSimple_1AddressArray)) {
            if (basicData.age >= 23 && basicData.age <= 50) {
              if (this.keywordCheckRirekisho(formatData, isSimple_1KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isSimple_1KeywordArray)) {
                isSimple_1 = true
              }
              if (this.keywordCheckRirekisho(formatData, isSimple_1NotAddressArray)
                || this.keywordCheckShokumukeirekisho(formatData, isSimple_1NotAddressArray)) {
                isSimple_1 = false
              }
            }
          }


          let isNoajpn_1KeywordArray = ['看護師', '准看護師']
          let isNoajpn_1AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '大阪府']
          if (this.addressCheck(basicData, isNoajpn_1AddressArray)) {
            if (basicData.age >= 40 && basicData.age <= 49) {
              if (this.keywordCheckRirekisho(formatData, isNoajpn_1KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isNoajpn_1KeywordArray)) {
                isNoajpn_1 = true
              }
            }
          }
          let isNoajpn_2KeywordArray = ['介護士', 'ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員']
          let isNoajpn_2AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '大阪府']
          if (this.addressCheck(basicData, isNoajpn_2AddressArray)) {
            if (basicData.age >= 25 && basicData.age <= 49) {
              if (this.keywordCheckRirekisho(formatData, isNoajpn_2KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isNoajpn_2KeywordArray)) {
                isNoajpn_2 = true
              }
            }
          }


          let isNineearth_1KeywordArray = ['介護福祉士', '初任者研修', '実務者研修', 'ヘルパー2級', 'ヘルパー1級', '介護士業務', '介護業務']
          let isNineearth_1AddressArray = ['愛知県', '岐阜県']
          if (this.addressCheck(basicData, isNineearth_1AddressArray)) {
            if (basicData.age >= 23 && basicData.age <= 60) {
              if (this.keywordCheckRirekisho(formatData, isNineearth_1KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isNineearth_1KeywordArray)) {
                isNineearth_1 = true
              }
            }
          }
          let isNineearth_2KeywordArray = ['介護福祉士', '初任者研修', '実務者研修', 'ヘルパー2級', 'ヘルパー1級', '介護士業務', '介護業務']
          let isNineearth_2AddressArray = ['東京都', '埼玉県']
          if (this.addressCheck(basicData, isNineearth_2AddressArray)) {
            if (basicData.age >= 23 && basicData.age <= 60) {
              if (this.keywordCheckRirekisho(formatData, isNineearth_2KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isNineearth_2KeywordArray)) {
                isNineearth_2 = true
              }
            }
          }

          let isAxes_1KeywordArray = ['介護士', 'ケアマネージャー', '初任者研修', '実務者研修', '介護福祉士', '社会福祉士', '介護支援専門員']
          let isAxes_1AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '埼玉県']
          if (this.addressCheck(basicData, isAxes_1AddressArray)) {
            if (basicData.age >= 18 && basicData.age <= 60) {
              if (this.keywordCheckRirekisho(formatData, isAxes_1KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isAxes_1KeywordArray)) {
                isAxes_1 = true
              }
            }
          }


          let isStarlabo_1KeywordArray = ['看護師']
          let isStarlabo_1AddressArray = ['東京都', '神奈川県', '埼玉県', '千葉県', '茨城県', '栃木県', '群馬県']
          if (this.addressCheck(basicData, isStarlabo_1AddressArray)) {
            if (basicData.age >= 25 && basicData.age <= 55) {
              if (this.keywordCheckRirekisho(formatData, isStarlabo_1KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isStarlabo_1KeywordArray)) {
                isStarlabo_1 = true
              }
            }
          }

          let isSupernurse_1KeywordArray = ['正看護師']
          let isSupernurse_1AddressArray = ['東京都', '神奈川県', '千葉県', '埼玉県']
          if (this.addressCheck(basicData, isSupernurse_1AddressArray)) {
            if (basicData.age >= 20 && basicData.age <= 59) {
              if (this.keywordCheckRirekisho(formatData, isSupernurse_1KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isSupernurse_1KeywordArray)) {
                isSupernurse_1 = true
              }
            }
          }

          let isStarlabo_2KeywordArray = ['施工管理']
          let isStarlabo_2AddressArray = ['東京都', '埼玉県', '千葉県', '神奈川県', '愛知県', '大阪府', '福岡県']
          if (this.addressCheck(basicData, isStarlabo_2AddressArray)) {
            if (basicData.age >= 30 && basicData.age <= 45) {
              if (this.keywordCheckRirekisho(formatData, isStarlabo_2KeywordArray)
                || this.keywordCheckShokumukeirekisho(formatData, isStarlabo_2KeywordArray)) {
                isStarlabo_2 = true
              }
            }
          }


          if (this.keywordCheck(formatId, formatData, '薬剤師')) {
            if (basicData.age >= 23 && basicData.age <= 50) {
              isRecruitMc1 = true
            }
          }
          let recruitMc2NotKeywordArray = ['獣', '歯科']
          if (this.keywordCheck(formatId, formatData, '医師免許')) {
            if (basicData.age >= 23 && basicData.age <= 65) {
              isRecruitMc2 = true
            }
            if (this.keywordCheckRirekisho(formatData, recruitMc2NotKeywordArray)) {
              isRecruitMc2 = false
            }
            if (this.keywordCheckShokumukeirekisho(formatData, recruitMc2NotKeywordArray)) {
              isRecruitMc2 = false
            }
          }


          for (let val in request_data) {
            // console.error(request_data[val].client_id)
            if (request_data[val].client_id == 'system_shared_mail' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isSystemShared4 = false
            }
            if (request_data[val].client_id == 'system_shared_mail' &&
              request_data[val].permission_type == 5 &&
              !request_data[val].request_able) {
              isSystemShared5 = false
            }
            if (request_data[val].client_id == 'system_shared_mail' &&
              request_data[val].permission_type == 6 &&
              !request_data[val].request_able) {
              isSystemShared6 = false
            }
            if (request_data[val].client_id == 'system_shared_mail' &&
              request_data[val].permission_type == 8 &&
              !request_data[val].request_able) {
              isSystemShared8 = false
            }
            if (request_data[val].client_id == 'system_shared_mail' &&
              request_data[val].permission_type == 9 &&
              !request_data[val].request_able) {
              isSystemShared9 = false
            }
            if (request_data[val].client_id == 'system_shared_mail' &&
              request_data[val].permission_type == 10 &&
              !request_data[val].request_able) {
              isSystemShared10 = false
            }
            if (request_data[val].client_id == 'miraiyu_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isMiraiyu_3 = false
            }
            if (request_data[val].client_id == 'miraiyu_mail' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isMiraiyu_4 = false
            }
            if (request_data[val].client_id == 'roxx_api' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isRoxx2 = false
            }
            if (request_data[val].client_id == 'roxx_api' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isRoxx = false
            }
            if (request_data[val].client_id == 'jobs919_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isJob919_1 = false
            }
            if (request_data[val].client_id == 'jobs919_mail' &&
              request_data[val].permission_type == 7 &&
              !request_data[val].request_able) {
              isJob919_7 = false
            }
            if (request_data[val].client_id == 'jobs919_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isJob919_2 = false
            }
            if (request_data[val].client_id == 'jobs919_mail' &&
              request_data[val].permission_type == 8 &&
              !request_data[val].request_able) {
              isJob919_8 = false
            }
            if (request_data[val].client_id == 'jobs919_mail' &&
              request_data[val].permission_type == 9 &&
              !request_data[val].request_able) {
              isJob919_9 = false
            }
            if (request_data[val].client_id == 'jobs919_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isJob919_3 = false
            }
            if (request_data[val].client_id == 'jobs919_mail' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isJob919_4 = false
            }
            if (request_data[val].client_id == 'jobs919_mail' &&
              request_data[val].permission_type == 5 &&
              !request_data[val].request_able) {
              isJob919_5 = false
            }
            if (request_data[val].client_id == 'jobs919_mail' &&
              request_data[val].permission_type == 6 &&
              !request_data[val].request_able) {
              isJob919_6 = false
            }


            if (request_data[val].client_id == 'persolinnovation_admin' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isPersolinnovation_1 = false
            }
            if (request_data[val].client_id == 'persolinnovation_admin' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isPersolinnovation_2 = false
            }

            if (request_data[val].client_id == 'persolinnovation_admin' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isPersolinnovation_3 = false
            }

            if (request_data[val].client_id == 'recrea_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isRecrea_1 = false
            }

            if (request_data[val].client_id == 'persolinnovation_admin' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isPersolinnovation_4 = false
            }

            if (request_data[val].client_id == 'hrcareer_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isHrcareer_1 = false
            }
            if (request_data[val].client_id == 'hrcareer_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isHrcareer_2 = false
            }
            if (request_data[val].client_id == 'hrcareer_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isHrcareer_3 = false
            }
            if (request_data[val].client_id == 'hrcareer_mail' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isHrcareer_4 = false
            }
            if (request_data[val].client_id == 'hrcareer_mail' &&
              request_data[val].permission_type == 5 &&
              !request_data[val].request_able) {
              isHrcareer_5 = false
            }
            if (request_data[val].client_id == 'hrcareer_mail' &&
              request_data[val].permission_type == 6 &&
              !request_data[val].request_able) {
              isHrcareer_6 = false
            }
            if (request_data[val].client_id == 'hrcareer_mail' &&
              request_data[val].permission_type == 7 &&
              !request_data[val].request_able) {
              isHrcareer_7 = false
            }
            if (request_data[val].client_id == 'hrcareer_mail' &&
              request_data[val].permission_type == 8 &&
              !request_data[val].request_able) {
              isHrcareer_8 = false
            }
            if (request_data[val].client_id == 'hrcareer_mail' &&
              request_data[val].permission_type == 9 &&
              !request_data[val].request_able) {
              isHrcareer_9 = false
            }
            if (request_data[val].client_id == 'hrcareer_mail' &&
              request_data[val].permission_type == 10 &&
              !request_data[val].request_able) {
              isHrcareer_10 = false
            }
            if (request_data[val].client_id == 'hrcareer_mail' &&
              request_data[val].permission_type == 13 &&
              !request_data[val].request_able) {
              isHrcareer_13 = false
            }
            if (request_data[val].client_id == 'hrcareer_mail' &&
              request_data[val].permission_type == 14 &&
              !request_data[val].request_able) {
              isHrcareer_14 = false
            }
            if (request_data[val].client_id == 'hrcareer_mail' &&
              request_data[val].permission_type == 11 &&
              !request_data[val].request_able) {
              isHrcareer_11 = false
            }
            if (request_data[val].client_id == 'hrcareer_mail' &&
              request_data[val].permission_type == 12 &&
              !request_data[val].request_able) {
              isHrcareer_12 = false
            }
            if (request_data[val].client_id == 'hrcareer_mail' &&
              request_data[val].permission_type == 15 &&
              !request_data[val].request_able) {
              isHrcareer_15 = false
            }

            if (request_data[val].client_id == 'leverages_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isLeverages_1 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isMedley1 = false
              isMedley2 = false
              isMedley3 = false
              isMedley4 = false
              isMedley5 = false
              isMedley6 = false
              isMedley7 = false
              isMedley8 = false
              isMedley9 = false
              isMedley10 = false
            }
            if (request_data[val].client_id == 'roxx_api' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isRoxx3 = false
            }
            if (request_data[val].client_id == 'roxx_api' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isRoxx_4 = false
            }
            if (request_data[val].client_id == 'roxx_api' &&
              request_data[val].permission_type == 5 &&
              !request_data[val].request_able) {
              isRoxx_5 = false
            }
            if (request_data[val].client_id == 'hitotech_admin' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isHitotech_1 = false
            }
            if (request_data[val].client_id == 'hitotech_admin' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isHitotech_2 = false
            }
            if (request_data[val].client_id == 'hitotech_admin' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isHitotech_3 = false
            }
            if (request_data[val].client_id == 'hitotech_admin' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isHitotech_4 = false
            }
            if (request_data[val].client_id == 'careerdraft_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isCareerdraft_1 = false
            }
            if (request_data[val].client_id == 'careerdraft_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isCareerdraft_2 = false
            }
            if (request_data[val].client_id == 'careerdraft_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isCareerdraft_3 = false
            }

            if (request_data[val].client_id == 'roxx_api' &&
              request_data[val].permission_type == 6 &&
              !request_data[val].request_able) {
              isRoxx_6 = false
            }
            if (request_data[val].client_id == 'roxx_api' &&
              request_data[val].permission_type == 7 &&
              !request_data[val].request_able) {
              isRoxx_7 = false
            }

            if (request_data[val].client_id == 'taikennyusha_link' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isTaikennyusha_1 = false
            }
            if (request_data[val].client_id == 'taikennyusha_link' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isTaikennyusha_2 = false
            }
            if (request_data[val].client_id == 'neocareer_new_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isNeocareerNew_1 = false
            }
            if (request_data[val].client_id == 'drtc_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isDrtc_1 = false
            }
            if (request_data[val].client_id == 'neocareer_admin' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isNeocareer_1 = false
            }
            if (request_data[val].client_id == 'neocareer_admin' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isHitotechNeocareer_1 = false
            }
            if (request_data[val].client_id == 'neocareer_admin' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isHitotechNeocareer_1 = false
            }
            if (request_data[val].client_id == 'hitotech_admin' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isHitotechNeocareer_1 = false
            }

            if (request_data[val].client_id == 'neocareer_admin' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isNeocareer_2 = false
            }
            if (request_data[val].client_id == 'hitoshia_admin' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isNeocareer_3 = false
            }
            if (request_data[val].client_id == 'hitoshia_admin' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isNeocareer_4 = false
            }

            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isPleiades_1 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isPleiades_2 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isPleiades_3 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isPleiades_4 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 5 &&
              !request_data[val].request_able) {
              isPleiades_5 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 6 &&
              !request_data[val].request_able) {
              isPleiades_6 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 7 &&
              !request_data[val].request_able) {
              isPleiades_7 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 8 &&
              !request_data[val].request_able) {
              isPleiades_8 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 9 &&
              !request_data[val].request_able) {
              isPleiades_9 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 10 &&
              !request_data[val].request_able) {
              isPleiades_10 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 18 &&
              !request_data[val].request_able) {
              isPleiades_18 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 11 &&
              !request_data[val].request_able) {
              isPleiades_11 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 12 &&
              !request_data[val].request_able) {
              isPleiades_12 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 13 &&
              !request_data[val].request_able) {
              isPleiades_13 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 14 &&
              !request_data[val].request_able) {
              isPleiades_14 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 15 &&
              !request_data[val].request_able) {
              isPleiades_15 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 16 &&
              !request_data[val].request_able) {
              isPleiades_16 = false
            }
            if (request_data[val].client_id == 'pleiades_mail' &&
              request_data[val].permission_type == 17 &&
              !request_data[val].request_able) {
              isPleiades_17 = false
            }

            if (request_data[val].client_id == 'peacekaigo_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isPeacekaigo_2 = false
            }

            if (request_data[val].client_id == 'jhr_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isJhr_1 = false
            }
            if (request_data[val].client_id == 'jhr_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isJhr_2 = false
            }
            if (request_data[val].client_id == 'peacekaigo_mail' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isPeacekaigo_4 = false
            }
            if (request_data[val].client_id == 'peacekaigo_mail' &&
              request_data[val].permission_type == 5 &&
              !request_data[val].request_able) {
              isPeacekaigo_5 = false
            }
            if (request_data[val].client_id == 'kirara_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isKirara = false
            }
            if (request_data[val].client_id == 'tryt_api' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isTryt = false
            }
            if (request_data[val].client_id == 'yagish_link' &&
              request_data[val].permission_type == 7 &&
              !request_data[val].request_able) {
              isYagish = false
            }
            if (request_data[val].client_id == 'yagish_admin' &&
              request_data[val].permission_type == 8 &&
              !request_data[val].request_able) {
              isYagish_8 = false
            }
            if (request_data[val].client_id == 'reastage_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isReastage_1 = false
            }
            if (request_data[val].client_id == 'mynavi_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isMynavi_1 = false
            }

            if (request_data[val].client_id == 'kikkakeagent_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isKikkakeagent_1 = false
            }


            if (request_data[val].client_id == 'cloudlink_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isCloudlink_1 = false
            }
            if (request_data[val].client_id == 'cloudlink_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isCloudlink_2 = false
            }

            if (request_data[val].client_id == 'heros_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isHeros_1 = false
            }
            if (request_data[val].client_id == 'heros_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isHeros_2 = false
            }

            if (request_data[val].client_id == 'huproinc_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isHuproinc_1 = false
            }
            if (request_data[val].client_id == 'huproinc_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isHuproinc_2 = false
            }

            if (request_data[val].client_id == 'nineearth_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isNineearth_1 = false
            }

            if (request_data[val].client_id == 'nineearth_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isNineearth_2 = false
            }

            if (request_data[val].client_id == 'axes_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isAxes_1 = false
            }

            if (request_data[val].client_id == 'starlabo_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isStarlabo_1 = false
            }

            if (request_data[val].client_id == 'supernurse_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isSupernurse_1 = false
            }

            if (request_data[val].client_id == 'starlabo_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isStarlabo_2 = false
            }


            if (request_data[val].client_id == 'tryt_api' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isTryt_3 = false
            }
            if (request_data[val].client_id == 'tryt_api' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isTryt_4 = false
            }


            if (request_data[val].client_id == 'reaching_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isReaching_1 = false
            }
            if (request_data[val].client_id == 'reaching_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isReaching_2 = false
            }
            if (request_data[val].client_id == 'reaching_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isReaching_3 = false
            }
            if (request_data[val].client_id == 'reaching_mail' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isReaching_4 = false
            }
            if (request_data[val].client_id == 'reaching_mail' &&
              request_data[val].permission_type == 5 &&
              !request_data[val].request_able) {
              isReaching_5 = false
            }

            if (request_data[val].client_id == 'dagent_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isDagent_1 = false
            }

            if (request_data[val].client_id == 'grandop_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isGrandop_1 = false
            }

            if (request_data[val].client_id == 'simple_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isSimple_1 = false
            }

            if (request_data[val].client_id == 'noajpn_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isNoajpn_1 = false
            }

            if (request_data[val].client_id == 'noajpn_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isNoajpn_2 = false
            }


            if (request_data[val].client_id == 'recruit_mc_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isRecruitMc1 = false
            }

            if (request_data[val].client_id == 'krasys_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isKrasys_2 = false
            }
            if (request_data[val].client_id == 'pharmacareer_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isPharmacareer_1 = false
            }
            if (request_data[val].client_id == 'recruit_mc_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isRecruitMc2 = false
            }

            if (request_data[val].client_id == 'asiro_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isAsiro_1 = false
            }
            if (request_data[val].client_id == 'asiro_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isAsiro_2 = false
            }
            if (request_data[val].client_id == 'asiro_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isAsiro_3 = false
            }
            if (request_data[val].client_id == 'asiro_mail' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isAsiro_4 = false
            }
            if (request_data[val].client_id == 'asiro_mail' &&
              request_data[val].permission_type == 5 &&
              !request_data[val].request_able) {
              isAsiro_5 = false
            }
            if (request_data[val].client_id == 'asiro_mail' &&
              request_data[val].permission_type == 6 &&
              !request_data[val].request_able) {
              isAsiro_6 = false
            }
            if (request_data[val].client_id == 'capla_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isCapla_1 = false
            }
            if (request_data[val].client_id == 'capla_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isCapla_2 = false
            }
            if (request_data[val].client_id == 'bridge_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isBridge_1 = false
            }

            if (request_data[val].client_id == 'rozas_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isRozas_1 = false
            }
            if (request_data[val].client_id == 'rozas_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isRozas_2 = false
            }
            if (request_data[val].client_id == 'rozas_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isRozas_3 = false
            }
            if (request_data[val].client_id == 'rozas_mail' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isRozas_4 = false
            }
            if (request_data[val].client_id == 'rozas_mail' &&
              request_data[val].permission_type == 5 &&
              !request_data[val].request_able) {
              isRozas_5 = false
            }
            if (request_data[val].client_id == 'tunaguba_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isTunaguba_1 = false
            }
            if (request_data[val].client_id == 'dely_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isDely_1 = false
            }
            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isXmile_1 = false
            }
            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isXmile_2 = false
            }
            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isXmile_3 = false
            }
            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isXmile_4 = false
            }

            if (request_data[val].client_id == 'workport_admin' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isWorkport_1 = false
            }

            if (request_data[val].client_id == 'workport_admin' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isWorkport_4 = false
            }
            if (request_data[val].client_id == 'briedge_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isBriedge_1 = false
            }
            if (request_data[val].client_id == 'awesome_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isAwesome_1 = false
            }

            if (request_data[val].client_id == 'prolg_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isProlg_1 = false
            }

            if (request_data[val].client_id == 'prolg_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isProlg_2 = false
            }

            if (request_data[val].client_id == 'smartforce_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isSmartforce_1 = false
            }

            if (request_data[val].client_id == 'kiminara_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isKiminara_1 = false
            }
            if (request_data[val].client_id == 'kiminara_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isKiminara_2 = false
            }
            if (request_data[val].client_id == 'cloudlink_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isCloudlink_3 = false
            }


            if (request_data[val].client_id == 'bearsnavi_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isBearsnavi_1 = false
            }
            if (request_data[val].client_id == 'bearsnavi_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isBearsnavi_2 = false
            }
            if (request_data[val].client_id == 'bearsnavi_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isBearsnavi_3 = false
            }

            if (request_data[val].client_id == 'strike_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isStrike_1 = false
            }

            if (request_data[val].client_id == 'internous_link' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isInternous_1 = false
            }

            if (request_data[val].client_id == 'internous_link' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isInternous_2 = false
            }

            if (request_data[val].client_id == 'internous_link' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isInternous_3 = false
            }

            if (request_data[val].client_id == 'internous_link' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isInternous_4 = false
            }

            if (request_data[val].client_id == 'internous_link' &&
              request_data[val].permission_type == 5 &&
              !request_data[val].request_able) {
              isInternous_5 = false
            }

            if (request_data[val].client_id == 'workport_admin' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isWorkport_2 = false
            }

            if (request_data[val].client_id == 'workport_admin' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isWorkport_3 = false
            }

            if (request_data[val].client_id == 'agrinavi_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isAgrinavi_1 = false
            }
            if (request_data[val].client_id == 'techouse_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isTechouse_1 = false
            }
            if (request_data[val].client_id == 'techouse_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isTechouse_2 = false
            }
            if (request_data[val].client_id == 'techouse_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isTechouse_3 = false
            }

            if (request_data[val].client_id == 'outsourcing_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isOutsourcing_1 = false
            }

            if (request_data[val].client_id == 'cookbiz_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isCookbiz_1 = false
            }
            if (request_data[val].client_id == 'cookbiz_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isCookbiz_2 = false
            }
            if (request_data[val].client_id == 'cookbiz_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isCookbiz_3 = false
            }
            if (request_data[val].client_id == 'hitolabo_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isHitolabo_1 = false
            }

            if (request_data[val].client_id == 'hitolabo_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isHitolabo_2 = false
            }

            if (request_data[val].client_id == 'foodison_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isFoodison_1 = false
            }
            if (request_data[val].client_id == 'foodison_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isFoodison_2 = false
            }
            if (request_data[val].client_id == 'foodison_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isFoodison_3 = false
            }

            if (request_data[val].client_id == 'oishiru_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isOishiru_1 = false
            }

            if (request_data[val].client_id == 'hayfield_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isHayfield_1 = false
            }

            if (request_data[val].client_id == 'itk_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isItk_1 = false
            }

            if (request_data[val].client_id == 'primalwork_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isPrimalwork_1 = false
            }
            if (request_data[val].client_id == 'talentnavi_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isTalentnavi_1 = false
            }
            if (request_data[val].client_id == 'azurite_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isAzurite_1 = false
            }
            if (request_data[val].client_id == 'azurite_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isAzurite_2 = false
            }
            if (request_data[val].client_id == '400f_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              is400F_1 = false
            }
            if (request_data[val].client_id == 'usenworking_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isUsenworking_1 = false
            }
            if (request_data[val].client_id == 'usenworking_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isUsenworking_2 = false
            }
            if (request_data[val].client_id == 'usenworking_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isUsenworking_3 = false
            }
            if (request_data[val].client_id == 'usenworking_mail' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isUsenworking_4 = false
            }

            if (request_data[val].client_id == 'recree_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isRecree_1 = false
            }

            if (request_data[val].client_id == 'recree_mail' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isRecree_2 = false
            }

            if (request_data[val].client_id == 'recree_mail' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isRecree_3 = false
            }

            if (request_data[val].client_id == 'recree_mail' &&
              request_data[val].permission_type == 4 &&
              !request_data[val].request_able) {
              isRecree_4 = false
            }

            if (request_data[val].client_id == 'recree_mail' &&
              request_data[val].permission_type == 5 &&
              !request_data[val].request_able) {
              isRecree_5 = false
            }

            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 5 &&
              !request_data[val].request_able) {
              isXmile_5 = false
            }
            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 6 &&
              !request_data[val].request_able) {
              isXmile_6 = false
            }
            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 7 &&
              !request_data[val].request_able) {
              isXmile_7 = false
            }
            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 8 &&
              !request_data[val].request_able) {
              isXmile_8 = false
            }
            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 9 &&
              !request_data[val].request_able) {
              isXmile_9 = false
            }
            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 10 &&
              !request_data[val].request_able) {
              isXmile_10 = false
            }
            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 11 &&
              !request_data[val].request_able) {
              isXmile_11 = false
            }
            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 12 &&
              !request_data[val].request_able) {
              isXmile_12 = false
            }
            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 13 &&
              !request_data[val].request_able) {
              isXmile_13 = false
            }
            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 14 &&
              !request_data[val].request_able) {
              isXmile_14 = false
            }
            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 15 &&
              !request_data[val].request_able) {
              isXmile_15 = false
            }
            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 16 &&
              !request_data[val].request_able) {
              isXmile_16 = false
            }
            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 17 &&
              !request_data[val].request_able) {
              isXmile_17 = false
            }
            if (request_data[val].client_id == 'xmile_mail' &&
              request_data[val].permission_type == 18 &&
              !request_data[val].request_able) {
              isXmile_18 = false
            }



            if (request_data[val].client_id == 'growtrail_admin' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isArowtrail_1 = false
            }

            if (request_data[val].client_id == 'growtrail_admin' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isArowtrail_2 = false
            }

            if (request_data[val].client_id == 'growtrail_admin' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isArowtrail_3 = false
            }
            if (request_data[val].client_id == 'yagish_test_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isYagish_1 = false
            }
            if (request_data[val].client_id == 'sms_admin' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isSms_1 = false
            }
            if (request_data[val].client_id == 'sms_admin_eiyoshi' &&
              request_data[val].permission_type == 2 &&
              !request_data[val].request_able) {
              isSms_2 = false
            }
            if (request_data[val].client_id == 'sms_admin_hoiku' &&
              request_data[val].permission_type == 3 &&
              !request_data[val].request_able) {
              isSms_3 = false
            }

            if (request_data[val].client_id == 'huemaridge_mail' &&
              request_data[val].permission_type == 1 &&
              !request_data[val].request_able) {
              isHuemaridge_1 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 5 &&
              !request_data[val].request_able) {
              isMedley_Link_5 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 6 &&
              !request_data[val].request_able) {
              isMedley_Link_6 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 7 &&
              !request_data[val].request_able) {
              isMedley_Link_7 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 8 &&
              !request_data[val].request_able) {
              isMedley_Link_8 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 9 &&
              !request_data[val].request_able) {
              isMedley_Link_9 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 10 &&
              !request_data[val].request_able) {
              isMedley_Link_10 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 11 &&
              !request_data[val].request_able) {
              isMedley_Link_11 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 12 &&
              !request_data[val].request_able) {
              isMedley_Link_12 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 13 &&
              !request_data[val].request_able) {
              isMedley_Link_13 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 14 &&
              !request_data[val].request_able) {
              isMedley_Link_14 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 15 &&
              !request_data[val].request_able) {
              isMedley_Link_15 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 16 &&
              !request_data[val].request_able) {
              isMedley_Link_16 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 17 &&
              !request_data[val].request_able) {
              isMedley_Link_17 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 18 &&
              !request_data[val].request_able) {
              isMedley_Link_18 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 19 &&
              !request_data[val].request_able) {
              isMedley_Link_19 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 20 &&
              !request_data[val].request_able) {
              isMedley_Link_20 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 21 &&
              !request_data[val].request_able) {
              isMedley_Link_21 = false
            }

            if (request_data[val].client_id == 'medley_link' &&
              request_data[val].permission_type == 22 &&
              !request_data[val].request_able) {
              isMedley_Link_22 = false
            }
          }
          /*
          const clientPermissions = {
            system_shared_mail: [4, 5, 6, 8, 9, 10],
            miraiyu_mail: [3, 4],
            roxx_api: [1, 2, 3, 4],
            jobs919_mail: [1, 2, 3, 4, 5, 6, 7, 8, 9],
            problemsolving_mail: [1, 2],
            persolinnovation_admin: [1, 2],
            hrcareer_mail: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
            medley_link: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22],
            hitotech_admin: [1, 2, 3, 4],
            careerdraft_mail: [1],
            neocareer_admin: [1, 2],
            hitotech_neocareer: [1, 2, 3],
            hitoshia_admin: [3, 4],
            hoikushikyujin_mail: [1, 2],
            pleiades_mail: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18],
            peacekaigo_mail: [1, 2, 3, 4, 5],
            kirara_mail: [1],
            tryt_api: [2],
            yagish_link: [7],
            yagish_admin: [8],
            reastage_mail: [1],
            mynavi_mail: [1],
            recruit_mc_mail: [1, 2],
            krasys_mail: [1, 2],
            pharmacareer_mail: [1],
            asiro_mail: [1, 2, 3, 4, 5, 6],
            capla_mail: [1, 2],
            bridge_mail: [1],
            rozas_mail: [1],
            tunaguba_mail: [1],
            dely_mail: [1],
            xmile_mail: [1, 2, 3, 4],
            cellpromote_mail: [1],
            workport_admin: [1, 2, 3, 4],
            loginess_mail: [1],
            agrinavi_mail: [1, 2],
            techouse_mail: [1, 2, 3],
            f400_mail: [1],
            usenworking_mail: [1, 2, 3, 4],
            recree_mail: [1, 2, 3, 4, 5],
            growtrail_admin: [1, 2, 3],
            yagish_test_mail: [1],
            sms_admin: [1],
            sms_admin_eiyoshi: [2],
            sms_admin_hoiku: [3],
          };
          
          // request_data をループして `false` にする
          request_data.forEach(({ client_id, permission_type, request_able }) => {
            if (clientPermissions[client_id] && clientPermissions[client_id].includes(permission_type) && !request_able) {
              const varName = `is${client_id.replace(/_/g, "").charAt(0).toUpperCase() + client_id.slice(1)}_${permission_type}`;
              if (this[varName] !== undefined) {
                this[varName] = false;
              }
            }
          });
          */

          const nowdate3 = new Date()
          console.error(nowdate3)
          // if (isSms_1 && (formatId == "rirekisho_job_change" || formatId == "rirekisho_ai_career" ||
          //   formatId == "rirekisho_job_change2" ||
          //   formatId == "rirekisho_job_change_old" ||
          //   formatId == "rirekisho_single" ||
          //   formatId == "rirekisho_nophoto_double" ||
          //   formatId == "rirekisho_nophoto" ||
          //   formatId.includes('shokumukeirekisho'))) {
          //   this.$eventHub.$emit('open-sms-dialog', formatId, previewFormat, 1, basicData)
          // } else
          if (isYagish_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {


            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/yagish_logo_20230522.png',
              clientId: 'yagish_test_mail',
              dialogName: 'yagish-dialog',
              clientName: '株式会社Yagish',
              termurl: 'https://-',
              privacyurl: 'https://-',
              clientServiceName: '株式会社Yagish',
              subArea1: '株式会社Yagishをご紹介します！'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)
          } else if (isJob919_5 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            this.$eventHub.$emit('open-jobs919-dialog', formatId, previewFormat, 5, basicData)
          } else if (isTryt && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-tryt-dialog', formatId, previewFormat, 2)
          } else if (isSystemShared4 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-systemshared-dialog', formatId, previewFormat, 4)
          } else if (isXmile_5 && this.isJobChangeShokumukeirekiFormat(formatId)) {

            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/xmile_5_yagish_logo.png',
              clientId: 'xmile_mail',
              dialogName: 'xmile-dialog',
              clientName: 'X Mile株式会社',
              termurl: 'https://www.xmile.co.jp/policy/08',
              privacyurl: 'https://www.xmile.co.jp/policy/06',
              clientServiceName: 'クロスワーク'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 5, dialogInfo, basicData)
            // } else if (isJob919_1 && this.isJobChangeFormat(formatId)) {
            //   this.$eventHub.$emit('open-jobs919-dialog', formatId, previewFormat, 1)
          } else if (isJob919_1 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-jobs919-dialog', formatId, previewFormat, 1)
            // } else if (isXmile_5 && this.isJobChangeShokumukeirekiFormat(formatId)) {

            //   const dialogInfo = {
            //     logoImage: '/static/renew3_img/rt/xmile_5_yagish_logo.png',
            //     clientId: 'xmile_mail',
            //     dialogName: 'xmile-dialog',
            //     clientName: 'X Mile株式会社',
            //     termurl: 'https://www.xmile.co.jp/policy/08',
            //     privacyurl: 'https://www.xmile.co.jp/policy/06',
            //     clientServiceName: 'クロスワーク'
            //   }
            //   this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 5, dialogInfo, basicData)
          } else if (isJob919_7 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-jobs919-dialog', formatId, previewFormat, 7)
          } else if (isJob919_2 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-jobs919-dialog', formatId, previewFormat, 2)
          } else if (isJob919_8 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-jobs919-dialog', formatId, previewFormat, 8)
          } else if (isJob919_9 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-jobs919-dialog', formatId, previewFormat, 9)
          } else if (isJob919_3 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-jobs919-dialog', formatId, previewFormat, 3)
          } else if (isJob919_4 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-jobs919-dialog', formatId, previewFormat, 4)
          } else if (isHrcareer_9 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-hrcareer-dialog', formatId, previewFormat, 9)
          } else if (isHrcareer_10 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-hrcareer-dialog', formatId, previewFormat, 10)
          } else if (isSms_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/sms_2_yagish_logo_20250205.png',
              clientId: 'sms_admin_eiyoshi',
              dialogName: 'sms-dialog',
              clientName: '株式会社エス･エム･エス',
              termurl: 'https://policy.bm-sms.co.jp/consumer/terms/jinzaibank-com',
              privacyurl: 'https://policy.bm-sms.co.jp/consumer/privacy/policy',
              clientServiceName: 'キャリア支援サービス'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData)

          } else if (isKrasys_2 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-krasys-dialog', formatId, previewFormat, 2)
          } else if (isKikkakeagent_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/kikkakeagent_yagish_logo_20250326.png',
              clientId: 'kikkakeagent_mail',
              dialogName: 'kikkakeagent-dialog',
              clientName: '株式会社キッカケクリエイション',
              termurl: 'https://kikkakeagent.com/terms/',
              privacyurl: 'https://kikkakecreation.com/privacy/',
              clientServiceName: 'キッカケエージェント'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)

          } else if (isCloudlink_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/cloudlink_1_yagish_logo.png',
              clientId: 'cloudlink_mail',
              dialogName: 'cloudlink-dialog',
              clientName: '株式会社Cloud Link',
              termurl: 'https://cloud-link.co.jp/terms-of-service/',
              privacyurl: 'https://cloud-link.co.jp/privacy-policy/',
              clientServiceName: 'Cloud Link',
              setTimeLink: 'https://cloud-link.eeasy.jp/shokai_mendan_kikai'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)

          } else if (isCloudlink_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/cloudlink_2_yagish_logo.png',
              clientId: 'cloudlink_mail',
              dialogName: 'cloudlink-dialog',
              clientName: '株式会社Cloud Link',
              termurl: 'https://cloud-link.co.jp/terms-of-service/',
              privacyurl: 'https://cloud-link.co.jp/privacy-policy/',
              clientServiceName: 'Cloud Link',
              setTimeLink: 'https://cloud-link.eeasy.jp/shokai_mendan_IT'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData)

          } else if (isGrandop_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/grandop_1_yagish_logo.png',
              clientId: 'grandop_mail',
              dialogName: 'grandop-dialog',
              clientName: '株式会社GRANDOP',
              termurl: 'https://drive.google.com/file/d/1iMBrcbmhvd_tKTyCE8VnETWN5q87_HrE/view?usp=sharing',
              privacyurl: 'https://grandop.net/wp/recruitment-business-privacy-policy/',
              clientServiceName: 'GRANDOP'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)

          } else if (isReaching_4 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/reaching_4_yagish_logo.png',
              clientId: 'reaching_mail',
              dialogName: 'reaching-dialog',
              clientName: '株式会社リーチング',
              termurl: 'https://drive.google.com/file/d/1KaXtYZ5lC8ZZebo2Z2Uyo-M96B5yXW7f/view?usp=sharing',
              privacyurl: 'https://drive.google.com/file/d/1-clvJ--G6NKE26Y194fz6uf0wNfCI22u/view?usp=drive_link',
              clientServiceName: 'JOBリーチ'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 4, dialogInfo, basicData)

          } else if (isReaching_5 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/reaching_5_yagish_logo.png',
              clientId: 'reaching_mail',
              dialogName: 'reaching-dialog',
              clientName: '株式会社リーチング',
              termurl: 'https://drive.google.com/file/d/1KaXtYZ5lC8ZZebo2Z2Uyo-M96B5yXW7f/view?usp=sharing',
              privacyurl: 'https://drive.google.com/file/d/1-clvJ--G6NKE26Y194fz6uf0wNfCI22u/view?usp=drive_link',
              clientServiceName: 'JOBリーチ'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 5, dialogInfo, basicData)

          } else if (isHeros_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/heros_1_yagish_logo.png',
              clientId: 'heros_mail',
              dialogName: 'heros-dialog',
              clientName: '株式会社HeRos',
              termurl: 'https://hr-heros.co.jp/term',
              privacyurl: 'https://hr-heros.co.jp/privacy',
              clientServiceName: 'セカチャレ！'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)

          } else if (isHeros_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/heros_2_yagish_logo.png',
              clientId: 'heros_mail',
              dialogName: 'heros-dialog',
              clientName: '株式会社HeRos',
              termurl: 'https://hr-heros.co.jp/term',
              privacyurl: 'https://hr-heros.co.jp/privacy',
              clientServiceName: 'セカチャレ！'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData)

          } else if (isHuproinc_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/huproinc_yagish_logo_20250406.png',
              clientId: 'huproinc_mail',
              dialogName: 'huproinc-dialog',
              clientName: '株式会社ヒュープロ',
              termurl: 'https://hupro-job.com/terms',
              privacyurl: 'https://hupro-job.com/privacy_policy',
              clientServiceName: 'ヒュープロ'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)

          } else if (isHuproinc_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/huproinc_yagish_logo_20250406.png',
              clientId: 'huproinc_mail',
              dialogName: 'huproinc-dialog',
              clientName: '株式会社ヒュープロ',
              termurl: 'https://hupro-job.com/terms',
              privacyurl: 'https://hupro-job.com/privacy_policy',
              clientServiceName: 'ヒュープロ'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData)

          } else if (isNeocareer_3 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-neocareer-dialog', formatId, previewFormat, 3, formatData.gradeYear)
          } else if (isNeocareer_4 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-neocareer-dialog', formatId, previewFormat, 4, formatData.gradeYear)
          } else if (isMedley_Link_11 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-medley-dialog', formatId, previewFormat, 0, 11)
          } else if (isMedley_Link_12 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-medley-dialog', formatId, previewFormat, 0, 12)
          } else if (isMedley_Link_13 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-medley-dialog', formatId, previewFormat, 0, 13)
          } else if (isMedley_Link_14 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-medley-dialog', formatId, previewFormat, 0, 14)
          } else if (isMedley_Link_15 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-medley-dialog', formatId, previewFormat, 0, 15)
          } else if (isMedley_Link_16 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-medley-dialog', formatId, previewFormat, 0, 16)
          } else if (isMedley_Link_17 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-medley-dialog', formatId, previewFormat, 0, 17)
          } else if (isMedley_Link_18 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-medley-dialog', formatId, previewFormat, 0, 18)
          } else if (isMedley_Link_19 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-medley-dialog', formatId, previewFormat, 0, 19)
          } else if (isMedley_Link_20 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-medley-dialog', formatId, previewFormat, 0, 20)
          } else if (isMedley_Link_21 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-medley-dialog', formatId, previewFormat, 0, 21)
          } else if (isMedley_Link_22 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-medley-dialog', formatId, previewFormat, 0, 22)
          } else if (isPleiades_1 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-pleiades-dialog', formatId, previewFormat, 1)
          } else if (isPleiades_9 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-pleiades-dialog', formatId, previewFormat, 9)
          } else if (isPleiades_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            this.$eventHub.$emit('open-pleiades-dialog', formatId, previewFormat, 2, basicData)
          } else if (isPleiades_3 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-pleiades-dialog', formatId, previewFormat, 3)
          } else if (isPleiades_4 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-pleiades-dialog', formatId, previewFormat, 4)
          } else if (isPleiades_5 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-pleiades-dialog', formatId, previewFormat, 5)
          } else if (isPleiades_6 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-pleiades-dialog', formatId, previewFormat, 6)
          } else if (isPleiades_7 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-pleiades-dialog', formatId, previewFormat, 7)
          } else if (isPleiades_8 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-pleiades-dialog', formatId, previewFormat, 8)
          } else if (isPleiades_10 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            this.$eventHub.$emit('open-pleiades-dialog', formatId, previewFormat, 10, basicData)
          } else if (isPleiades_18 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            this.$eventHub.$emit('open-pleiades-dialog', formatId, previewFormat, 18, basicData)
          } else if (isPleiades_11 && (formatId.includes('shokumukeirekisho'))) {
            this.$eventHub.$emit('open-pleiades-dialog', formatId, previewFormat, 11, basicData)
          } else if (isPleiades_12 && (this.isJobChangeShokumukeirekiFormat(formatId))) {
            this.$eventHub.$emit('open-pleiades-dialog', formatId, previewFormat, 12, basicData)
          } else if (isPleiades_13 && (this.isJobChangeShokumukeirekiFormat(formatId))) {
            this.$eventHub.$emit('open-pleiades-dialog', formatId, previewFormat, 13, basicData)
          } else if (isPleiades_14 && (formatId.includes('shokumukeirekisho'))) {
            this.$eventHub.$emit('open-pleiades-dialog', formatId, previewFormat, 14, basicData)
          } else if (isPleiades_15 && (formatId.includes('shokumukeirekisho'))) {
            this.$eventHub.$emit('open-pleiades-dialog', formatId, previewFormat, 15, basicData)
          } else if (isPleiades_16 && (formatId.includes('shokumukeirekisho'))) {
            this.$eventHub.$emit('open-pleiades-dialog', formatId, previewFormat, 16, basicData)
          } else if (isPleiades_17 && (formatId.includes('shokumukeirekisho'))) {
            this.$eventHub.$emit('open-pleiades-dialog', formatId, previewFormat, 17, basicData)
          } else if (isCapla_1 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-capla-dialog', formatId, previewFormat, 1)
          } else if (isCapla_2 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-capla-dialog', formatId, previewFormat, 2)
          } else if (isReastage_1 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-reastage-dialog', formatId, previewFormat, 1)
          } else if (isJob919_6 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-jobs919-dialog', formatId, previewFormat, 6)
          } else if (isPeacekaigo_2 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-peacekaigo-dialog', formatId, previewFormat, 2, basicData)
          } else if (isHrcareer_1 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-hrcareer-dialog', formatId, previewFormat, 1)
          } else if (isHrcareer_2 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-hrcareer-dialog', formatId, previewFormat, 2)
          } else if (isHrcareer_3 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-hrcareer-dialog', formatId, previewFormat, 3)
          } else if (isHrcareer_4 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-hrcareer-dialog', formatId, previewFormat, 4)
          } else if (isPersolinnovation_1 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-persolinnovation-dialog', formatId, previewFormat, 1, basicData)
          } else if (isPersolinnovation_2 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-persolinnovation-dialog', formatId, previewFormat, 2, basicData)
          } else if (isPersolinnovation_4 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-persolinnovation-dialog', formatId, previewFormat, 4, basicData)
          } else if (isLeverages_1 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/leverages_1_yagish_logo.png',
              clientId: 'leverages_mail',
              dialogName: 'leverages-dialog',
              clientName: 'レバウェル株式会社',
              termurl: 'https://levwell.jp/terms/',
              privacyurl: 'https://leverages.jp/privacypolicy/ ',
              clientServiceName: 'レバウェル保育士'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)

          } else if (isHrcareer_5 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-hrcareer-dialog', formatId, previewFormat, 5)
          } else if (isHrcareer_6 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-hrcareer-dialog', formatId, previewFormat, 6)
          } else if (isHrcareer_7 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-hrcareer-dialog', formatId, previewFormat, 7)
          } else if (isHrcareer_8 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-hrcareer-dialog', formatId, previewFormat, 8)
          } else if (isHrcareer_13 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-hrcareer-dialog', formatId, previewFormat, 13)
          } else if (isHrcareer_14 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-hrcareer-dialog', formatId, previewFormat, 14)
          } else if (isHrcareer_11 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-hrcareer-dialog', formatId, previewFormat, 11)
          } else if (isHrcareer_12 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-hrcareer-dialog', formatId, previewFormat, 12)
          } else if (isHrcareer_15 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-hrcareer-dialog', formatId, previewFormat, 15)
          } else if (isReaching_1 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/reaching_1_yagish_logo.jpg',
              clientId: 'reaching_mail',
              dialogName: 'reaching-dialog',
              clientName: '株式会社リーチング',
              termurl: 'https://drive.google.com/file/d/1KaXtYZ5lC8ZZebo2Z2Uyo-M96B5yXW7f/view?usp=sharing',
              privacyurl: 'https://drive.google.com/file/d/1-clvJ--G6NKE26Y194fz6uf0wNfCI22u/view?usp=drive_link',
              clientServiceName: '介護リーチ'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)

          } else if (isTryt_4 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/tryt_4_yagish_logo.png',
              clientId: 'tryt_api',
              dialogName: 'tryt-dialog',
              clientName: '株式会社トライトキャリア',
              termurl: 'https://iryouworker.com/company/sitepolicy/',
              privacyurl: 'https://iryouworker.com/company/privacypolicy/',
              handlingurl: 'https://iryouworker.com/company/handling/',
              clientServiceName: '看護師ワーカー'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 4, dialogInfo, basicData)

          } else if (isTryt_3 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/tryt_3_yagish_logo.png',
              clientId: 'tryt_api',
              dialogName: 'tryt-dialog',
              clientName: '株式会社トライトキャリア',
              termurl: 'https://kaigoworker.jp/company/sitepolicy/',
              privacyurl: 'https://kaigoworker.jp/company/privacypolicy/',
              handlingurl: 'https://kaigoworker.jp/company/handling/',
              clientServiceName: '介護ワーカー'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 3, dialogInfo, basicData)

          } else if (isReaching_2 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/reaching_2_yagish_logo.jpg',
              clientId: 'reaching_mail',
              dialogName: 'reaching-dialog',
              clientName: '株式会社リーチング',
              termurl: 'https://drive.google.com/file/d/1KaXtYZ5lC8ZZebo2Z2Uyo-M96B5yXW7f/view?usp=sharing',
              privacyurl: 'https://drive.google.com/file/d/1-clvJ--G6NKE26Y194fz6uf0wNfCI22u/view?usp=drive_link',
              clientServiceName: '看護リーチ'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData)

          } else if (isDagent_1 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/dagent_1_yagish_logo.png',
              clientId: 'dagent_mail',
              dialogName: 'dagent-dialog',
              clientName: '株式会社デイリー・インフォメーション関西',
              termurl: 'https://d-agent.net/terms/',
              privacyurl: 'https://dac-kansai.co.jp/privacypolicy/',
              clientServiceName: 'D-agent'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)

          } else if (isReaching_3 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/reaching_3_yagish_logo.jpg',
              clientId: 'reaching_mail',
              dialogName: 'reaching-dialog',
              clientName: '株式会社リーチング',
              termurl: 'https://drive.google.com/file/d/1KaXtYZ5lC8ZZebo2Z2Uyo-M96B5yXW7f/view?usp=sharing',
              privacyurl: 'https://drive.google.com/file/d/1-clvJ--G6NKE26Y194fz6uf0wNfCI22u/view?usp=drive_link',
              clientServiceName: '保育リーチ'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 3, dialogInfo, basicData)

          } else if (isRozas_1 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-rozas-dialog', formatId, previewFormat, 1)
          } else if (isRozas_2 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-rozas-dialog', formatId, previewFormat, 2)
          } else if (isRozas_3 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-rozas-dialog', formatId, previewFormat, 3)
          } else if (isRozas_4 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-rozas-dialog', formatId, previewFormat, 4)
          } else if (isRozas_5 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-rozas-dialog', formatId, previewFormat, 5)
          } else if (isSimple_1 && this.isJobChangeFormat(formatId)) {

            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/simple_1_yagish_logo.png',
              clientId: 'simple_mail',
              dialogName: 'simple-dialog',
              clientName: 'Simple株式会社',
              termurl: 'https://simple-hoiku.com/use-policy',
              privacyurl: 'https://simple-hoiku.com/privacypolicy',
              clientServiceName: 'しんぷる保育'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)

          } else if (isNoajpn_1 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/noajpn_1_yagish_logo.jpg',
              clientId: 'noajpn_mail',
              dialogName: 'noajpn-dialog',
              clientName: 'NOA・JAPAN株式会社',
              termurl: 'https://noa-jpn.com/terms/?_gl=1*1auq0g3*_ga*MjQ5NDMyMzA0LjE3MTY0NTA1NTk.*_ga_890K6PB6H2*MTc0NTI4ODk0Ny43NC4xLjE3NDUyODg5ODAuMC4wLjA.',
              privacyurl: 'https://noa-jpn.com/terms/?_gl=1*1auq0g3*_ga*MjQ5NDMyMzA0LjE3MTY0NTA1NTk.*_ga_890K6PB6H2*MTc0NTI4ODk0Ny43NC4xLjE3NDUyODg5ODAuMC4wLjA.',
              clientServiceName: 'NOA・JAPAN'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)

          } else if (isNoajpn_2 && this.isJobChangeFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/noajpn_2_yagish_logo.jpg',
              clientId: 'noajpn_mail',
              dialogName: 'noajpn-dialog',
              clientName: 'NOA・JAPAN株式会社',
              termurl: 'https://noa-jpn.com/terms/?_gl=1*1auq0g3*_ga*MjQ5NDMyMzA0LjE3MTY0NTA1NTk.*_ga_890K6PB6H2*MTc0NTI4ODk0Ny43NC4xLjE3NDUyODg5ODAuMC4wLjA.',
              privacyurl: 'https://noa-jpn.com/terms/?_gl=1*1auq0g3*_ga*MjQ5NDMyMzA0LjE3MTY0NTA1NTk.*_ga_890K6PB6H2*MTc0NTI4ODk0Ny43NC4xLjE3NDUyODg5ODAuMC4wLjA.',
              clientServiceName: 'NOA・JAPAN'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData)

          } else if (isNineearth_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/nineearth_1_yagish_logo.png',
              clientId: 'nineearth_mail',
              dialogName: 'nineearth-dialog',
              clientName: '株式会社N.E',
              termurl: 'https://nine-earth.co.jp/kaigo_s2/terms.html',
              privacyurl: 'https://nine-earth.co.jp/kaigo_s2/privacy.html',
              clientServiceName: '介護ナイン'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)

          } else if (isNineearth_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/nineearth_2_yagish_logo.png',
              clientId: 'nineearth_mail',
              dialogName: 'nineearth-dialog',
              clientName: '株式会社N.E',
              termurl: 'https://nine-earth.co.jp/kaigo_s2/terms.html',
              privacyurl: 'https://nine-earth.co.jp/kaigo_s2/privacy.html',
              clientServiceName: '介護ナイン'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData)

          } else if (isAxes_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/axes_1_yagish_logo.jpg',
              clientId: 'axes_mail',
              dialogName: 'axes-dialog',
              clientName: '株式会社axes',
              termurl: 'https://axes.jobs/terms-of-use/',
              privacyurl: 'https://axes.jobs/privacy-policy/',
              clientServiceName: 'アクキャリ介護'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)

          } else if (isStarlabo_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/starlabo_1_yagish_logo_20250406.png',
              clientId: 'starlabo_mail',
              dialogName: 'starlabo-dialog',
              clientName: '株式会社スターラボ',
              termurl: 'https://search.eir-agent.jp/terms',
              privacyurl: 'https://search.eir-agent.jp/privacy',
              clientServiceName: '看護師転職支援サービスEIR(エイル)'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)

          } else if (isSupernurse_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/supernurse_1_yagish_logo.png',
              clientId: 'supernurse_mail',
              dialogName: 'supernurse-dialog',
              clientName: '株式会社スーパーナース',
              termurl: 'https://www.supernurse.co.jp/cms/wp-content/uploads/2025/07/スーパーナース利用規約.pdf',
              privacyurl: 'https://www.supernurse.co.jp/privacy/',
              clientServiceName: 'スーパーナース'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)

          } else if (isStarlabo_2 && formatId.includes('shokumukeirekisho')) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/starlabo_2_yagish_logo_20250406.png',
              clientId: 'starlabo_mail',
              dialogName: 'starlabo-dialog',
              clientName: '株式会社スターラボ',
              termurl: 'https://scout.star-labo.co.jp/terms',
              privacyurl: 'https://scout.star-labo.co.jp/policy/',
              clientServiceName: 'スターラボ'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData)

          } else if (isRecree_2 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-recree-dialog', formatId, previewFormat, 2, basicData)
          } else if (isRecree_3 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-recree-dialog', formatId, previewFormat, 3, basicData)
          } else if (isRecree_4 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-recree-dialog', formatId, previewFormat, 4, basicData)
          } else if (isSms_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {


            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/sms_1_yagish_logo_20250115.jpg',
              clientId: 'sms_admin',
              dialogName: 'sms-dialog',
              clientName: 'カイゴジョブエージェント',
              termurl: 'https://www.kaigoagent.com/contents/tos.html',
              privacyurl: 'https://www.kaigoagent.com/contents/pmark.html',
              clientServiceName: 'キャリア支援サービス',
              subArea1: '介護の求人・転職ならカイゴジョブエージェント<br>電話にて非公開求人をご紹介します！'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)
          } else if (isSms_3 && this.isJobChangeShokumukeirekiFormat(formatId)) {



            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/sms_3_yagish_logo_20250205.png',
              clientId: 'sms_admin_hoiku',
              dialogName: 'sms-dialog',
              clientName: '株式会社エス･エム･エス',
              termurl: 'https://hoiku.jinzaibank.com/contents/tos.html',
              privacyurl: 'https://policy.bm-sms.co.jp/consumer/privacy/policy',
              clientServiceName: 'キャリア支援サービス'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 3, dialogInfo, basicData)

          } else if (isPeacekaigo_4 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-peacekaigo-dialog', formatId, previewFormat, 4, basicData)
          } else if (isPeacekaigo_5 && (formatId == "rerekisho_part_time" ||
            formatId == "rirekisho_part_time2")) {
            this.$eventHub.$emit('open-peacekaigo-dialog', formatId, previewFormat, 5)
          } else if (isJhr_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {

            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/jhr_1_yagish_logo.jpg',
              clientId: 'jhr_mail',
              dialogName: 'jhr-dialog',
              clientName: 'JHR株式会社',
              termurl: 'https://drive.google.com/file/d/1BehbiQGs7Nf5sns3hQRt5btf4DRHQTB7/view?usp=drive_link',
              privacyurl: 'https://j-h-r.com/privacy/',
              clientServiceName: 'JHR株式会社'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData)

          } else if (isJhr_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {

            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/jhr_1_yagish_logo.jpg',
              clientId: 'jhr_mail',
              dialogName: 'jhr-dialog',
              clientName: 'JHR株式会社',
              termurl: 'https://drive.google.com/file/d/1BehbiQGs7Nf5sns3hQRt5btf4DRHQTB7/view?usp=drive_link',
              privacyurl: 'https://j-h-r.com/privacy/',
              clientServiceName: 'JHR株式会社'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)

          } else if (isRecruitMc1 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-recruit_mc-dialog', formatId, previewFormat, 1)
          } else if (isPharmacareer_1 && (formatId == "rerekisho_part_time" || formatId == "rirekisho_part_time2" ||
            formatId.includes('shokumukeirekisho'))) {
            this.$eventHub.$emit('open-pharmacareer-dialog', formatId, previewFormat, 1, basicData)
          } else if (isHuemaridge_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {

            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/huemaridge_1_yagish_logo.png',
              clientId: 'huemaridge_mail',
              dialogName: 'huemaridge-dialog',
              clientName: '株式会社ヒューマリッジ',
              termurl: 'https://drive.google.com/file/d/14WkOz9-7YyvDWuYE2rYyhbyVdiUCPt3x/view?usp=drive_link',
              privacyurl: 'https://www.huemaridge.co.jp/privacy/',
              clientServiceName: '株式会社ヒューマリッジ'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)

          } else if (isMedley_Link_5 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-medley-dialog', formatId, previewFormat, 0, 5)
          } else if (isMedley_Link_6 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-medley-dialog', formatId, previewFormat, 0, 6)
          } else if (isMedley_Link_7 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-medley-dialog', formatId, previewFormat, 0, 7)
          } else if (isMedley_Link_9 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-medley-dialog', formatId, previewFormat, 0, 9)
          } else if (isMedley_Link_10 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-medley-dialog', formatId, previewFormat, 0, 10)
          } else if (isMedley_Link_8 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-medley-dialog', formatId, previewFormat, 0, 8)
          } else if (isAsiro_1 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-asiro-dialog', formatId, previewFormat, 1)
          } else if (isAsiro_2 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-asiro-dialog', formatId, previewFormat, 2)
          } else if (isAsiro_3 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-asiro-dialog', formatId, previewFormat, 3)
          } else if (isAsiro_4 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-asiro-dialog', formatId, previewFormat, 4)
          } else if (isAsiro_5 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-asiro-dialog', formatId, previewFormat, 5)
          } else if (isAsiro_6 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-asiro-dialog', formatId, previewFormat, 6)
          } else if (isSystemShared5 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-systemshared-dialog', formatId, previewFormat, 5)
          } else if (isSystemShared8 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-systemshared-dialog', formatId, previewFormat, 8)
          } else if (isSystemShared9 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-systemshared-dialog', formatId, previewFormat, 9)
          } else if (isSystemShared6 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-systemshared-dialog', formatId, previewFormat, 6)
          } else if (isSystemShared10 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-systemshared-dialog', formatId, previewFormat, 10)
          } else if (isBridge_1 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-bridge-dialog', formatId, previewFormat, 1)
          } else if (isTunaguba_1 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-tunaguba-dialog', formatId, previewFormat, 1)
          } else if (isDely_1 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-dely-dialog', formatId, previewFormat, 1)
          } else if (isXmile_1 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-xmile-dialog', formatId, previewFormat, 1)
          } else if (isXmile_2 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-xmile-dialog', formatId, previewFormat, 2)
          } else if (isXmile_3 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-xmile-dialog', formatId, previewFormat, 3)
          } else if (isXmile_4 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-xmile-dialog', formatId, previewFormat, 4)
          } else if (isAgrinavi_1 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-agrinavi-dialog', formatId, previewFormat, 1)
          } else if (isRecree_1 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-recree-dialog', formatId, previewFormat, 1)
          } else if (isRecree_5 && this.isJobChangeFormat(formatId)) {

            this.$eventHub.$emit('open-recree-dialog', formatId, previewFormat, 5, basicData)
          } else if (isXmile_6 && this.isJobChangeShokumukeirekiFormat(formatId)) {

            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/xmile_6_yagish_logo.png',
              clientId: 'xmile_mail',
              dialogName: 'xmile-dialog',
              clientName: 'X Mile株式会社',
              termurl: 'https://www.xmile.co.jp/policy/08',
              privacyurl: 'https://www.xmile.co.jp/policy/06',
              clientServiceName: 'クロスワーク'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 6, dialogInfo, basicData)
          } else if (isXmile_7 && this.isJobChangeShokumukeirekiFormat(formatId)) {

            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/xmile_7_yagish_logo.png',
              clientId: 'xmile_mail',
              dialogName: 'xmile-dialog',
              clientName: 'X Mile株式会社',
              termurl: 'https://www.xmile.co.jp/policy/08',
              privacyurl: 'https://www.xmile.co.jp/policy/06',
              clientServiceName: 'クロスワーク'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 7, dialogInfo, basicData)
          } else if (isXmile_8 && this.isJobChangeShokumukeirekiFormat(formatId)) {

            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/xmile_8_yagish_logo.png',
              clientId: 'xmile_mail',
              dialogName: 'xmile-dialog',
              clientName: 'X Mile株式会社',
              termurl: 'https://www.xmile.co.jp/policy/08',
              privacyurl: 'https://www.xmile.co.jp/policy/06',
              clientServiceName: 'クロスワーク'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 8, dialogInfo, basicData)
          } else if (isXmile_9 && this.isJobChangeShokumukeirekiFormat(formatId)) {

            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/xmile_9_yagish_logo.png',
              clientId: 'xmile_mail',
              dialogName: 'xmile-dialog',
              clientName: 'X Mile株式会社',
              termurl: 'https://www.xmile.co.jp/policy/08',
              privacyurl: 'https://www.xmile.co.jp/policy/06',
              clientServiceName: 'クロスワーク'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 9, dialogInfo, basicData)
          } else if (isXmile_10 && this.isJobChangeShokumukeirekiFormat(formatId)) {

            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/xmile_10_yagish_logo.png',
              clientId: 'xmile_mail',
              dialogName: 'xmile-dialog',
              clientName: 'X Mile株式会社',
              termurl: 'https://www.xmile.co.jp/policy/08',
              privacyurl: 'https://www.xmile.co.jp/policy/06',
              clientServiceName: 'クロスワーク'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 10, dialogInfo, basicData)
          } else if (isXmile_11 && this.isJobChangeShokumukeirekiFormat(formatId)) {

            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/xmile_11_yagish_logo.png',
              clientId: 'xmile_mail',
              dialogName: 'xmile-dialog',
              clientName: 'X Mile株式会社',
              termurl: 'https://www.xmile.co.jp/policy/08',
              privacyurl: 'https://www.xmile.co.jp/policy/06',
              clientServiceName: 'クロスワーク'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 11, dialogInfo, basicData)
          } else if (isXmile_12 && this.isJobChangeShokumukeirekiFormat(formatId)) {

            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/xmile_12_yagish_logo.png',
              clientId: 'xmile_mail',
              dialogName: 'xmile-dialog',
              clientName: 'X Mile株式会社',
              termurl: 'https://www.xmile.co.jp/policy/08',
              privacyurl: 'https://www.xmile.co.jp/policy/06',
              clientServiceName: 'クロスワーク'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 12, dialogInfo, basicData)
          } else if (isXmile_13 && this.isJobChangeShokumukeirekiFormat(formatId)) {

            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/xmile_13_yagish_logo.png',
              clientId: 'xmile_mail',
              dialogName: 'xmile-dialog',
              clientName: 'X Mile株式会社',
              termurl: 'https://www.xmile.co.jp/policy/08',
              privacyurl: 'https://www.xmile.co.jp/policy/06',
              clientServiceName: 'クロスワーク'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 13, dialogInfo, basicData)
          } else if (isXmile_14 && this.isJobChangeShokumukeirekiFormat(formatId)) {

            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/xmile_14_yagish_logo.png',
              clientId: 'xmile_mail',
              dialogName: 'xmile-dialog',
              clientName: 'X Mile株式会社',
              termurl: 'https://www.xmile.co.jp/policy/08',
              privacyurl: 'https://www.xmile.co.jp/policy/06',
              clientServiceName: 'クロスワーク'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 14, dialogInfo, basicData)
          } else if (isXmile_15 && this.isJobChangeShokumukeirekiFormat(formatId)) {

            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/xmile_15_yagish_logo.png',
              clientId: 'xmile_mail',
              dialogName: 'xmile-dialog',
              clientName: 'X Mile株式会社',
              termurl: 'https://www.xmile.co.jp/policy/08',
              privacyurl: 'https://www.xmile.co.jp/policy/06',
              clientServiceName: 'クロスワーク'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 15, dialogInfo, basicData)
          } else if (isXmile_16 && this.isJobChangeShokumukeirekiFormat(formatId)) {

            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/xmile_16_yagish_logo.png',
              clientId: 'xmile_mail',
              dialogName: 'xmile-dialog',
              clientName: 'X Mile株式会社',
              termurl: 'https://www.xmile.co.jp/policy/08',
              privacyurl: 'https://www.xmile.co.jp/policy/06',
              clientServiceName: 'クロスワーク'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 16, dialogInfo, basicData)
          } else if (isXmile_17 && this.isJobChangeShokumukeirekiFormat(formatId)) {

            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/xmile_17_yagish_logo.png',
              clientId: 'xmile_mail',
              dialogName: 'xmile-dialog',
              clientName: 'X Mile株式会社',
              termurl: 'https://www.xmile.co.jp/policy/08',
              privacyurl: 'https://www.xmile.co.jp/policy/06',
              clientServiceName: 'クロスワーク'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 17, dialogInfo, basicData)
          } else if (isXmile_18 && this.isJobChangeShokumukeirekiFormat(formatId)) {

            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/xmile_18_yagish_logo.png',
              clientId: 'xmile_mail',
              dialogName: 'xmile-dialog',
              clientName: 'X Mile株式会社',
              termurl: 'https://www.xmile.co.jp/policy/08',
              privacyurl: 'https://www.xmile.co.jp/policy/06',
              clientServiceName: 'クロスワーク'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 18, dialogInfo, basicData)
          } else if (isOutsourcing_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {

            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/outsourcing_yagish_logo_20250414.jpg',
              clientId: 'outsourcing_mail',
              dialogName: 'outsourcing-dialog',
              clientName: '株式会社アウトソーシング',
              termurl: 'https://www.894651.com/guide/terms-of-use-for-user/',
              privacyurl: 'https://www.outsourcing.co.jp/privacy/01',
              clientServiceName: 'はたらくヨロコビ'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)
          } else if (isHitolabo_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {

            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/hitolabo_1_yagish_logo.png',
              clientId: 'hitolabo_mail',
              dialogName: 'hitolabo-dialog',
              clientName: 'ヒトラボエージェント株式会社',
              termurl: 'https://hitolabo-agent.com/%E5%88%A9%E7%94%A8%E8%A6%8F%E7%B4%84/',
              privacyurl: 'https://hitolabo-agent.com/privacy-policy/',
              clientServiceName: '調理師・栄養士のおしごとらぼ'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)
          } else if (isHitolabo_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {

            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/hitolabo_2_yagish_logo.png',
              clientId: 'hitolabo_mail',
              dialogName: 'hitolabo-dialog',
              clientName: 'ヒトラボエージェント株式会社',
              termurl: 'https://hitolabo-agent.com/%E5%88%A9%E7%94%A8%E8%A6%8F%E7%B4%84/',
              privacyurl: 'https://hitolabo-agent.com/privacy-policy/',
              clientServiceName: '調理師・栄養士のおしごとらぼ'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData)
          } else if (isCookbiz_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {

            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/cookbiz_1_yagish_logo.png',
              clientId: 'cookbiz_mail',
              dialogName: 'cookbiz-dialog',
              clientName: 'クックビズ株式会社',
              termurl: 'https://cookbiz.co.jp/terms',
              privacyurl: 'https://corp.cookbiz.co.jp/privacy-policy/',
              clientServiceName: 'localook',
              link: 'https://liff.line.me/2006706940-XWrw0jwQ/landing?follow=%40639witoy&lp=leMW2G&liff_id=2006706940-XWrw0jwQ',
              text_1: 'LINEから人気の飲食関連のお仕事を紹介します！',
              text_2: 'LINEで友だち追加された方だけの「限定求人」をお届け！<br class="sp">友だち追加後のメッセージをご確認ください！',
              agree_text: '規約に同意して仕事の紹介を希望する',
              btn_text: 'LINEで友だちになる',
              etc_text: '※給与アップは、（個人の経験、スキル、希望条件、企業の状況により変動します。）全ての方に保証されるものではありません。'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)
          } else if (isCookbiz_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {

            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/cookbiz_2_yagish_logo.jpg',
              clientId: 'cookbiz_mail',
              dialogName: 'cookbiz-dialog',
              clientName: 'クックビズ株式会社',
              termurl: 'https://cookbiz.co.jp/terms',
              privacyurl: 'https://corp.cookbiz.co.jp/privacy-policy/',
              clientServiceName: 'cookbiz',
              link: 'https://liff.line.me/2006706940-XWrw0jwQ/landing?follow=%40639witoy&lp=nFe2b1&liff_id=2006706940-XWrw0jwQ'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData)
          } else if (isCookbiz_3 && (formatId == "rerekisho_part_time" ||
            formatId == "rirekisho_part_time2")) {

            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/cookbiz_3_yagish_logo.jpg',
              clientId: 'cookbiz_mail',
              dialogName: 'cookbiz-dialog',
              clientName: 'クックビズ株式会社',
              termurl: 'https://cookbiz.co.jp/terms',
              privacyurl: 'https://corp.cookbiz.co.jp/privacy-policy/',
              clientServiceName: 'cookbiz',
              link: 'https://liff.line.me/2006706940-XWrw0jwQ/landing?follow=%40639witoy&lp=rkmnx1&liff_id=2006706940-XWrw0jwQ'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 3, dialogInfo, basicData)
          } else if (isFoodison_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {

            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/foodison_1_yagish_logo.png',
              clientId: 'foodison_mail',
              dialogName: 'foodison-dialog',
              clientName: '株式会社フーディソン',
              termurl: 'https://foodjinzaibank.jp/terms',
              privacyurl: 'https://docs.google.com/document/d/e/2PACX-1vRVeKM7rPsERCKlZNLz_UBKI1-nSsv0LhP36-LtSVxx8BmTKNN1IS3Tn4pwc1hnE7Ql7x__GEvFH1JX/pub',
              clientServiceName: 'フード人材バンク'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)
          } else if (isFoodison_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {

            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/foodison_2_yagish_logo.png',
              clientId: 'foodison_mail',
              dialogName: 'foodison-dialog',
              clientName: '株式会社フーディソン',
              termurl: 'https://foodjinzaibank.jp/terms',
              privacyurl: 'https://docs.google.com/document/d/e/2PACX-1vRVeKM7rPsERCKlZNLz_UBKI1-nSsv0LhP36-LtSVxx8BmTKNN1IS3Tn4pwc1hnE7Ql7x__GEvFH1JX/pub',
              clientServiceName: 'フード人材バンク'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData)
          } else if (isFoodison_3 && this.isJobChangeShokumukeirekiFormat(formatId)) {

            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/foodison_3_yagish_logo.png',
              clientId: 'foodison_mail',
              dialogName: 'foodison-dialog',
              clientName: '株式会社フーディソン',
              termurl: 'https://foodjinzaibank.jp/terms',
              privacyurl: 'https://docs.google.com/document/d/e/2PACX-1vRVeKM7rPsERCKlZNLz_UBKI1-nSsv0LhP36-LtSVxx8BmTKNN1IS3Tn4pwc1hnE7Ql7x__GEvFH1JX/pub',
              clientServiceName: 'フード人材バンク'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 3, dialogInfo, basicData)

          } else if (isOishiru_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/oishiru_1_yagish_logo.png',
              clientId: 'oishiru_mail',
              dialogName: 'oishiru-dialog',
              clientName: '株式会社オイシル',
              termurl: 'https://oishiru-career.jp/lp/service_policy.html',
              privacyurl: 'https://oishiru-career.jp/lp/privacy_policy.html',
              clientServiceName: 'オイシルキャリア'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)

          } else if (isHayfield_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {

            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/hayfield_1_yagish_logo.png',
              clientId: 'hayfield_mail',
              dialogName: 'hayfield-dialog',
              clientName: '株式会社ヘイフィールド',
              termurl: 'https://hayfield.jp/terms/',
              privacyurl: 'https://hayfield.jp/privacy/',
              clientServiceName: '宅建Jobエージェント'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)

          } else if (isItk_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/itk_1_yagish_logo.jpg',
              clientId: 'itk_mail',
              dialogName: 'itk-dialog',
              clientName: '株式会社itk',
              termurl: 'https://i-t-k.co.jp/rules',
              privacyurl: 'https://i-t-k.co.jp/privacy',
              clientServiceName: '飲食専門エージェント'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)

          } else if (isPrimalwork_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {

            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/primalwork_yagish_logo_20250326.jpg',
              clientId: 'primalwork_mail',
              dialogName: 'primalwork-dialog',
              clientName: '株式会社プライマルワーク',
              termurl: 'https://primalwork.net/terms-of-service/',
              privacyurl: 'https://primalwork.net/privacy-policy/',
              clientServiceName: 'プライマルワーク'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)
          } else if (isTalentnavi_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {

            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/talentnavi_1_yagish_logo.png',
              clientId: 'talentnavi_mail',
              dialogName: 'talentnavi-dialog',
              clientName: '株式会社タレントナビゲーター',
              termurl: 'https://talent-navi.jp/terms',
              privacyurl: 'https://talent-navi.jp/privacy',
              clientServiceName: 'タレントナビゲーター'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)
          } else if (isAzurite_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {

            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/azurite_1_yagish_logo.png',
              clientId: 'azurite_mail',
              dialogName: 'azurite-dialog',
              clientName: '株式会社アズライト',
              termurl: 'https://azu-rite.co.jp/terms',
              privacyurl: 'https://azu-rite.co.jp/privacy_policy',
              clientServiceName: 'アズライト'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)
          } else if (isAzurite_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {

            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/azurite_2_yagish_logo.png',
              clientId: 'azurite_mail',
              dialogName: 'azurite-dialog',
              clientName: '株式会社アズライト',
              termurl: 'https://azu-rite.co.jp/privacy_policy',
              privacyurl: 'https://azu-rite.co.jp/privacy_policy',
              clientServiceName: 'アズライト'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData)
          } else if (is400F_1 && this.isJobChangeFormat(formatId)) {

            const dialogInfo = {
              logoImage: '/static/renew3_img/rt/400f_yagish_logo_20241212.png',
              clientId: '400f_mail',
              dialogName: '400f-dialog',
              clientName: '株式会社400F',
              termurl: 'https://lpd.okane-kenko.jp/tenshoku/docs/terms.pdf',
              privacyurl: 'https://okane-kenko.jp/policies/privacy',
              clientServiceName: 'オカネコ転職'
            }
            this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)
          } else if (isTechouse_1 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-techouse-dialog', formatId, previewFormat, 1)
          } else if (isTechouse_2 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-techouse-dialog', formatId, previewFormat, 2)
          } else if (isTechouse_3 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-techouse-dialog', formatId, previewFormat, 3)
          } else if (isRoxx2 && this.isJobChangeShokumukeirekiFormat(formatId)) {
            this.$eventHub.$emit('open-roxx-dialog', formatId, previewFormat, basicData.email, 2, '', basicData)
          } else if (isRoxx && this.isJobChangeShokumukeirekiFormat(formatId)) {
            this.$eventHub.$emit('open-roxx-dialog', formatId, previewFormat, basicData.email, 1, '', basicData)
          } else if (isUsenworking_1 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-usenworking-dialog', formatId, previewFormat, 1)
          } else if (isUsenworking_2 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-usenworking-dialog', formatId, previewFormat, 2)
          } else if (isUsenworking_3 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-usenworking-dialog', formatId, previewFormat, 3)
          } else if (isUsenworking_4 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-usenworking-dialog', formatId, previewFormat, 4)
          } else if (isArowtrail_1 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-growtrail-dialog', formatId, previewFormat, 1)
          } else if (isArowtrail_2 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-growtrail-dialog', formatId, previewFormat, 2)
          } else if (isArowtrail_3 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-growtrail-dialog', formatId, previewFormat, 3)
          } else if (isRecruitMc2 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-recruit_mc-dialog', formatId, previewFormat, 2)
          } else if (isKirara && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-kirara-dialog', formatId, previewFormat)
          } else if (isSimple1 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-simple-dialog', formatId, previewFormat, 1)
          } else if (isSimple2 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-simple-dialog', formatId, previewFormat, 2)
          } else if (isSimple3 && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-simple-dialog', formatId, previewFormat, 3)
          } else if (isBaton && this.isJobChangeFormat(formatId)) {
            this.$eventHub.$emit('open-baton-dialog', formatId, previewFormat, 1)
          } else if (isJaic1) {
            this.$eventHub.$emit('open-jaic-dialog', formatId, previewFormat, 1)
          } else if (isJaic2) {
            this.$eventHub.$emit('open-jaic-dialog', formatId, previewFormat, 2)
          } else if (isJaic3) {
            this.$eventHub.$emit('open-jaic-dialog', formatId, previewFormat, 3)
          } else {
            if (isJob919_4 && (formatId == "rirekisho_job_change" || formatId == "rirekisho_ai_career" ||
              formatId == "rirekisho_job_change2" ||
              formatId == "rirekisho_job_change_old" ||
              formatId == "rirekisho_single" ||
              formatId == "rirekisho_nophoto_double" ||
              formatId == "rirekisho_nophoto")) {
              this.$eventHub.$emit('open-jobs919-dialog', formatId, previewFormat, 4)
            } else if (isBaton2 && (formatId == "rirekisho_job_change" || formatId == "rirekisho_ai_career" ||
              formatId == "rirekisho_job_change2" ||
              formatId == "rirekisho_job_change_old" ||
              formatId == "rirekisho_single" ||
              formatId == "rirekisho_nophoto_double" ||
              formatId == "rirekisho_nophoto")) {
              this.$eventHub.$emit('open-baton-dialog', formatId, previewFormat, 2)
            } else if (isSystemShared && (formatId == "rirekisho_job_change" || formatId == "rirekisho_ai_career" ||
              formatId == "rirekisho_job_change2" ||
              formatId == "rirekisho_job_change_old" ||
              formatId == "rirekisho_single" ||
              formatId == "rirekisho_nophoto_double" ||
              formatId == "rirekisho_nophoto")) {
              this.$eventHub.$emit('open-systemshared-dialog', formatId, previewFormat, 1)
            } else if (isSystemShared2 && (formatId == "rirekisho_job_change" || formatId == "rirekisho_ai_career" ||
              formatId == "rirekisho_job_change2" ||
              formatId == "rirekisho_job_change_old" ||
              formatId == "rirekisho_single" ||
              formatId == "rirekisho_nophoto_double" ||
              formatId == "rirekisho_nophoto")) {
              if (basicData.sex == 1) {
                this.$eventHub.$emit('open-systemshared-dialog', formatId, previewFormat, 2)
              } else {
                this.$eventHub.$emit('open-systemshared-dialog', formatId, previewFormat, 3)
              }
            } else if (isSystemShared3 && (formatId == "rirekisho_job_new" ||
              formatId == "rirekisho_job_new_single" ||
              formatId == "entrysheet")) {
              if (basicData.sex == 1) {
                this.$eventHub.$emit('open-systemshared-dialog', formatId, previewFormat, 2)
              } else {
                this.$eventHub.$emit('open-systemshared-dialog', formatId, previewFormat, 3)
              }
            } else if (isAdtop && (formatId == "rirekisho_job_change" || formatId == "rirekisho_ai_career" ||
              formatId == "rirekisho_job_change2" ||
              formatId == "rirekisho_job_change_old" ||
              formatId == "rirekisho_single" ||
              formatId == "rirekisho_nophoto_double" ||
              formatId == "rirekisho_nophoto")) {
              this.$eventHub.$emit('open-adtop-dialog', formatId, previewFormat)
            } else if (isMynaviMs && (formatId == "rirekisho_job_change" || formatId == "rirekisho_ai_career" ||
              formatId == "rirekisho_job_change2" ||
              formatId == "rirekisho_job_change_old" ||
              formatId == "rirekisho_single" ||
              formatId == "rirekisho_nophoto_double" ||
              formatId == "rirekisho_nophoto")) {
              this.$eventHub.$emit('open-mynavi-ms-dialog', formatId, previewFormat)
            } else if (isJigen && (formatId == "rirekisho_job_change" || formatId == "rirekisho_ai_career" ||
              formatId == "rirekisho_job_change2" ||
              formatId == "rirekisho_job_change_old" ||
              formatId == "rirekisho_single" ||
              formatId == "rirekisho_nophoto_double" ||
              formatId == "rirekisho_nophoto")) {
              this.$eventHub.$emit('open-jigen-dialog', formatId, previewFormat, 2)
            } else if ((isMedley1 || isMedley2 || isMedley3 || isMedley4 || isMedley5 || isMedley6 || isMedley7 || isMedley8 || isMedley9 || isMedley10)
              && !(formatId == "rirekisho_job_new" || formatId == "rirekisho_job_new_single" || formatId == "internship" || formatId == "entrysheet")) {
              this.$eventHub.$emit('open-medley-dialog', formatId, previewFormat, medleyID, 0)
            } else if (isMiraiyu_3 && (formatId == "rirekisho_job_change" || formatId == "rirekisho_ai_career" ||
              formatId == "rirekisho_job_change2" ||
              formatId == "rirekisho_job_change_old" ||
              formatId == "rirekisho_single" ||
              formatId == "rirekisho_nophoto_double" ||
              formatId == "rirekisho_nophoto")) {
              this.$eventHub.$emit('open-miraiyu-dialog', formatId, previewFormat, 3)
            } else if (isMiraiyu_4 && (formatId == "rirekisho_job_change" || formatId == "rirekisho_ai_career" ||
              formatId == "rirekisho_job_change2" ||
              formatId == "rirekisho_job_change_old" ||
              formatId == "rirekisho_single" ||
              formatId == "rirekisho_nophoto_double" ||
              formatId == "rirekisho_nophoto")) {
              this.$eventHub.$emit('open-miraiyu-dialog', formatId, previewFormat, 4)
            } else if (isMynavi_1 && (formatId == "rerekisho_part_time" ||
              formatId == "rirekisho_part_time2")) {
              this.$eventHub.$emit('open-mynavi-dialog', formatId, previewFormat, 1)
            } else if (isRoxx3 && (formatId == "rirekisho_job_new" ||
              formatId == "rirekisho_job_new_single" ||
              formatId == "entrysheet")) {
              this.$eventHub.$emit('open-roxx-dialog', formatId, previewFormat, basicData.email, 3, formatData.gradeYear)
            } else if (isBriedge_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/briedge_1_yagish_logo.png',
                clientId: 'briedge_mail',
                dialogName: 'briedge-dialog',
                clientName: 'ブライエッジ株式会社',
                termurl: 'https://drive.google.com/file/d/1pn2C2hz7tBqz5Ql3tw0svnTWgvEYxE1d/view?usp=sharing',
                privacyurl: 'https://briedge.co.jp/privacypolicy/',
                clientServiceName: 'ブライエッジ株式会社',
                // text_1: 'プロが条件に合う転職エージェンをご紹介します！'
              }
              this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)
            } else if (isAwesome_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/awesome_1_yagish_logo.jpg',
                clientId: 'awesome_mail',
                dialogName: 'awesome-dialog',
                clientName: 'AWESOME株式会社',
                termurl: 'https://drive.google.com/file/d/1FCX_wO1XMBeMOVoN4LLi-YI22ourIYr-/view?usp=drive_link',
                privacyurl: 'https://awesome0707.com/policy/',
                clientServiceName: 'AWESOME株式会社',
                // text_1: 'プロが条件に合う転職エージェンをご紹介します！'
              }
              this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)
            } else if (isCloudlink_3 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/cloudlink_3_yagish_logo.png',
                clientId: 'cloudlink_mail',
                dialogName: 'cloudlink-dialog',
                clientName: '株式会社Cloud Link',
                termurl: 'https://cloud-link.co.jp/terms-of-service/',
                privacyurl: 'https://cloud-link.co.jp/privacy-policy/',
                clientServiceName: 'Cloud Link',
                setTimeLink: 'https://cloud-link.eeasy.jp/shokai_mendan_pro'

              }
              this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 3, dialogInfo, basicData)

            } else if (isBearsnavi_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/bearsnavi_1_yagish_logo.png',
                clientId: 'bearsnavi_mail',
                dialogName: 'bearsnavi-dialog',
                clientName: 'ベアーズナビ株式会社',
                termurl: 'https://drive.google.com/file/d/1Frifaolfz0fnNECHBrtdDepYwHgyt9FC/view',
                privacyurl: 'https://bearsnavi.com/privacypolicy',
                clientServiceName: 'ベアーズナビ株式会社'
              }
              this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)

            } else if (isBearsnavi_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/bearsnavi_2_yagish_logo.png',
                clientId: 'bearsnavi_mail',
                dialogName: 'bearsnavi-dialog',
                clientName: 'ベアーズナビ株式会社',
                termurl: 'https://drive.google.com/file/d/1Frifaolfz0fnNECHBrtdDepYwHgyt9FC/view',
                privacyurl: 'https://bearsnavi.com/privacypolicy',
                clientServiceName: 'ベアーズナビ株式会社'
              }
              this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData)

            } else if (isBearsnavi_3 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/bearsnavi_3_yagish_logo.png',
                clientId: 'bearsnavi_mail',
                dialogName: 'bearsnavi-dialog',
                clientName: 'ベアーズナビ株式会社',
                termurl: 'https://drive.google.com/file/d/1Frifaolfz0fnNECHBrtdDepYwHgyt9FC/view',
                privacyurl: 'https://bearsnavi.com/privacypolicy',
                clientServiceName: 'ベアーズナビ株式会社'
              }
              this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 3, dialogInfo, basicData)

            } else if (isProlg_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/prolg_1_yagish_logo.png',
                clientId: 'prolg_mail',
                dialogName: 'prolg-dialog',
                clientName: '株式会社プロローグ',
                termurl: 'https://drive.google.com/file/d/1I-fDPZb3wstO4_t9wLTfxi8fxVsnZNVA/view?usp=drive_link',
                privacyurl: 'https://prolg-shoukai.com/privacy',
                clientServiceName: '株式会社プロローグ',
                // text_1: 'キャリア・年収UP'
              }
              this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)

            } else if (isProlg_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/prolg_2_yagish_logo.png',
                clientId: 'prolg_mail',
                dialogName: 'prolg-dialog',
                clientName: '株式会社プロローグ',
                termurl: 'https://drive.google.com/file/d/1I-fDPZb3wstO4_t9wLTfxi8fxVsnZNVA/view?usp=drive_link',
                privacyurl: 'https://prolg-shoukai.com/privacy',
                clientServiceName: '株式会社プロローグ',
                // text_1: 'キャリア・年収UP'

              }
              this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData)

            } else if (isSmartforce_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/smartforce_1_yagish_logo.jpg',
                clientId: 'smartforce_mail',
                dialogName: 'smartforce-dialog',
                clientName: '株式会社SmartForce',
                termurl: 'https://smartforce.jp/terms-of-service',
                privacyurl: 'https://smartforce.jp/privacy-policy',
                clientServiceName: 'SmartForce'
              }
              this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)

            } else if (isKiminara_1 && this.isJobChangeFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/kiminara_1_yagish_logo.png',
                clientId: 'kiminara_mail',
                dialogName: 'kiminara-dialog',
                clientName: '株式会社キミナラ',
                termurl: 'https://kiminara.net/policy.php',
                privacyurl: 'https://kiminara.net/policy.php',
                clientServiceName: 'キャリアアドバイザー紹介サービス',
                text_1: 'プロが条件に合う転職エージェントをご紹介します！'
              }
              this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)
            } else if (isKiminara_2 && this.isJobChangeFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/kiminara_2_yagish_logo.png',
                clientId: 'kiminara_mail',
                dialogName: 'kiminara-dialog',
                clientName: '株式会社キミナラ',
                termurl: 'https://kiminara.net/policy.php',
                privacyurl: 'https://kiminara.net/policy.php',
                clientServiceName: 'キャリアアドバイザー紹介サービス',
                text_1: 'プロが条件に合う転職エージェントをご紹介します！'
              }
              this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData)
            } else if (isWorkport_4 && (formatId.includes('shokumukeirekisho'))) {
              this.$eventHub.$emit('open-workport-dialog', formatId, previewFormat, 4, basicData)
            } else if (isWorkport_1 && (formatId.includes('shokumukeirekisho'))) {
              this.$eventHub.$emit('open-workport-dialog', formatId, previewFormat, 1, basicData)
            } else if (isWorkport_2 && (formatId.includes('shokumukeirekisho'))) {
              this.$eventHub.$emit('open-workport-dialog', formatId, previewFormat, 2, basicData)
            } else if (isWorkport_3 && (formatId.includes('shokumukeirekisho'))) {
              this.$eventHub.$emit('open-workport-dialog', formatId, previewFormat, 3, basicData)
            } else if (isRoxx_5 && this.isJobChangeFormat(formatId)) {
              this.$eventHub.$emit('open-roxx-dialog', formatId, previewFormat, basicData.email, 5, formatData.gradeYear)
            } else if (isRoxx_4 && (formatId == "rirekisho_job_new" ||
              formatId == "rirekisho_job_new_single" ||
              formatId == "entrysheet")) {
              this.$eventHub.$emit('open-roxx-dialog', formatId, previewFormat, basicData.email, 4, formatData.gradeYear)
            } else if (isRecrea_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/recrea_1_yagish_logo.png',
                clientId: 'recrea_mail',
                dialogName: 'recrea-dialog',
                clientName: '株式会社Recrea',
                termurl: '',
                privacyurl: '',
                clientServiceName: '株式会社Recrea'
              }
              this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)

            } else if (isPersolinnovation_3 && this.isJobChangeFormat(formatId)) {
              this.$eventHub.$emit('open-persolinnovation-dialog', formatId, previewFormat, 3, basicData)
            } else if (isDrtc_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/drtc_1_yagish_logo.png',
                clientId: 'drtc_mail',
                dialogName: 'drtc-dialog',
                clientName: '株式会社ドライバーテクノロジーズ',
                termurl: 'https://www.drtc.co.jp/terms',
                privacyurl: 'https://driver-direct.jp/personal/index.html',
                clientServiceName: 'ドライバーテクノロジーズ',
                // text_1: 'プロが条件に合う転職エージェンをご紹介します！'
              }
              this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)
            } else if (isNeocareerNew_1 && this.isJobChangeFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/neocareer_1_yagish_logo.jpg',
                clientId: 'neocareer_new_mail',
                dialogName: 'neocareer-dialog',
                clientName: '第二新卒Agent neo',
                termurl: 'https://www.daini-agent.jp/terms',
                privacyurl: 'https://www.daini-agent.jp/terms',
                clientServiceName: '第二新卒Agent neo'
              }
              this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)
            } else if ((formatId == "rirekisho_job_new" ||
              formatId == "rirekisho_job_new_single" ||
              formatId == "entrysheet" ||
              formatId == "internship") && isNeocareer_1) {
              this.$eventHub.$emit('open-neocareer-dialog', formatId, previewFormat, 1, formatData.gradeYear)
            } else if ((formatId == "rerekisho_part_time") && isNeocareer_2) {
              this.$eventHub.$emit('open-neocareer-dialog', formatId, previewFormat, 2, formatData.gradeYear)
            } else if ((formatId == "rirekisho_job_new" ||
              formatId == "rirekisho_job_new_single" ||
              formatId == "entrysheet" ||
              formatId == "internship") && isHitotechNeocareer_1) {
              this.$eventHub.$emit('open-hitotechneocareer-dialog', formatId, previewFormat, 1)
            } else if ((formatId == "rirekisho_job_new" ||
              formatId == "rirekisho_job_new_single" ||
              formatId == "entrysheet" ||
              formatId == "internship") && isHitotech_1) {
              this.$eventHub.$emit('open-hitotech-dialog', formatId, previewFormat, 1)
            } else if ((formatId == "rirekisho_job_new" ||
              formatId == "rirekisho_job_new_single" ||
              formatId == "entrysheet" ||
              formatId == "internship") && isHitotech_2) {
              this.$eventHub.$emit('open-hitotech-dialog', formatId, previewFormat, 2)
            } else if ((formatId == "rirekisho_job_new" ||
              formatId == "rirekisho_job_new_single" ||
              formatId == "entrysheet" ||
              formatId == "internship") && isHitotech_3) {
              this.$eventHub.$emit('open-hitotech-dialog', formatId, previewFormat, 3)
            } else if ((formatId == "rirekisho_job_new" ||
              formatId == "rirekisho_job_new_single" ||
              formatId == "entrysheet" ||
              formatId == "internship") && isHitotech_4) {
              this.$eventHub.$emit('open-hitotech-dialog', formatId, previewFormat, 4)
            } else if ((formatId == "rirekisho_job_new" ||
              formatId == "rirekisho_job_new_single" ||
              formatId == "entrysheet" ||
              formatId == "internship") && isCareerdraft_1) {
              this.$eventHub.$emit('open-careerdraft-dialog', formatId, previewFormat, 1, formatData.gradeYear)
            } else if ((formatId == "rirekisho_job_new" ||
              formatId == "rirekisho_job_new_single" ||
              formatId == "entrysheet" ||
              formatId == "internship") && isCareerdraft_2) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/careerdraft_2_yagish_logo.png',
                clientId: 'careerdraft_mail',
                dialogName: 'careerdraft-dialog',
                clientName: '絆ホールディングス(株)',
                termurl: 'https://d27rnpuamwvieu.cloudfront.net/pdf/0nvXg8Nheikk1vyMiwjjlMQXX.pdf',
                privacyurl: 'https://d27rnpuamwvieu.cloudfront.net/pdf/0J67ChgX0gawBQYVnQiXVSwXX.pdf',
                clientServiceName: 'キャリアドラフト'
              }
              this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData)
            } else if (isRoxx_7 && (formatId == "rerekisho_part_time" ||
              formatId == "rirekisho_part_time2")) {
              this.$eventHub.$emit('open-roxx-dialog', formatId, previewFormat, basicData.email, 7, formatData.gradeYear)
            } else if (isRoxx_6 && (formatId == "rirekisho_job_new" ||
              formatId == "rirekisho_job_new_single" ||
              formatId == "entrysheet")) {
              this.$eventHub.$emit('open-roxx-dialog', formatId, previewFormat, basicData.email, 6, formatData.gradeYear)
            } else if ((formatId == "rirekisho_job_new" ||
              formatId == "rirekisho_job_new_single" ||
              formatId == "entrysheet" ||
              formatId == "internship") && isCareerdraft_3) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/careerdraft_3_yagish_logo.png',
                clientId: 'careerdraft_mail',
                dialogName: 'careerdraft-dialog',
                clientName: '絆ホールディングス(株)',
                termurl: 'https://d27rnpuamwvieu.cloudfront.net/pdf/0nvXg8Nheikk1vyMiwjjlMQXX.pdf',
                privacyurl: 'https://d27rnpuamwvieu.cloudfront.net/pdf/0J67ChgX0gawBQYVnQiXVSwXX.pdf',
                clientServiceName: 'キャリアドラフト'
              }
              this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 3, dialogInfo, basicData)
            } else if ((formatId == "rirekisho_job_new" ||
              formatId == "rirekisho_job_new_single" ||
              formatId == "entrysheet") && isYagish_8) {
              this.$eventHub.$emit('open-yagish-dialog', formatId, previewFormat, 8)
            } else if (isTaikennyusha_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/taikennyusha_1_yagish_logo.png',
                clientId: 'taikennyusha_link',
                dialogName: 'taikennyusha-dialog',
                clientName: '株式会社体験入社',
                link: 'https://taikennyusha.com/ai?utm_source=yagish&utm_content=banner_a',
                clientServiceName: '体験入社',
                ptype: 'link'
              }
              this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)
            } else if (isTaikennyusha_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/taikennyusha_2_yagish_logo.png',
                clientId: 'taikennyusha_link',
                dialogName: 'taikennyusha-dialog',
                clientName: '株式会社体験入社',
                link: 'https://taikennyusha.com/ai?utm_source=yagish&utm_content=banner_b',
                clientServiceName: '体験入社',
                ptype: 'link'
              }
              this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData)
            } else if (isStrike_1 && this.isJobChangeFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/strike_1_yagish_logo.jpg',
                clientId: 'strike_mail',
                dialogName: 'strike-dialog',
                clientName: '女性が笑顔になれる株式会社',
                termurl: 'https://drive.google.com/file/d/1-5Svi4k7fJG-nMQ0pN6hJZBlnxdBR2ED/view',
                privacyurl: 'https://strike-t.jp/contact/privacy-policy/',
                clientServiceName: 'キャリアストライク',
                // text_1: 'プロが条件に合う転職エージェントをご紹介します！'
              }
              this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)
            } else if (isInternous_1 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/internous_1_yagish_logo.png',
                clientId: 'internous_link',
                dialogName: 'internous-dialog',
                clientName: 'インターノウス株式会社',
                link: 'https://programmercollege.jp/lp8-1?utm_source=yaggish&utm_medium=banner&utm_campaign=programmer_college_2025&utm_content=lp8-1',
                clientServiceName: 'programmer college',
                ptype: 'link'
              }
              this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 1, dialogInfo, basicData)
            } else if (isInternous_2 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/internous_2_yagish_logo.png',
                clientId: 'internous_link',
                dialogName: 'internous-dialog',
                clientName: 'インターノウス株式会社',
                link: 'https://programmercollege.jp/lp8-2?utm_source=yaggish&utm_medium=banner&utm_campaign=programmer_college_2025&utm_content=lp8-2',
                clientServiceName: 'programmer college',
                ptype: 'link'
              }
              this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 2, dialogInfo, basicData)
            } else if (isInternous_3 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/internous_3_yagish_logo.png',
                clientId: 'internous_link',
                dialogName: 'internous-dialog',
                clientName: 'インターノウス株式会社',
                link: 'https://programmercollege.jp/lp8-3?utm_source=yaggish&utm_medium=banner&utm_campaign=programmer_college_2025&utm_content=lp8-3',
                clientServiceName: 'programmer college',
                ptype: 'link'
              }
              this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 3, dialogInfo, basicData)
            } else if (isInternous_4 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/internous_4_yagish_logo.png',
                clientId: 'internous_link',
                dialogName: 'internous-dialog',
                clientName: 'インターノウス株式会社',
                link: 'https://programmercollege.jp/lp8-4?utm_source=yaggish&utm_medium=banner&utm_campaign=programmer_college_2025&utm_content=lp8-4',
                clientServiceName: 'programmer college',
                ptype: 'link'
              }
              this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 4, dialogInfo, basicData)
            } else if (isInternous_5 && this.isJobChangeShokumukeirekiFormat(formatId)) {
              const dialogInfo = {
                logoImage: '/static/renew3_img/rt/internous_5_yagish_logo.png',
                clientId: 'internous_link',
                dialogName: 'internous-dialog',
                clientName: 'インターノウス株式会社',
                link: 'https://programmercollege.jp/lp8-6/?utm_source=yaggish&utm_medium=banner&utm_campaign=programmer_college_2025&utm_content=lp8-6',
                clientServiceName: 'programmer college',
                ptype: 'link'
              }
              this.$eventHub.$emit('open-realtimetransfercommon-dialog', formatId, previewFormat, 5, dialogInfo, basicData)
            } else {
              this.$eventHub.$emit('open-carat-dialog', formatId, previewFormat, this.checkJoblistKeyword(formatId, formatData), this.getPrefJoblist(basicData), basicData.age, 1, null, null, basicData.address1)
            }
            // if (formatId == "shokumukeirekisho") {
            //   console.error(formatData)
            //   if (isYagishSaiyo2) {
            //     this.$eventHub.$emit('open-yagish-dialog', formatId, previewFormat, 6)
            //   } else if (isYagishSaiyo1) {
            //     this.$eventHub.$emit('open-yagish-dialog', formatId, previewFormat, 5)
            //   } else {
            //     this.$eventHub.$emit('open-carat-dialog', formatId, previewFormat, this.checkJoblistKeyword(formatId, formatData), this.getPrefJoblist(basicData), basicData.age, 1, null, null, basicData.address1)
            //   }
            // }
          }
        }
      }
    })
    Vue.prototype.$globalVar = main
  }
}
export default globalVar
